/* eslint-disable */
export const data_ecotrack_V2 = [
  {
    id: 1,
    code_postal: "01001",
    ok_postal_code: "1001",
    second_name: "Adrar",
    nom: "Adrar",
    wilaya_id: 1,
    commune_name: "أدرار",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 2,
    code_postal: "01002",
    ok_postal_code: "1002",
    second_name: "Tamest",
    nom: "Tamest",
    wilaya_id: 1,
    commune_name: "تامست",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 4,
    code_postal: "01004",
    ok_postal_code: "1004",
    second_name: "Reggane",
    nom: "Reggane",
    wilaya_id: 1,
    commune_name: "رقان",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-13 11:32:25",
  },
  {
    id: 5,
    code_postal: "01005",
    ok_postal_code: "1005",
    second_name: "In Zghmir",
    nom: "Inozghmir",
    wilaya_id: 1,
    commune_name: "إن زغمير",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 8,
    code_postal: "01008",
    ok_postal_code: "1008",
    second_name: "Tsabit",
    nom: "Tsabit",
    wilaya_id: 1,
    commune_name: "تسابيت",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 11,
    code_postal: "01011",
    ok_postal_code: "1011",
    second_name: "Zaouiet Kounta",
    nom: "Zaouiet Kounta",
    wilaya_id: 1,
    commune_name: "زاوية كنتة",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 12,
    code_postal: "01012",
    ok_postal_code: "1012",
    second_name: "Aoulef",
    nom: "Aoulef",
    wilaya_id: 1,
    commune_name: "أولف",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 13,
    code_postal: "01013",
    ok_postal_code: "1013",
    second_name: "Tamekten",
    nom: "Timokten",
    wilaya_id: 1,
    commune_name: "تيمقتن",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 14,
    code_postal: "01014",
    ok_postal_code: "1014",
    second_name: "Tamantit",
    nom: "Tamentit",
    wilaya_id: 1,
    commune_name: "تامنطيط",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 15,
    code_postal: "01015",
    ok_postal_code: "1015",
    second_name: null,
    nom: "Fenoughil",
    wilaya_id: 1,
    commune_name: "فنوغيل",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 18,
    code_postal: "01018",
    ok_postal_code: "1018",
    second_name: "Sali",
    nom: "Sali",
    wilaya_id: 1,
    commune_name: "سالي",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 19,
    code_postal: "01019",
    ok_postal_code: "1019",
    second_name: "Akabli",
    nom: "Akabli",
    wilaya_id: 1,
    commune_name: "اقبلي",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 21,
    code_postal: "01021",
    ok_postal_code: "1021",
    second_name: "Ouled Ahmed Tammi",
    nom: "O Ahmed Timmi",
    wilaya_id: 1,
    commune_name: "أولاد أحمد تيمي",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 22,
    code_postal: "01022",
    ok_postal_code: "1022",
    second_name: "Bouda",
    nom: "Bouda",
    wilaya_id: 1,
    commune_name: "بودة",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 15:50:26",
  },
  {
    id: 26,
    code_postal: "01026",
    ok_postal_code: "1026",
    second_name: "Sebaa",
    nom: "Sbaa",
    wilaya_id: 1,
    commune_name: "السبع",
    wilaya_name: "أدرار",
    hub_id: 22,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 29,
    code_postal: "02001",
    ok_postal_code: "2001",
    second_name: "Chlef",
    nom: "Chlef",
    wilaya_id: 2,
    commune_name: "الشلف",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 30,
    code_postal: "02002",
    ok_postal_code: "2002",
    second_name: "T\u00e9n\u00e8s",
    nom: "Tenes",
    wilaya_id: 2,
    commune_name: "تنس",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 31,
    code_postal: "02003",
    ok_postal_code: "2003",
    second_name: "B\u00e9nairia",
    nom: "Benairia",
    wilaya_id: 2,
    commune_name: "بنايرية",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 32,
    code_postal: "02004",
    ok_postal_code: "2004",
    second_name: "El Karimia",
    nom: "El Karimia",
    wilaya_id: 2,
    commune_name: "الكريمية",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 33,
    code_postal: "02005",
    ok_postal_code: "2005",
    second_name: "Tadjena",
    nom: "Tadjna",
    wilaya_id: 2,
    commune_name: "تاجنة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 34,
    code_postal: "02006",
    ok_postal_code: "2006",
    second_name: "Taougrite",
    nom: "Taougrite",
    wilaya_id: 2,
    commune_name: "تاوقريت",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 35,
    code_postal: "02007",
    ok_postal_code: "2007",
    second_name: "Beni Haoua",
    nom: "Beni Haoua",
    wilaya_id: 2,
    commune_name: "بني حواء",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 36,
    code_postal: "02008",
    ok_postal_code: "2008",
    second_name: "Sobha",
    nom: "Sobha",
    wilaya_id: 2,
    commune_name: "الصبحة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 37,
    code_postal: "02009",
    ok_postal_code: "2009",
    second_name: "Harchoun",
    nom: "Harchoun",
    wilaya_id: 2,
    commune_name: "حرشون",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 38,
    code_postal: "02010",
    ok_postal_code: "2010",
    second_name: "Ouled Fares",
    nom: "Ouled Fares",
    wilaya_id: 2,
    commune_name: "أولاد فارس",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 39,
    code_postal: "02011",
    ok_postal_code: "2011",
    second_name: "Sidi Akkacha",
    nom: "Sidi Akacha",
    wilaya_id: 2,
    commune_name: "سيدي عكاشة",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 40,
    code_postal: "02012",
    ok_postal_code: "2012",
    second_name: "Boukadir",
    nom: "Boukadir",
    wilaya_id: 2,
    commune_name: "بوقادير",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 41,
    code_postal: "02013",
    ok_postal_code: "2013",
    second_name: "Beni Rached",
    nom: "Beni Rached",
    wilaya_id: 2,
    commune_name: "بني راشد",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 42,
    code_postal: "02014",
    ok_postal_code: "2014",
    second_name: "Talassa",
    nom: "Talassa",
    wilaya_id: 2,
    commune_name: "تلعصة",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 43,
    code_postal: "02015",
    ok_postal_code: "2015",
    second_name: "Harenfa",
    nom: "Herenfa",
    wilaya_id: 2,
    commune_name: "الهرانفة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 44,
    code_postal: "02016",
    ok_postal_code: "2016",
    second_name: "Oued Goussine",
    nom: "Oued Goussine",
    wilaya_id: 2,
    commune_name: "وادي قوسين",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:43:30",
  },
  {
    id: 45,
    code_postal: "02017",
    ok_postal_code: "2017",
    second_name: "Dahra",
    nom: "Dahra",
    wilaya_id: 2,
    commune_name: "الظهرة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-16 17:42:29",
  },
  {
    id: 46,
    code_postal: "02018",
    ok_postal_code: "2018",
    second_name: "Ouled Abbes",
    nom: "Ouled Abbes",
    wilaya_id: 2,
    commune_name: "أولاد عباس",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 47,
    code_postal: "02019",
    ok_postal_code: "2019",
    second_name: "Sendjas",
    nom: "Sendjas",
    wilaya_id: 2,
    commune_name: "سنجاس",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 48,
    code_postal: "02020",
    ok_postal_code: "2020",
    second_name: "Zeboudja",
    nom: "Zeboudja",
    wilaya_id: 2,
    commune_name: "الزبوجة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 49,
    code_postal: "02021",
    ok_postal_code: "2021",
    second_name: "Oued Sly",
    nom: "Oued Sly",
    wilaya_id: 2,
    commune_name: "وادي سلي",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 50,
    code_postal: "02022",
    ok_postal_code: "2022",
    second_name: "Abou El Hassan",
    nom: "Abou El Hassen",
    wilaya_id: 2,
    commune_name: "أبو الحسن",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 51,
    code_postal: "02023",
    ok_postal_code: "2023",
    second_name: "El Marsa",
    nom: "El Marsa",
    wilaya_id: 2,
    commune_name: "المرسى",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 52,
    code_postal: "02024",
    ok_postal_code: "2024",
    second_name: "Chettia",
    nom: "Chettia",
    wilaya_id: 2,
    commune_name: "الشطية",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 53,
    code_postal: "02025",
    ok_postal_code: "2025",
    second_name: "Sidi Abderrahmane",
    nom: "Sidi Abderrahmane",
    wilaya_id: 2,
    commune_name: "سيدي عبد الرحمن",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:41:32",
  },
  {
    id: 54,
    code_postal: "02026",
    ok_postal_code: "2026",
    second_name: "Moussadek",
    nom: "Moussadek",
    wilaya_id: 2,
    commune_name: "مصدق",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:43:30",
  },
  {
    id: 56,
    code_postal: "02028",
    ok_postal_code: "2028",
    second_name: "Labiod Medjadja",
    nom: "Labiod Medjadja",
    wilaya_id: 2,
    commune_name: "الأبيض مجاجة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 57,
    code_postal: "02029",
    ok_postal_code: "2029",
    second_name: "Oued Fodda",
    nom: "Oued Fodda",
    wilaya_id: 2,
    commune_name: "وادي الفضة",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 58,
    code_postal: "02030",
    ok_postal_code: "2030",
    second_name: "Ouled Ben Abdelkader",
    nom: "Ouled Ben Abdelkader",
    wilaya_id: 2,
    commune_name: "أولاد بن عبد القادر",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 59,
    code_postal: "02031",
    ok_postal_code: "2031",
    second_name: "Bouzeghaia",
    nom: "Bouzghaia",
    wilaya_id: 2,
    commune_name: "بوزغاية",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 60,
    code_postal: "02032",
    ok_postal_code: "2032",
    second_name: "A\u00efn Merane",
    nom: "Ain Merane",
    wilaya_id: 2,
    commune_name: "عين مران",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 61,
    code_postal: "02033",
    ok_postal_code: "2033",
    second_name: "Oum Drou",
    nom: "Oum Drou",
    wilaya_id: 2,
    commune_name: "أم الدروع",
    wilaya_name: "الشلف",
    hub_id: 8,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 62,
    code_postal: "02034",
    ok_postal_code: "2034",
    second_name: "Breira",
    nom: "Breira",
    wilaya_id: 2,
    commune_name: "بريرة",
    wilaya_name: "الشلف",
    hub_id: 97,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-05 21:43:30",
  },
  {
    id: 64,
    code_postal: "03001",
    ok_postal_code: "3001",
    second_name: "Laghouat",
    nom: "Laghouat",
    wilaya_id: 3,
    commune_name: "الأغواط",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 65,
    code_postal: "03002",
    ok_postal_code: "3002",
    second_name: "Ksar El Hirane",
    nom: "Ksar El Hirane",
    wilaya_id: 3,
    commune_name: "قصر الحيران",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 66,
    code_postal: "03003",
    ok_postal_code: "3003",
    second_name: "Bennasser Benchohra",
    nom: "Benacer Ben Chohra",
    wilaya_id: 3,
    commune_name: "بن ناصر بن شهرة",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 67,
    code_postal: "03004",
    ok_postal_code: "3004",
    second_name: "Sidi Makhlouf",
    nom: "Sidi Makhlouf",
    wilaya_id: 3,
    commune_name: "سيدي مخلوف",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 68,
    code_postal: "03005",
    ok_postal_code: "3005",
    second_name: "Hassi Delaa",
    nom: "Hassi Delaa",
    wilaya_id: 3,
    commune_name: "حاسي الدلاعة",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 69,
    code_postal: "03006",
    ok_postal_code: "3006",
    second_name: "Hassi R'Mel",
    nom: "Hassi R Mel",
    wilaya_id: 3,
    commune_name: "حاسي الرمل",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 70,
    code_postal: "03007",
    ok_postal_code: "3007",
    second_name: "A\u00efn Madhi",
    nom: "Ain Mahdi",
    wilaya_id: 3,
    commune_name: "عين ماضي",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 71,
    code_postal: "03008",
    ok_postal_code: "3008",
    second_name: "Tadjemout",
    nom: "Tadjmout",
    wilaya_id: 3,
    commune_name: "تاجموت",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 72,
    code_postal: "03009",
    ok_postal_code: "3009",
    second_name: "Kheneg",
    nom: "Kheneg",
    wilaya_id: 3,
    commune_name: "الخنق",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 73,
    code_postal: "03010",
    ok_postal_code: "3010",
    second_name: "Gueltat Sidi Saad",
    nom: "Gueltat Sidi Saad",
    wilaya_id: 3,
    commune_name: "قلتة سيدي سعد",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 74,
    code_postal: "03011",
    ok_postal_code: "3011",
    second_name: "A\u00efn Sidi Ali",
    nom: "Ain Sidi Ali",
    wilaya_id: 3,
    commune_name: "عين سيدي علي",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 75,
    code_postal: "03012",
    ok_postal_code: "3012",
    second_name: "Beidha",
    nom: "Beidha",
    wilaya_id: 3,
    commune_name: "البيضاء",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 76,
    code_postal: "03013",
    ok_postal_code: "3013",
    second_name: "Brida",
    nom: "Brida",
    wilaya_id: 3,
    commune_name: "بريدة",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 77,
    code_postal: "03014",
    ok_postal_code: "3014",
    second_name: "El Ghicha",
    nom: "El Ghicha",
    wilaya_id: 3,
    commune_name: "الغيشة",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 78,
    code_postal: "03015",
    ok_postal_code: "3015",
    second_name: "Hadj Mechri",
    nom: "Hadj Mechri",
    wilaya_id: 3,
    commune_name: "الحاج مشري",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 79,
    code_postal: "03016",
    ok_postal_code: "3016",
    second_name: "Sebgag",
    nom: "Sebgag",
    wilaya_id: 3,
    commune_name: "سبقاق",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 80,
    code_postal: "03017",
    ok_postal_code: "3017",
    second_name: "Taouiala",
    nom: "Taouiala",
    wilaya_id: 3,
    commune_name: "تاويالة",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 81,
    code_postal: "03018",
    ok_postal_code: "3018",
    second_name: "Tadjrouna",
    nom: "Tadjrouna",
    wilaya_id: 3,
    commune_name: "تاجرونة",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 82,
    code_postal: "03019",
    ok_postal_code: "3019",
    second_name: "Aflou",
    nom: "Aflou",
    wilaya_id: 3,
    commune_name: "أفلو",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 83,
    code_postal: "03020",
    ok_postal_code: "3020",
    second_name: "El Assafia",
    nom: "El Assafia",
    wilaya_id: 3,
    commune_name: "العسافية",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 84,
    code_postal: "03021",
    ok_postal_code: "3021",
    second_name: "Oued Morra",
    nom: "Oued Morra",
    wilaya_id: 3,
    commune_name: "وادي مرة",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 85,
    code_postal: "03022",
    ok_postal_code: "3022",
    second_name: "Oued M'Zi",
    nom: "Oued M Zi",
    wilaya_id: 3,
    commune_name: "وادي مزي",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 86,
    code_postal: "03023",
    ok_postal_code: "3023",
    second_name: "El Houaita",
    nom: "El Haouaita",
    wilaya_id: 3,
    commune_name: "الحويطة",
    wilaya_name: "الأغواط",
    hub_id: 12,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 87,
    code_postal: "03024",
    ok_postal_code: "3024",
    second_name: "Sidi Bouzid",
    nom: "Sidi Bouzid",
    wilaya_id: 3,
    commune_name: "سيدي بوزيد",
    wilaya_name: "الأغواط",
    hub_id: 74,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 17:15:02",
  },
  {
    id: 88,
    code_postal: "04001",
    ok_postal_code: "4001",
    second_name: "Oum el Bouaghi",
    nom: "Oum El Bouaghi",
    wilaya_id: 4,
    commune_name: "أم البواقي",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 89,
    code_postal: "04002",
    ok_postal_code: "4002",
    second_name: "A\u00efn Be\u00efda",
    nom: "Ain Beida",
    wilaya_id: 4,
    commune_name: "عين البيضاء",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 90,
    code_postal: "04003",
    ok_postal_code: "4003",
    second_name: "A\u00efn M'lila",
    nom: "Ainmlila",
    wilaya_id: 4,
    commune_name: "عين مليلة",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 91,
    code_postal: "04004",
    ok_postal_code: "4004",
    second_name: "Behir Chergui",
    nom: "Behir Chergui",
    wilaya_id: 4,
    commune_name: "بحير الشرقي",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 92,
    code_postal: "04005",
    ok_postal_code: "4005",
    second_name: "El Amiria",
    nom: "El Amiria",
    wilaya_id: 4,
    commune_name: "العامرية",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 93,
    code_postal: "04006",
    ok_postal_code: "4006",
    second_name: "Sigus",
    nom: "Sigus",
    wilaya_id: 4,
    commune_name: "سيقوس",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 94,
    code_postal: "04007",
    ok_postal_code: "4007",
    second_name: "El Belala",
    nom: "El Belala",
    wilaya_id: 4,
    commune_name: "البلالة",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 95,
    code_postal: "04008",
    ok_postal_code: "4008",
    second_name: "A\u00efn Babouche",
    nom: "Ain Babouche",
    wilaya_id: 4,
    commune_name: "عين ببوش",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 96,
    code_postal: "04009",
    ok_postal_code: "4009",
    second_name: "Berriche",
    nom: "Berriche",
    wilaya_id: 4,
    commune_name: "بريش",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 97,
    code_postal: "04010",
    ok_postal_code: "4010",
    second_name: "Ouled Hamla",
    nom: "Ouled Hamla",
    wilaya_id: 4,
    commune_name: "أولاد حملة",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 98,
    code_postal: "04011",
    ok_postal_code: "4011",
    second_name: "Dhalaa",
    nom: "Dhala",
    wilaya_id: 4,
    commune_name: "الضلعة",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 99,
    code_postal: "04012",
    ok_postal_code: "4012",
    second_name: "A\u00efn Kercha",
    nom: "Ain Kercha",
    wilaya_id: 4,
    commune_name: "عين كرشة",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 100,
    code_postal: "04013",
    ok_postal_code: "4013",
    second_name: "Hanchir Toumghani",
    nom: "Hanchir Toumghani",
    wilaya_id: 4,
    commune_name: "هنشير تومغني",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 102,
    code_postal: "04015",
    ok_postal_code: "4015",
    second_name: "A\u00efn Diss",
    nom: "Ain Diss",
    wilaya_id: 4,
    commune_name: "عين الديس",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 103,
    code_postal: "04016",
    ok_postal_code: "4016",
    second_name: "Fkirina",
    nom: "Fkirina",
    wilaya_id: 4,
    commune_name: "فكيرينة",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 104,
    code_postal: "04017",
    ok_postal_code: "4017",
    second_name: "Souk Naamane",
    nom: "Souk Naamane",
    wilaya_id: 4,
    commune_name: "سوق نعمان",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 105,
    code_postal: "04018",
    ok_postal_code: "4018",
    second_name: "Zorg",
    nom: "Zorg",
    wilaya_id: 4,
    commune_name: "الزرق",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 106,
    code_postal: "04019",
    ok_postal_code: "4019",
    second_name: "El Fedjoudj Boughrara Saoudi",
    nom: "El Fedjoudj Boughrar",
    wilaya_id: 4,
    commune_name: "الفجوج بوغرارة سعودي",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-10 12:43:50",
  },
  {
    id: 107,
    code_postal: "04020",
    ok_postal_code: "4020",
    second_name: "Ouled Zoua\u00ef",
    nom: "Ouled Zouai",
    wilaya_id: 4,
    commune_name: "أولاد زواي",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 108,
    code_postal: "04021",
    ok_postal_code: "4021",
    second_name: "Bir Chouhada",
    nom: "Bir Chouhada",
    wilaya_id: 4,
    commune_name: "بئر الشهداء",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 109,
    code_postal: "04022",
    ok_postal_code: "4022",
    second_name: "Ksar Sbahi",
    nom: "Ksar Sbahi",
    wilaya_id: 4,
    commune_name: "قصر الصباحي",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 110,
    code_postal: "04023",
    ok_postal_code: "4023",
    second_name: "Oued Nini",
    nom: "Oued Nini",
    wilaya_id: 4,
    commune_name: "وادي نيني",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 111,
    code_postal: "04024",
    ok_postal_code: "4024",
    second_name: "Meskiana",
    nom: "Meskiana",
    wilaya_id: 4,
    commune_name: "مسكيانة",
    wilaya_name: "أم البواقي",
    hub_id: 103,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-09 18:27:55",
  },
  {
    id: 112,
    code_postal: "04025",
    ok_postal_code: "4025",
    second_name: "A\u00efn Fakroun",
    nom: "Ain Fekroune",
    wilaya_id: 4,
    commune_name: "عين فكرون",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 114,
    code_postal: "04027",
    ok_postal_code: "4027",
    second_name: "A\u00efn Zitoun",
    nom: "Ain Zitoun",
    wilaya_id: 4,
    commune_name: "عين الزيتون",
    wilaya_name: "أم البواقي",
    hub_id: 87,
    is_active: 1,
    created_at: null,
    updated_at: "2025-03-15 01:44:20",
  },
  {
    id: 115,
    code_postal: "04028",
    ok_postal_code: "4028",
    second_name: "Ouled Gacem",
    nom: "Ouled Gacem",
    wilaya_id: 4,
    commune_name: "أولاد قاسم",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 116,
    code_postal: "04029",
    ok_postal_code: "4029",
    second_name: "El Harmilia",
    nom: "El Harmilia",
    wilaya_id: 4,
    commune_name: "الحرملية",
    wilaya_name: "أم البواقي",
    hub_id: 41,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 117,
    code_postal: "05001",
    ok_postal_code: "5001",
    second_name: "Batna",
    nom: "Batna",
    wilaya_id: 5,
    commune_name: "باتنة",
    wilaya_name: "باتنة",
    hub_id: 7,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 118,
    code_postal: "05002",
    ok_postal_code: "5002",
    second_name: "Ghassira",
    nom: "Ghassira",
    wilaya_id: 5,
    commune_name: "غسيرة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 119,
    code_postal: "05003",
    ok_postal_code: "5003",
    second_name: "Maafa",
    nom: "Maafa",
    wilaya_id: 5,
    commune_name: "معافة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 120,
    code_postal: "05004",
    ok_postal_code: "5004",
    second_name: "Merouana",
    nom: "Merouana",
    wilaya_id: 5,
    commune_name: "مروانة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 121,
    code_postal: "05005",
    ok_postal_code: "5005",
    second_name: "Seriana",
    nom: "Seriana",
    wilaya_id: 5,
    commune_name: "سريانة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 122,
    code_postal: "05006",
    ok_postal_code: "5006",
    second_name: "Menaa",
    nom: "Menaa",
    wilaya_id: 5,
    commune_name: "منعة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 123,
    code_postal: "05007",
    ok_postal_code: "5007",
    second_name: "El Madher",
    nom: "El Madher",
    wilaya_id: 5,
    commune_name: "المعذر",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 124,
    code_postal: "05008",
    ok_postal_code: "5008",
    second_name: "Tazoult",
    nom: "Tazoult",
    wilaya_id: 5,
    commune_name: "تازولت",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 125,
    code_postal: "05009",
    ok_postal_code: "5009",
    second_name: "N'Gaous",
    nom: "Ngaous",
    wilaya_id: 5,
    commune_name: "نقاوس",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 126,
    code_postal: "05010",
    ok_postal_code: "5010",
    second_name: "Guigba",
    nom: "Guigba",
    wilaya_id: 5,
    commune_name: "القيقبة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 127,
    code_postal: "05011",
    ok_postal_code: "5011",
    second_name: "Inoughissen",
    nom: "Inoughissen",
    wilaya_id: 5,
    commune_name: "إينوغيسن",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 128,
    code_postal: "05012",
    ok_postal_code: "5012",
    second_name: "Ouyoun El Assafir",
    nom: "Ouyoun El Assafir",
    wilaya_id: 5,
    commune_name: "عيون العصافير",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 129,
    code_postal: "05013",
    ok_postal_code: "5013",
    second_name: "Djerma",
    nom: "Djerma",
    wilaya_id: 5,
    commune_name: "جرمة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 130,
    code_postal: "05014",
    ok_postal_code: "5014",
    second_name: "Bitam",
    nom: "Bitam",
    wilaya_id: 5,
    commune_name: "بيطام",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 131,
    code_postal: "05015",
    ok_postal_code: "5015",
    second_name: "Abdelkader Azil",
    nom: "Metkaouak",
    wilaya_id: 5,
    commune_name: "عزيل عبد القادر",
    wilaya_name: "باتنة",
    // TODO(arabic-match): "Abdelkader Azil". done
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-07 11:05:17",
  },
  {
    id: 132,
    code_postal: "05016",
    ok_postal_code: "5016",
    second_name: "Arris",
    nom: "Arris",
    wilaya_id: 5,
    commune_name: "أريس",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 133,
    code_postal: "05017",
    ok_postal_code: "5017",
    second_name: "Kimmel",
    nom: "Kimmel",
    wilaya_id: 5,
    commune_name: "كيمل",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 134,
    code_postal: "05018",
    ok_postal_code: "5018",
    second_name: "Tilatou",
    nom: "Tilatou",
    wilaya_id: 5,
    commune_name: "تيلاطو",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 135,
    code_postal: "05019",
    ok_postal_code: "5019",
    second_name: "A\u00efn Djasser",
    nom: "Ain Djasser",
    wilaya_id: 5,
    commune_name: "عين جاسر",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 136,
    code_postal: "05020",
    ok_postal_code: "5020",
    second_name: "Ouled Sellam",
    nom: "Ouled Selam",
    wilaya_id: 5,
    commune_name: "أولاد سلام",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 137,
    code_postal: "05021",
    ok_postal_code: "5021",
    second_name: "Tigherghar",
    nom: "Tigherghar",
    wilaya_id: 5,
    commune_name: "تغرغار",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 138,
    code_postal: "05022",
    ok_postal_code: "5022",
    second_name: "A\u00efn Yagout",
    nom: "Ain Yagout",
    wilaya_id: 5,
    commune_name: "عين ياقوت",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 139,
    code_postal: "05023",
    ok_postal_code: "5023",
    second_name: "Fesdis",
    nom: "Fesdis",
    wilaya_id: 5,
    commune_name: "فسديس",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 140,
    code_postal: "05024",
    ok_postal_code: "5024",
    second_name: "Sefiane",
    nom: "Sefiane",
    wilaya_id: 5,
    commune_name: "سفيان",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 141,
    code_postal: "05025",
    ok_postal_code: "5025",
    second_name: "Rahbat",
    nom: "Rahbat",
    wilaya_id: 5,
    commune_name: "الرحبات",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 142,
    code_postal: "05026",
    ok_postal_code: "5026",
    second_name: "Tighanimine",
    nom: "Tighanimine",
    wilaya_id: 5,
    commune_name: "تيغانمين",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 143,
    code_postal: "05027",
    ok_postal_code: "5027",
    second_name: "Lemsane",
    nom: "Lemsane",
    wilaya_id: 5,
    commune_name: "لمسان",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 144,
    code_postal: "05028",
    ok_postal_code: "5028",
    second_name: "Ksar Bellezma",
    nom: "Ksar Belezma",
    wilaya_id: 5,
    commune_name: "قصر بلزمة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 145,
    code_postal: "05029",
    ok_postal_code: "5029",
    second_name: "Seggana",
    nom: "Seggana",
    wilaya_id: 5,
    commune_name: "سقانة",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 146,
    code_postal: "05030",
    ok_postal_code: "5030",
    second_name: "Ichmoul",
    nom: "Ichmoul",
    wilaya_id: 5,
    commune_name: "إشمول",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 147,
    code_postal: "05031",
    ok_postal_code: "5031",
    second_name: "Foum Toub",
    nom: "Foum Toub",
    wilaya_id: 5,
    commune_name: "فم الطوب",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 148,
    code_postal: "05032",
    ok_postal_code: "5032",
    second_name: "Ben Foudhala El Hakania",
    nom: "Beni Foudhala El Hakania",
    wilaya_id: 5,
    commune_name: "بني فضالة الحقانية",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 149,
    code_postal: "05033",
    ok_postal_code: "5033",
    second_name: "Oued El Ma",
    nom: "Oued El Ma",
    wilaya_id: 5,
    commune_name: "وادي الماء",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 150,
    code_postal: "05034",
    ok_postal_code: "5034",
    second_name: "Talkhamt",
    nom: "Talkhamt",
    wilaya_id: 5,
    commune_name: "تالخمت",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 151,
    code_postal: "05035",
    ok_postal_code: "5035",
    second_name: "Bouzina",
    nom: "Bouzina",
    wilaya_id: 5,
    commune_name: "بوزينة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 152,
    code_postal: "05036",
    ok_postal_code: "5036",
    second_name: "Chemora",
    nom: "Chemora",
    wilaya_id: 5,
    commune_name: "الشمرة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 153,
    code_postal: "05037",
    ok_postal_code: "5037",
    second_name: "Oued Chaaba",
    nom: "Oued Chaaba",
    wilaya_id: 5,
    commune_name: "وادي الشعبة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 154,
    code_postal: "05038",
    ok_postal_code: "5038",
    second_name: "Taxlent",
    nom: "Taxlent",
    wilaya_id: 5,
    commune_name: "تاكسلانت",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 155,
    code_postal: "05039",
    ok_postal_code: "5039",
    second_name: "Gosbat",
    nom: "Gosbat",
    wilaya_id: 5,
    commune_name: "القصبات",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 156,
    code_postal: "05040",
    ok_postal_code: "5040",
    second_name: "Ouled Aouf",
    nom: "Ouled Aouf",
    wilaya_id: 5,
    commune_name: "أولاد عوف",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 157,
    code_postal: "05041",
    ok_postal_code: "5041",
    second_name: "Boumagueur",
    nom: "Boumagueur",
    wilaya_id: 5,
    commune_name: "بومقر",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 158,
    code_postal: "05042",
    ok_postal_code: "5042",
    second_name: "Barika",
    nom: "Barika",
    wilaya_id: 5,
    commune_name: "بريكة",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 159,
    code_postal: "05043",
    ok_postal_code: "5043",
    second_name: "Djezar",
    nom: "Djezzar",
    wilaya_id: 5,
    commune_name: "الجزار",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 160,
    code_postal: "05044",
    ok_postal_code: "5044",
    second_name: "T'Kout",
    nom: "Tkout",
    wilaya_id: 5,
    commune_name: "تكوت",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 161,
    code_postal: "05045",
    ok_postal_code: "5045",
    second_name: "A\u00efn Touta",
    nom: "Ain Touta",
    wilaya_id: 5,
    commune_name: "عين التوتة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 162,
    code_postal: "05046",
    ok_postal_code: "5046",
    second_name: "Hidoussa",
    nom: "Hidoussa",
    wilaya_id: 5,
    commune_name: "حيدوسة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 163,
    code_postal: "05047",
    ok_postal_code: "5047",
    second_name: "Teniet El Abed",
    nom: "Teniet El Abed",
    wilaya_id: 5,
    commune_name: "ثنية العابد",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 164,
    code_postal: "05048",
    ok_postal_code: "5048",
    second_name: "Oued Taga",
    nom: "Oued Taga",
    wilaya_id: 5,
    commune_name: "وادي الطاقة",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 165,
    code_postal: "05049",
    ok_postal_code: "5049",
    second_name: "Ouled Fadel",
    nom: "Ouled Fadel",
    wilaya_id: 5,
    commune_name: "أولاد فاضل",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 166,
    code_postal: "05050",
    ok_postal_code: "5050",
    second_name: "Timgad",
    nom: "Timgad",
    wilaya_id: 5,
    commune_name: "تيمقاد",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 167,
    code_postal: "05051",
    ok_postal_code: "5051",
    second_name: "Ras El Aioun",
    nom: "Ras El Aioun",
    wilaya_id: 5,
    commune_name: "رأس العيون",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 168,
    code_postal: "05052",
    ok_postal_code: "5052",
    second_name: "Chir",
    nom: "Chir",
    wilaya_id: 5,
    commune_name: "شير",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:41:13",
  },
  {
    id: 169,
    code_postal: "05053",
    ok_postal_code: "5053",
    second_name: "Ouled Si Slimane",
    nom: "Ouled Si Slimane",
    wilaya_id: 5,
    commune_name: "أولاد سي سليمان",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 170,
    code_postal: "05054",
    ok_postal_code: "5054",
    second_name: "Zanat El Beida",
    nom: "Zanat El Beida",
    wilaya_id: 5,
    commune_name: "زانة البيضاء",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 171,
    code_postal: "05055",
    ok_postal_code: "5055",
    second_name: "M'doukel",
    nom: "Amdoukal",
    wilaya_id: 5,
    commune_name: "إمدوكل",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 172,
    code_postal: "05056",
    ok_postal_code: "5056",
    second_name: "Ouled Ammar",
    nom: "Ouled Ammar",
    wilaya_id: 5,
    commune_name: "أولاد عمار",
    wilaya_name: "باتنة",
    hub_id: 67,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-10 04:00:16",
  },
  {
    id: 173,
    code_postal: "05057",
    ok_postal_code: "5057",
    second_name: "El Hassi",
    nom: "El Hassi",
    wilaya_id: 5,
    commune_name: "الحاسي",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 174,
    code_postal: "05058",
    ok_postal_code: "5058",
    second_name: "Lazrou",
    nom: "Lazrou",
    wilaya_id: 5,
    commune_name: "لازرو",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 175,
    code_postal: "05059",
    ok_postal_code: "5059",
    second_name: "Boumia (Batna)",
    nom: "Boumia",
    wilaya_id: 5,
    commune_name: "بومية",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 176,
    code_postal: "05060",
    ok_postal_code: "5060",
    second_name: "Boulhilat",
    nom: "Boulhilat",
    wilaya_id: 5,
    commune_name: "بولهيلات",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 177,
    code_postal: "05061",
    ok_postal_code: "5061",
    second_name: "Larba\u00e2",
    nom: "Larbaa",
    wilaya_id: 5,
    commune_name: "لارباع",
    wilaya_name: "باتنة",
    hub_id: 89,
    is_active: 1,
    created_at: null,
    updated_at: "2025-06-27 23:43:19",
  },
  {
    id: 178,
    code_postal: "06001",
    ok_postal_code: "6001",
    second_name: "B\u00e9ja\u00efa",
    nom: "Bejaia",
    wilaya_id: 6,
    commune_name: "بجاية",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 179,
    code_postal: "06002",
    ok_postal_code: "6002",
    second_name: "Amizour",
    nom: "Amizour",
    wilaya_id: 6,
    commune_name: "أميزور",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 180,
    code_postal: "06003",
    ok_postal_code: "6003",
    second_name: "Ferraoun",
    nom: "Ferraoun",
    wilaya_id: 6,
    commune_name: "فرعون",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 181,
    code_postal: "06004",
    ok_postal_code: "6004",
    second_name: "Taourirt Ighil",
    nom: "Taourirt Ighil",
    wilaya_id: 6,
    commune_name: "تاوريرت إغيل",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2026-03-31 13:21:56",
  },
  {
    id: 182,
    code_postal: "06005",
    ok_postal_code: "6005",
    second_name: "Chellata",
    nom: "Chelata",
    wilaya_id: 6,
    commune_name: "شلاطة",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 184,
    code_postal: "06007",
    ok_postal_code: "6007",
    second_name: null,
    nom: "Timzrit",
    wilaya_id: 6,
    commune_name: "تيمزريت",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-08 11:24:41",
  },
  {
    id: 185,
    code_postal: "06008",
    ok_postal_code: "6008",
    second_name: "Souk El T\u00e9nine",
    nom: "Souk El Thenine",
    wilaya_id: 6,
    commune_name: "سوق لإثنين",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2026-03-31 13:22:22",
  },
  {
    id: 186,
    code_postal: "06009",
    ok_postal_code: "6009",
    second_name: "M'cisna",
    nom: "Mcisna",
    wilaya_id: 6,
    commune_name: "مسيسنة",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 187,
    code_postal: "06010",
    ok_postal_code: "6010",
    second_name: "Tinabdher",
    nom: "Thinabdher",
    wilaya_id: 6,
    commune_name: "تينبدار",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 188,
    code_postal: "06011",
    ok_postal_code: "6011",
    second_name: "Tichy",
    nom: "Tichi",
    wilaya_id: 6,
    commune_name: "تيشي",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 189,
    code_postal: "06012",
    ok_postal_code: "6012",
    second_name: "Semaoun",
    nom: "Semaoun",
    wilaya_id: 6,
    commune_name: "سمعون",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 190,
    code_postal: "06013",
    ok_postal_code: "6013",
    second_name: "Kendira",
    nom: "Kendira",
    wilaya_id: 6,
    commune_name: "كنديرة",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 191,
    code_postal: "06014",
    ok_postal_code: "6014",
    second_name: "Tifra",
    nom: "Tifra",
    wilaya_id: 6,
    commune_name: "تيفرة",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 192,
    code_postal: "06015",
    ok_postal_code: "6015",
    second_name: "Ighram",
    nom: "Ighram",
    wilaya_id: 6,
    commune_name: "اغرم",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 193,
    code_postal: "06016",
    ok_postal_code: "6016",
    second_name: "Amalou",
    nom: "Amalou",
    wilaya_id: 6,
    commune_name: "أمالو",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 195,
    code_postal: "06018",
    ok_postal_code: "6018",
    second_name: "Fena\u00efa Ilmaten",
    nom: "Ifelain Ilmathen",
    wilaya_id: 6,
    commune_name: "فناية الماثن",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 196,
    code_postal: "06019",
    ok_postal_code: "6019",
    second_name: "Toudja",
    nom: "Toudja",
    wilaya_id: 6,
    commune_name: "توجة",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:34:53",
  },
  {
    id: 197,
    code_postal: "06020",
    ok_postal_code: "6020",
    second_name: "Darguina",
    nom: "Darguina",
    wilaya_id: 6,
    commune_name: "درقينة",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 198,
    code_postal: "06021",
    ok_postal_code: "6021",
    second_name: "Sidi Ayad",
    nom: "Sidi Ayad",
    wilaya_id: 6,
    commune_name: "سيدي عياد",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 199,
    code_postal: "06022",
    ok_postal_code: "6022",
    second_name: "Aokas",
    nom: "Aokas",
    wilaya_id: 6,
    commune_name: "أوقاس",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 200,
    code_postal: "06023",
    ok_postal_code: "6023",
    second_name: "Ait Djellil",
    nom: "Beni Djellil",
    wilaya_id: 6,
    commune_name: "بني جليل",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:39:08",
  },
  {
    id: 201,
    code_postal: "06024",
    ok_postal_code: "6024",
    second_name: "Adekar",
    nom: "Adekar",
    wilaya_id: 6,
    commune_name: "أدكار",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:34:53",
  },
  {
    id: 202,
    code_postal: "06025",
    ok_postal_code: "6025",
    second_name: "Akbou",
    nom: "Akbou",
    wilaya_id: 6,
    commune_name: "أقبو",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 203,
    code_postal: "06026",
    ok_postal_code: "6026",
    second_name: "Seddouk",
    nom: "Seddouk",
    wilaya_id: 6,
    commune_name: "صدوق",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 204,
    code_postal: "06027",
    ok_postal_code: "6027",
    second_name: "Tazmalt",
    nom: "Tazmalt",
    wilaya_id: 6,
    commune_name: "تازمالت",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 205,
    code_postal: "06028",
    ok_postal_code: "6028",
    second_name: "A\u00eft R'zine",
    nom: "Ait Rizine",
    wilaya_id: 6,
    commune_name: "أيت رزين",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 206,
    code_postal: "06029",
    ok_postal_code: "6029",
    second_name: "Chemini",
    nom: "Chemini",
    wilaya_id: 6,
    commune_name: "شميني",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 207,
    code_postal: "06030",
    ok_postal_code: "6030",
    second_name: "Souk Oufella",
    nom: "Souk Oufella",
    wilaya_id: 6,
    commune_name: "سوق اوفلا",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 208,
    code_postal: "06031",
    ok_postal_code: "6031",
    second_name: "Taskriout",
    nom: "Taskriout",
    wilaya_id: 6,
    commune_name: "تاسكريوت",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 209,
    code_postal: "06032",
    ok_postal_code: "6032",
    second_name: "Tibane",
    nom: "Tibane",
    wilaya_id: 6,
    commune_name: "طيبان",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 210,
    code_postal: "06033",
    ok_postal_code: "6033",
    second_name: "Tala Hamza",
    nom: "Tala Hamza",
    wilaya_id: 6,
    commune_name: "تالة حمزة",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-08 11:25:02",
  },
  {
    id: 211,
    code_postal: "06034",
    ok_postal_code: "6034",
    second_name: "Barbacha",
    nom: "Barbacha",
    wilaya_id: 6,
    commune_name: "برباشة",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:34:53",
  },
  {
    id: 212,
    code_postal: "06035",
    ok_postal_code: "6035",
    second_name: "A\u00eft Ksila",
    nom: "Beni Ksila",
    wilaya_id: 6,
    commune_name: "بني كسيلة",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-11 11:43:59",
  },
  {
    id: 213,
    code_postal: "06036",
    ok_postal_code: "6036",
    second_name: "Ouzellaguen",
    nom: "Ouzallaguen",
    wilaya_id: 6,
    commune_name: "أوزلاقن",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 214,
    code_postal: "06037",
    ok_postal_code: "6037",
    second_name: "Bouhamza",
    nom: "Bouhamza",
    wilaya_id: 6,
    commune_name: "بوحمزة",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 12:34:48",
  },
  {
    id: 216,
    code_postal: "06039",
    ok_postal_code: "6039",
    second_name: "Sidi A\u00efch",
    nom: "Sidi Aich",
    wilaya_id: 6,
    commune_name: "سيدي عيش",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 217,
    code_postal: "06040",
    ok_postal_code: "6040",
    second_name: "El Kseur",
    nom: "El Kseur",
    wilaya_id: 6,
    commune_name: "القصر",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:34:53",
  },
  {
    id: 218,
    code_postal: "06041",
    ok_postal_code: "6041",
    second_name: "Melbou",
    nom: "Melbou",
    wilaya_id: 6,
    commune_name: "مالبو",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 219,
    code_postal: "06042",
    ok_postal_code: "6042",
    second_name: "Akfadou",
    nom: "Akfadou",
    wilaya_id: 6,
    commune_name: "أكفادو",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 220,
    code_postal: "06043",
    ok_postal_code: "6043",
    second_name: "Leflaye",
    nom: "Leflaye",
    wilaya_id: 6,
    commune_name: "الفلاي",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 221,
    code_postal: "06044",
    ok_postal_code: "6044",
    second_name: "Kherrata",
    nom: "Kherrata",
    wilaya_id: 6,
    commune_name: "خراطة",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 224,
    code_postal: "06047",
    ok_postal_code: "6047",
    second_name: "A\u00eft Smail",
    nom: "Ait Smail",
    wilaya_id: 6,
    commune_name: "أيت إسماعيل",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 225,
    code_postal: "06048",
    ok_postal_code: "6048",
    second_name: "Boukhelifa",
    nom: "Boukhelifa",
    wilaya_id: 6,
    commune_name: "بوخليفة",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 226,
    code_postal: "06049",
    ok_postal_code: "6049",
    second_name: "Tizi N'Berber",
    nom: "Tizi Nberber",
    wilaya_id: 6,
    commune_name: "تيزي نبربر",
    wilaya_name: "بجاية",
    hub_id: 4,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 227,
    code_postal: "06050",
    ok_postal_code: "6050",
    second_name: "A\u00eft Maouche",
    nom: "Beni Maouch",
    wilaya_id: 6,
    commune_name: "بني معوش",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 228,
    code_postal: "06051",
    ok_postal_code: "6051",
    second_name: "Oued Ghir",
    nom: "Oued Ghir",
    wilaya_id: 6,
    commune_name: "وادي غير",
    wilaya_name: "بجاية",
    hub_id: 102,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-02 22:34:53",
  },
  {
    id: 229,
    code_postal: "06052",
    ok_postal_code: "6052",
    second_name: "Boudjellil",
    nom: "Boudjellil",
    wilaya_id: 6,
    commune_name: "بو جليل",
    wilaya_name: "بجاية",
    hub_id: 66,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 230,
    code_postal: "07001",
    ok_postal_code: "7001",
    second_name: "Biskra",
    nom: "Biskra",
    wilaya_id: 7,
    commune_name: "بسكرة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 231,
    code_postal: "07002",
    ok_postal_code: "7002",
    second_name: "Oumache",
    nom: "Oumache",
    wilaya_id: 7,
    commune_name: "أوماش",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 232,
    code_postal: "07003",
    ok_postal_code: "7003",
    second_name: "Branis",
    nom: "Branis",
    wilaya_id: 7,
    commune_name: "برانيس",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 233,
    code_postal: "07004",
    ok_postal_code: "7004",
    second_name: "Chetma",
    nom: "Chetma",
    wilaya_id: 7,
    commune_name: "شتمة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 240,
    code_postal: "07011",
    ok_postal_code: "7011",
    second_name: "Sidi Okba",
    nom: "Sidi Okba",
    wilaya_id: 7,
    commune_name: "سيدي عقبة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 241,
    code_postal: "07012",
    ok_postal_code: "7012",
    second_name: "M'Chouneche",
    nom: "Mchouneche",
    wilaya_id: 7,
    commune_name: "مشونش",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 243,
    code_postal: "07014",
    ok_postal_code: "7014",
    second_name: "A\u00efn Naga",
    nom: "Ain Naga",
    wilaya_id: 7,
    commune_name: "عين الناقة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 244,
    code_postal: "07015",
    ok_postal_code: "7015",
    second_name: "Zeribet El Oued",
    nom: "Zeribet El Oued",
    wilaya_id: 7,
    commune_name: "زريبة الوادي",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 245,
    code_postal: "07016",
    ok_postal_code: "7016",
    second_name: "El Feidh",
    nom: "El Feidh",
    wilaya_id: 7,
    commune_name: "الفيض",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 12:39:58",
  },
  {
    id: 246,
    code_postal: "07017",
    ok_postal_code: "7017",
    second_name: "El Kantara",
    nom: "El Kantara",
    wilaya_id: 7,
    commune_name: "القنطرة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 248,
    code_postal: "07019",
    ok_postal_code: "7019",
    second_name: "El Outaya",
    nom: "El Outaya",
    wilaya_id: 7,
    commune_name: "الوطاية",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 249,
    code_postal: "07020",
    ok_postal_code: "7020",
    second_name: "Djemorah",
    nom: "Djemorah",
    wilaya_id: 7,
    commune_name: "جمورة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 250,
    code_postal: "07021",
    ok_postal_code: "7021",
    second_name: "Tolga",
    nom: "Tolga",
    wilaya_id: 7,
    commune_name: "طولقة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 251,
    code_postal: "07022",
    ok_postal_code: "7022",
    second_name: "Lioua",
    nom: "Lioua",
    wilaya_id: 7,
    commune_name: "ليوة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 252,
    code_postal: "07023",
    ok_postal_code: "7023",
    second_name: "Lichana",
    nom: "Lichana",
    wilaya_id: 7,
    commune_name: "ليشانة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 253,
    code_postal: "07024",
    ok_postal_code: "7024",
    second_name: "Ourlal",
    nom: "Ourlal",
    wilaya_id: 7,
    commune_name: "أورلال",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 254,
    code_postal: "07025",
    ok_postal_code: "7025",
    second_name: "M'Lili",
    nom: "Mlili",
    wilaya_id: 7,
    commune_name: "مليلي",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 255,
    code_postal: "07026",
    ok_postal_code: "7026",
    second_name: "Foughala",
    nom: "Foughala",
    wilaya_id: 7,
    commune_name: "فوغالة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 256,
    code_postal: "07027",
    ok_postal_code: "7027",
    second_name: "Bordj Ben Azzouz",
    nom: "Bordj Ben Azzouz",
    wilaya_id: 7,
    commune_name: "برج بن عزوز",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 257,
    code_postal: "07028",
    ok_postal_code: "7028",
    second_name: "El Mizaraa",
    nom: "Meziraa",
    wilaya_id: 7,
    commune_name: "المزيرعة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 258,
    code_postal: "07029",
    ok_postal_code: "7029",
    second_name: "Bouchagroune",
    nom: "Bouchagroun",
    wilaya_id: 7,
    commune_name: "بوشقرون",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 259,
    code_postal: "07030",
    ok_postal_code: "7030",
    second_name: "Mekhadma",
    nom: "Mekhadma",
    wilaya_id: 7,
    commune_name: "مخادمة",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 260,
    code_postal: "07031",
    ok_postal_code: "7031",
    second_name: "El Ghrous",
    nom: "El Ghrous",
    wilaya_id: 7,
    commune_name: "الغروس",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 261,
    code_postal: "07032",
    ok_postal_code: "7032",
    second_name: "El Hadjeb",
    nom: "El Hadjab",
    wilaya_id: 7,
    commune_name: "الحاجب",
    wilaya_name: "بسكرة",
    hub_id: 26,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 263,
    code_postal: "08001",
    ok_postal_code: "8001",
    second_name: "B\u00e9char",
    nom: "Bechar",
    wilaya_id: 8,
    commune_name: "بشار",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 264,
    code_postal: "08002",
    ok_postal_code: "8002",
    second_name: "Erg Ferradj",
    nom: "Erg Ferradj",
    wilaya_id: 8,
    commune_name: "عرق فراج",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 266,
    code_postal: "08004",
    ok_postal_code: "8004",
    second_name: "Meridja",
    nom: "Meridja",
    wilaya_id: 8,
    commune_name: "المريجة",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-28 13:38:43",
  },
  {
    id: 268,
    code_postal: "08006",
    ok_postal_code: "8006",
    second_name: "Lahmar",
    nom: "Lahmar",
    wilaya_id: 8,
    commune_name: "لحمر",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-28 13:38:44",
  },
  {
    id: 271,
    code_postal: "08009",
    ok_postal_code: "8009",
    second_name: "Mechraa Houari Boumedienne",
    nom: "Mechraa Houari B",
    wilaya_id: 8,
    commune_name: "مشرع هواري بومدين",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-28 13:38:51",
  },
  {
    id: 272,
    code_postal: "08010",
    ok_postal_code: "8010",
    second_name: "Kenadsa",
    nom: "Kenedsa",
    wilaya_id: 8,
    commune_name: "القنادسة",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 275,
    code_postal: "08013",
    ok_postal_code: "8013",
    second_name: "Taghit",
    nom: "Taghit",
    wilaya_id: 8,
    commune_name: "تاغيت",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 277,
    code_postal: "08015",
    ok_postal_code: "8015",
    second_name: "Boukais",
    nom: "Boukais",
    wilaya_id: 8,
    commune_name: "بوكايس",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-28 13:38:59",
  },
  {
    id: 278,
    code_postal: "08016",
    ok_postal_code: "8016",
    second_name: "Mougheul",
    nom: "Mogheul",
    wilaya_id: 8,
    commune_name: "موغل",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-28 13:39:05",
  },
  {
    id: 279,
    code_postal: "08017",
    ok_postal_code: "8017",
    second_name: "Abadla",
    nom: "Abadla",
    wilaya_id: 8,
    commune_name: "العبادلة",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 283,
    code_postal: "08021",
    ok_postal_code: "8021",
    second_name: "Beni Ounif",
    nom: "Beni Ounif",
    wilaya_id: 8,
    commune_name: "بني ونيف",
    wilaya_name: "بشار",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 284,
    code_postal: "09001",
    ok_postal_code: "9001",
    second_name: "Blida",
    nom: "Blida",
    wilaya_id: 9,
    commune_name: "البليدة",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 285,
    code_postal: "09002",
    ok_postal_code: "9002",
    second_name: "Chebli",
    nom: "Chebli",
    wilaya_id: 9,
    commune_name: "الشبلي",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 286,
    code_postal: "09003",
    ok_postal_code: "9003",
    second_name: "Bouinan",
    nom: "Bouinan",
    wilaya_id: 9,
    commune_name: "بوعينان",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 287,
    code_postal: "09004",
    ok_postal_code: "9004",
    second_name: "Oued Alleug",
    nom: "Oued El Alleug",
    wilaya_id: 9,
    commune_name: "وادي العلايق",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 288,
    code_postal: "09007",
    ok_postal_code: "9007",
    second_name: "Ouled Ya\u00efch",
    nom: "Ouled Yaich",
    wilaya_id: 9,
    commune_name: "أولاد يعيش",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 289,
    code_postal: "09008",
    ok_postal_code: "9008",
    second_name: "Chr\u00e9a",
    nom: "Chrea",
    wilaya_id: 9,
    commune_name: "الشريعة",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 290,
    code_postal: "09010",
    ok_postal_code: "9010",
    second_name: "El Affroun",
    nom: "El Affroun",
    wilaya_id: 9,
    commune_name: "العفرون",
    wilaya_name: "البليدة",
    hub_id: 109,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 21:25:54",
  },
  {
    id: 291,
    code_postal: "09011",
    ok_postal_code: "9011",
    second_name: "Chiffa",
    nom: "Chiffa",
    wilaya_id: 9,
    commune_name: "الشفة",
    wilaya_name: "البليدة",
    hub_id: 109,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 21:25:54",
  },
  {
    id: 292,
    code_postal: "09012",
    ok_postal_code: "9012",
    second_name: "Hammam Melouane",
    nom: "Hammam Melouane",
    wilaya_id: 9,
    commune_name: "حمام ملوان",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 293,
    code_postal: "09013",
    ok_postal_code: "9013",
    second_name: "Benkhelil",
    nom: "Ben Khlil",
    wilaya_id: 9,
    commune_name: "بن خليل",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 294,
    code_postal: "09014",
    ok_postal_code: "9014",
    second_name: "Soumaa",
    nom: "Soumaa",
    wilaya_id: 9,
    commune_name: "الصومعة",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 295,
    code_postal: "09016",
    ok_postal_code: "9016",
    second_name: "Mouzaia",
    nom: "Mouzaia",
    wilaya_id: 9,
    commune_name: "موزاية",
    wilaya_name: "البليدة",
    hub_id: 109,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 21:25:54",
  },
  {
    id: 296,
    code_postal: "09017",
    ok_postal_code: "9017",
    second_name: "Souhane",
    nom: "Souhane",
    wilaya_id: 9,
    commune_name: "صوحان",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 297,
    code_postal: "09018",
    ok_postal_code: "9018",
    second_name: "Meftah",
    nom: "Meftah",
    wilaya_id: 9,
    commune_name: "مفتاح",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 298,
    code_postal: "09019",
    ok_postal_code: "9019",
    second_name: "Ouled Slama",
    nom: "Ouled Selama",
    wilaya_id: 9,
    commune_name: "اولاد سلامة",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 299,
    code_postal: "09020",
    ok_postal_code: "9020",
    second_name: "Boufarik",
    nom: "Boufarik",
    wilaya_id: 9,
    commune_name: "بوفاريك",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 300,
    code_postal: "09021",
    ok_postal_code: "9021",
    second_name: "Larbaa",
    nom: "Larbaa",
    wilaya_id: 9,
    commune_name: "الأربعاء",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 301,
    code_postal: "09022",
    ok_postal_code: "9022",
    second_name: "Oued Djer",
    nom: "Oued Djer",
    wilaya_id: 9,
    commune_name: "وادي جر",
    wilaya_name: "البليدة",
    hub_id: 109,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 21:25:54",
  },
  {
    id: 302,
    code_postal: "09023",
    ok_postal_code: "9023",
    second_name: "Beni Tamou",
    nom: "Beni Tamou",
    wilaya_id: 9,
    commune_name: "بني تامو",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 303,
    code_postal: "09024",
    ok_postal_code: "9024",
    second_name: "Bouarfa",
    nom: "Bouarfa",
    wilaya_id: 9,
    commune_name: "بوعرفة",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 304,
    code_postal: "09025",
    ok_postal_code: "9025",
    second_name: "Beni Mered",
    nom: "Beni Mered",
    wilaya_id: 9,
    commune_name: "بني مراد",
    wilaya_name: "البليدة",
    hub_id: 2,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 305,
    code_postal: "09026",
    ok_postal_code: "9026",
    second_name: "Bougara",
    nom: "Bougara",
    wilaya_id: 9,
    commune_name: "بوقرة",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 306,
    code_postal: "09027",
    ok_postal_code: "9027",
    second_name: "Guerouaou",
    nom: "Guerrouaou",
    wilaya_id: 9,
    commune_name: "قرواو",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 307,
    code_postal: "09028",
    ok_postal_code: "9028",
    second_name: "A\u00efn Romana",
    nom: "Ain Romana",
    wilaya_id: 9,
    commune_name: "عين الرمانة",
    wilaya_name: "البليدة",
    hub_id: 109,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 21:25:54",
  },
  {
    id: 308,
    code_postal: "09029",
    ok_postal_code: "9029",
    second_name: "Djebabra",
    nom: "Djebabra",
    wilaya_id: 9,
    commune_name: "جبابرة",
    wilaya_name: "البليدة",
    hub_id: 65,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 12:11:49",
  },
  {
    id: 309,
    code_postal: "10001",
    ok_postal_code: "10001",
    second_name: "Bouira",
    nom: "Bouira",
    wilaya_id: 10,
    commune_name: "البويرة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 310,
    code_postal: "10002",
    ok_postal_code: "10002",
    second_name: "El Asnam",
    nom: "El Asnam",
    wilaya_id: 10,
    commune_name: "الأسنام",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 311,
    code_postal: "10003",
    ok_postal_code: "10003",
    second_name: "Guerrouma",
    nom: "Guerrouma",
    wilaya_id: 10,
    commune_name: "قرومة",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 312,
    code_postal: "10004",
    ok_postal_code: "10004",
    second_name: "Souk El Khemis",
    nom: "Souk El Khemis",
    wilaya_id: 10,
    commune_name: "سوق الخميس",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 313,
    code_postal: "10005",
    ok_postal_code: "10005",
    second_name: "Kadiria",
    nom: "Kadiria",
    wilaya_id: 10,
    commune_name: "قادرية",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 314,
    code_postal: "10006",
    ok_postal_code: "10006",
    second_name: "Hanif",
    nom: "Hanif",
    wilaya_id: 10,
    commune_name: "حنيف",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 315,
    code_postal: "10007",
    ok_postal_code: "10007",
    second_name: "Dirrah",
    nom: "Dirah",
    wilaya_id: 10,
    commune_name: "ديرة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 316,
    code_postal: "10008",
    ok_postal_code: "10008",
    second_name: "A\u00eft Laziz",
    nom: "Ait Laaziz",
    wilaya_id: 10,
    commune_name: "أيت لعزيز",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 317,
    code_postal: "10009",
    ok_postal_code: "10009",
    second_name: "Taghzout",
    nom: "Taghzout",
    wilaya_id: 10,
    commune_name: "تاغزوت",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 318,
    code_postal: "10010",
    ok_postal_code: "10010",
    second_name: "Raouraoua",
    nom: "Raouraoua",
    wilaya_id: 10,
    commune_name: "روراوة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 319,
    code_postal: "10011",
    ok_postal_code: "10011",
    second_name: "Mezdour",
    nom: "Mezdour",
    wilaya_id: 10,
    commune_name: "مزدور",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 320,
    code_postal: "10012",
    ok_postal_code: "10012",
    second_name: "Haizer",
    nom: "Haizer",
    wilaya_id: 10,
    commune_name: "حيزر",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 321,
    code_postal: "10013",
    ok_postal_code: "10013",
    second_name: "Lakhdaria",
    nom: "Lakhdaria",
    wilaya_id: 10,
    commune_name: "الأخضرية",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 322,
    code_postal: "10014",
    ok_postal_code: "10014",
    second_name: "Maala",
    nom: "Maala",
    wilaya_id: 10,
    commune_name: "معلة",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 323,
    code_postal: "10015",
    ok_postal_code: "10015",
    second_name: "El Hachimia",
    nom: "El Hachimia",
    wilaya_id: 10,
    commune_name: "الهاشمية",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 324,
    code_postal: "10016",
    ok_postal_code: "10016",
    second_name: "Aomar",
    nom: "Aomar",
    wilaya_id: 10,
    commune_name: "أعمر",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 325,
    code_postal: "10017",
    ok_postal_code: "10017",
    second_name: "Chorfa",
    nom: "Chorfa",
    wilaya_id: 10,
    commune_name: "شرفة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 326,
    code_postal: "10018",
    ok_postal_code: "10018",
    second_name: "Bordj Okhriss",
    nom: "Bordj Oukhriss",
    wilaya_id: 10,
    commune_name: "برج أوخريص",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 327,
    code_postal: "10019",
    ok_postal_code: "10019",
    second_name: "El Adjiba",
    nom: "El Adjiba",
    wilaya_id: 10,
    commune_name: "العجيبة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 328,
    code_postal: "10020",
    ok_postal_code: "10020",
    second_name: "El Hakimia",
    nom: "El Hakimia",
    wilaya_id: 10,
    commune_name: "الحاكمية",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 329,
    code_postal: "10021",
    ok_postal_code: "10021",
    second_name: "El Khabouzia",
    nom: "El Khebouzia",
    wilaya_id: 10,
    commune_name: "الخبوزية",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 330,
    code_postal: "10022",
    ok_postal_code: "10022",
    second_name: "Ahl El Ksar",
    nom: "Ahl El Ksar",
    wilaya_id: 10,
    commune_name: "أهل القصر",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 331,
    code_postal: "10023",
    ok_postal_code: "10023",
    second_name: "Bouderbala",
    nom: "Bouderbala",
    wilaya_id: 10,
    commune_name: "بودربالة",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 332,
    code_postal: "10024",
    ok_postal_code: "10024",
    second_name: "Zbarbar",
    nom: "Zbarbar",
    wilaya_id: 10,
    commune_name: "زبربر",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 333,
    code_postal: "10025",
    ok_postal_code: "10025",
    second_name: "A\u00efn El Hadjar",
    nom: "Ain El Hadjar",
    wilaya_id: 10,
    commune_name: "عين الحجر",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 334,
    code_postal: "10026",
    ok_postal_code: "10026",
    second_name: "Djebahia",
    nom: "Djebahia",
    wilaya_id: 10,
    commune_name: "جباحية",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 335,
    code_postal: "10027",
    ok_postal_code: "10027",
    second_name: "Aghbalou",
    nom: "Aghbalou",
    wilaya_id: 10,
    commune_name: "أغبالو",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 336,
    code_postal: "10028",
    ok_postal_code: "10028",
    second_name: "Taguedit",
    nom: "Taguedit",
    wilaya_id: 10,
    commune_name: "تاقديت",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 337,
    code_postal: "10029",
    ok_postal_code: "10029",
    second_name: "A\u00efn El Turc",
    nom: "Ain Turk",
    wilaya_id: 10,
    commune_name: "عين الترك",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 338,
    code_postal: "10030",
    ok_postal_code: "10030",
    second_name: "Saharidj",
    nom: "Saharidj",
    wilaya_id: 10,
    commune_name: "سحاريج",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 339,
    code_postal: "10031",
    ok_postal_code: "10031",
    second_name: "Dechmia",
    nom: "Dechmia",
    wilaya_id: 10,
    commune_name: "الدشمية",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 340,
    code_postal: "10032",
    ok_postal_code: "10032",
    second_name: "Ridane",
    nom: "Ridane",
    wilaya_id: 10,
    commune_name: "ريدان",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 341,
    code_postal: "10033",
    ok_postal_code: "10033",
    second_name: "Bechloul",
    nom: "Bechloul",
    wilaya_id: 10,
    commune_name: "بشلول",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 342,
    code_postal: "10034",
    ok_postal_code: "10034",
    second_name: "Boukram",
    nom: "Boukram",
    wilaya_id: 10,
    commune_name: "بوكرم",
    wilaya_name: "البويرة",
    hub_id: 100,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-26 18:04:06",
  },
  {
    id: 343,
    code_postal: "10035",
    ok_postal_code: "10035",
    second_name: "A\u00efn Bessem",
    nom: "Ain Bessam",
    wilaya_id: 10,
    commune_name: "عين بسام",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 344,
    code_postal: "10036",
    ok_postal_code: "10036",
    second_name: "Bir Ghbalou",
    nom: "Bir Ghbalou",
    wilaya_id: 10,
    commune_name: "بئر غبالو",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 345,
    code_postal: "10037",
    ok_postal_code: "10037",
    second_name: "M'Chedallah",
    nom: "Mchedallah",
    wilaya_id: 10,
    commune_name: "أمشدالة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 346,
    code_postal: "10038",
    ok_postal_code: "10038",
    second_name: "Sour El Ghouzlane",
    nom: "Sour El Ghozlane",
    wilaya_id: 10,
    commune_name: "سور الغزلان",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 347,
    code_postal: "10039",
    ok_postal_code: "10039",
    second_name: "Maamora",
    nom: "Maamora",
    wilaya_id: 10,
    commune_name: "المعمورة",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 348,
    code_postal: "10040",
    ok_postal_code: "10040",
    second_name: "Ouled Rached",
    nom: "Ouled Rached",
    wilaya_id: 10,
    commune_name: "أولاد راشد",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 349,
    code_postal: "10041",
    ok_postal_code: "10041",
    second_name: "A\u00efn Laloui",
    nom: "Ain Laloui",
    wilaya_id: 10,
    commune_name: "عين العلوي",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 350,
    code_postal: "10042",
    ok_postal_code: "10042",
    second_name: "Hadjera Zerga",
    nom: "Hadjera Zerga",
    wilaya_id: 10,
    commune_name: "الحجرة الزرقاء",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 351,
    code_postal: "10043",
    ok_postal_code: "10043",
    second_name: "Ath Mansour",
    nom: "Ath Mansour",
    wilaya_id: 10,
    commune_name: "آث  منصور",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 352,
    code_postal: "10044",
    ok_postal_code: "10044",
    second_name: "El Mokrani",
    nom: "El Mokrani",
    wilaya_id: 10,
    commune_name: "المقراني",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 353,
    code_postal: "10045",
    ok_postal_code: "10045",
    second_name: "Oued El Berdi",
    nom: "Oued El Berdi",
    wilaya_id: 10,
    commune_name: "وادي البردي",
    wilaya_name: "البويرة",
    hub_id: 28,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 354,
    code_postal: "11001",
    ok_postal_code: "11001",
    second_name: "Tamanrasset",
    nom: "Tamanghasset",
    wilaya_id: 11,
    commune_name: "تمنراست",
    wilaya_name: "تمنراست",
    hub_id: 13,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 364,
    code_postal: "12001",
    ok_postal_code: "12001",
    second_name: "T\u00e9bessa",
    nom: "Tebessa",
    wilaya_id: 12,
    commune_name: "تبسة",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:38:29",
  },
  {
    id: 365,
    code_postal: "12002",
    ok_postal_code: "12002",
    second_name: "Bir el Ater",
    nom: "Bir El Ater",
    wilaya_id: 12,
    commune_name: "بئر العاتر",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 00:25:56",
  },
  {
    id: 366,
    code_postal: "12003",
    ok_postal_code: "12003",
    second_name: "Cheria",
    nom: "Cheria",
    wilaya_id: 12,
    commune_name: "الشريعة",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:38:55",
  },
  {
    id: 367,
    code_postal: "12004",
    ok_postal_code: "12004",
    second_name: "Stah Guentis",
    nom: "Stah Guentis",
    wilaya_id: 12,
    commune_name: "سطح قنطيس",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:38:58",
  },
  {
    id: 368,
    code_postal: "12005",
    ok_postal_code: "12005",
    second_name: "El Aouinet",
    nom: "El Aouinet",
    wilaya_id: 12,
    commune_name: "العوينات",
    wilaya_name: "تبسة",
    hub_id: 107,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 00:36:08",
  },
  {
    id: 369,
    code_postal: "12006",
    ok_postal_code: "12006",
    second_name: "El Houidjbet",
    nom: "Lahouidjbet",
    wilaya_id: 12,
    commune_name: "الحويجبات",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:01",
  },
  {
    id: 370,
    code_postal: "12007",
    ok_postal_code: "12007",
    second_name: "Safsaf El Ouesra",
    nom: "Safsaf El Ouesra",
    wilaya_id: 12,
    commune_name: "صفصاف الوسرى",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 00:25:56",
  },
  {
    id: 371,
    code_postal: "12008",
    ok_postal_code: "12008",
    second_name: "Hammamet",
    nom: "Hammamet",
    wilaya_id: 12,
    commune_name: "الحمامات",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:07",
  },
  {
    id: 372,
    code_postal: "12009",
    ok_postal_code: "12009",
    second_name: "Negrine",
    nom: "Negrine",
    wilaya_id: 12,
    commune_name: "نقرين",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 00:36:45",
  },
  {
    id: 373,
    code_postal: "12010",
    ok_postal_code: "12010",
    second_name: "Bir Mokkadem",
    nom: "Bir El Mokadem",
    wilaya_id: 12,
    commune_name: "بئر مقدم",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:17",
  },
  {
    id: 374,
    code_postal: "12011",
    ok_postal_code: "12011",
    second_name: "El Kouif",
    nom: "El Kouif",
    wilaya_id: 12,
    commune_name: "الكويف",
    wilaya_name: "تبسة",
    hub_id: 107,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-24 15:44:48",
  },
  {
    id: 375,
    code_postal: "12012",
    ok_postal_code: "12012",
    second_name: "Morsott",
    nom: "Morsott",
    wilaya_id: 12,
    commune_name: "مرسط",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:21",
  },
  {
    id: 376,
    code_postal: "12013",
    ok_postal_code: "12013",
    second_name: "El Ogla",
    nom: "El Ogla",
    wilaya_id: 12,
    commune_name: "العقلة",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 08:57:28",
  },
  {
    id: 377,
    code_postal: "12014",
    ok_postal_code: "12014",
    second_name: "Bir Dheb",
    nom: "Bir Dheheb",
    wilaya_id: 12,
    commune_name: "بئر الذهب",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:24",
  },
  {
    id: 378,
    code_postal: "12015",
    ok_postal_code: "12015",
    second_name: "Ogla Melha",
    nom: "El Ogla El Malha",
    wilaya_id: 12,
    commune_name: "العقلة المالحة",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 08:57:11",
  },
  {
    id: 379,
    code_postal: "12016",
    ok_postal_code: "12016",
    second_name: "Guorriguer",
    nom: "Gorriguer",
    wilaya_id: 12,
    commune_name: "قريقر",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:36",
  },
  {
    id: 380,
    code_postal: "12017",
    ok_postal_code: "12017",
    second_name: "Bekkaria",
    nom: "Bekkaria",
    wilaya_id: 12,
    commune_name: "بكارية",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:39",
  },
  {
    id: 381,
    code_postal: "12018",
    ok_postal_code: "12018",
    second_name: "Boukhadra",
    nom: "Boukhadra",
    wilaya_id: 12,
    commune_name: "بوخضرة",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:41",
  },
  {
    id: 382,
    code_postal: "12019",
    ok_postal_code: "12019",
    second_name: "Ouenza",
    nom: "Ouenza",
    wilaya_id: 12,
    commune_name: "الونزة",
    wilaya_name: "تبسة",
    hub_id: 107,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 00:36:50",
  },
  {
    id: 383,
    code_postal: "12020",
    ok_postal_code: "12020",
    second_name: "El Ma Labiodh",
    nom: "El Ma El Biodh",
    wilaya_id: 12,
    commune_name: "الماء الابيض",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:39:45",
  },
  {
    id: 384,
    code_postal: "12021",
    ok_postal_code: "12021",
    second_name: "Oum Ali",
    nom: "Oum Ali",
    wilaya_id: 12,
    commune_name: "أم علي",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 00:25:56",
  },
  {
    id: 385,
    code_postal: "12022",
    ok_postal_code: "12022",
    second_name: "Tlidjene",
    nom: "Thlidjene",
    wilaya_id: 12,
    commune_name: "ثليجان",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:40:02",
  },
  {
    id: 386,
    code_postal: "12023",
    ok_postal_code: "12023",
    second_name: "A\u00efn Zerga",
    nom: "Ain Zerga",
    wilaya_id: 12,
    commune_name: "عين الزرقاء",
    wilaya_name: "تبسة",
    hub_id: 107,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 10:17:27",
  },
  {
    id: 387,
    code_postal: "12024",
    ok_postal_code: "12024",
    second_name: "El Meridj",
    nom: "El Meridj",
    wilaya_id: 12,
    commune_name: "المريج",
    wilaya_name: "تبسة",
    hub_id: 107,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 00:36:39",
  },
  {
    id: 388,
    code_postal: "12025",
    ok_postal_code: "12025",
    second_name: "Boulhaf Dir",
    nom: "Boulhaf Dyr",
    wilaya_id: 12,
    commune_name: "بولحاف الدير",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:40:08",
  },
  {
    id: 389,
    code_postal: "12026",
    ok_postal_code: "12026",
    second_name: "Bedjene",
    nom: "Bedjene",
    wilaya_id: 12,
    commune_name: "بجن",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:40:11",
  },
  {
    id: 390,
    code_postal: "12027",
    ok_postal_code: "12027",
    second_name: "El Mezeraa",
    nom: "El Mazeraa",
    wilaya_id: 12,
    commune_name: "المزرعة",
    wilaya_name: "تبسة",
    hub_id: 29,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-18 01:40:13",
  },
  {
    id: 391,
    code_postal: "12028",
    ok_postal_code: "12028",
    second_name: "Ferkane",
    nom: "Ferkane",
    wilaya_id: 12,
    commune_name: "فركان",
    wilaya_name: "تبسة",
    hub_id: 117,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-05 00:36:45",
  },
  {
    id: 392,
    code_postal: "13001",
    ok_postal_code: "13001",
    second_name: "Tlemcen",
    nom: "Tlemcen",
    wilaya_id: 13,
    commune_name: "تلمسان",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 393,
    code_postal: "13002",
    ok_postal_code: "13002",
    second_name: "Beni Mester",
    nom: "Beni Mester",
    wilaya_id: 13,
    commune_name: "بني مستر",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 394,
    code_postal: "13003",
    ok_postal_code: "13003",
    second_name: "A\u00efn Tallout",
    nom: "Ain Tallout",
    wilaya_id: 13,
    commune_name: "عين تالوت",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 395,
    code_postal: "13004",
    ok_postal_code: "13004",
    second_name: "Remchi",
    nom: "Remchi",
    wilaya_id: 13,
    commune_name: "الرمشي",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 396,
    code_postal: "13005",
    ok_postal_code: "13005",
    second_name: "El Fehoul",
    nom: "El Fehoul",
    wilaya_id: 13,
    commune_name: "الفحول",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 397,
    code_postal: "13006",
    ok_postal_code: "13006",
    second_name: "Sabra",
    nom: "Sabra",
    wilaya_id: 13,
    commune_name: "صبرة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 398,
    code_postal: "13007",
    ok_postal_code: "13007",
    second_name: "Ghazaouet",
    nom: "Ghazaouet",
    wilaya_id: 13,
    commune_name: "الغزوات",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 399,
    code_postal: "13008",
    ok_postal_code: "13008",
    second_name: "Souani",
    nom: "Souani",
    wilaya_id: 13,
    commune_name: "السواني",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 400,
    code_postal: "13009",
    ok_postal_code: "13009",
    second_name: "Djebala",
    nom: "Djebala",
    wilaya_id: 13,
    commune_name: "جبالة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 401,
    code_postal: "13010",
    ok_postal_code: "13010",
    second_name: "El Gor",
    nom: "El Gor",
    wilaya_id: 13,
    commune_name: "القور",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 402,
    code_postal: "13011",
    ok_postal_code: "13011",
    second_name: "Oued Lakhdar",
    nom: "Oued Chouly",
    wilaya_id: 13,
    commune_name: "وادي الخضر",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 403,
    code_postal: "13012",
    ok_postal_code: "13012",
    second_name: "A\u00efn Fezza",
    nom: "Ain Fezza",
    wilaya_id: 13,
    commune_name: "عين فزة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 404,
    code_postal: "13013",
    ok_postal_code: "13013",
    second_name: "Ouled Mimoun",
    nom: "Ouled Mimoun",
    wilaya_id: 13,
    commune_name: "أولاد ميمون",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 405,
    code_postal: "13014",
    ok_postal_code: "13014",
    second_name: "Amieur",
    nom: "Amieur",
    wilaya_id: 13,
    commune_name: "عمير",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 406,
    code_postal: "13015",
    ok_postal_code: "13015",
    second_name: "A\u00efn Youcef",
    nom: "Ain Youcef",
    wilaya_id: 13,
    commune_name: "عين يوسف",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 407,
    code_postal: "13016",
    ok_postal_code: "13016",
    second_name: "Zenata",
    nom: "Zenata",
    wilaya_id: 13,
    commune_name: "زناتة",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 408,
    code_postal: "13017",
    ok_postal_code: "13017",
    second_name: "Beni Snous",
    nom: "Beni Snous",
    wilaya_id: 13,
    commune_name: "بني سنوس",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 409,
    code_postal: "13018",
    ok_postal_code: "13018",
    second_name: "Bab El Assa",
    nom: "Bab El Assa",
    wilaya_id: 13,
    commune_name: "باب العسة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 410,
    code_postal: "13019",
    ok_postal_code: "13019",
    second_name: "Dar Yaghmouracene",
    nom: "Dar Yaghmouracene",
    wilaya_id: 13,
    commune_name: "دار يغمراسن",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 411,
    code_postal: "13020",
    ok_postal_code: "13020",
    second_name: "Fellaoucene",
    nom: "Fellaoucene",
    wilaya_id: 13,
    commune_name: "فلاوسن",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 412,
    code_postal: "13021",
    ok_postal_code: "13021",
    second_name: "Azails",
    nom: "Azails",
    wilaya_id: 13,
    commune_name: "العزايل",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 413,
    code_postal: "13022",
    ok_postal_code: "13022",
    second_name: "Sebaa Chioukh",
    nom: "Sebbaa Chioukh",
    wilaya_id: 13,
    commune_name: "سبعة شيوخ",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 414,
    code_postal: "13023",
    ok_postal_code: "13023",
    second_name: "Terny Beni Hdiel",
    nom: "Terni Beni Hediel",
    wilaya_id: 13,
    commune_name: "تيرني بني هديل",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 415,
    code_postal: "13024",
    ok_postal_code: "13024",
    second_name: "Bensekrane",
    nom: "Bensekrane",
    wilaya_id: 13,
    commune_name: "بن سكران",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 416,
    code_postal: "13025",
    ok_postal_code: "13025",
    second_name: "A\u00efn Nehala",
    nom: "Ain Nehala",
    wilaya_id: 13,
    commune_name: "عين النحالة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 417,
    code_postal: "13026",
    ok_postal_code: "13026",
    second_name: "Hennaya",
    nom: "Hennaya",
    wilaya_id: 13,
    commune_name: "الحناية",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 418,
    code_postal: "13027",
    ok_postal_code: "13027",
    second_name: "Maghnia",
    nom: "Maghnia",
    wilaya_id: 13,
    commune_name: "مغنية",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 419,
    code_postal: "13028",
    ok_postal_code: "13028",
    second_name: "Hammam Boughrara",
    nom: "Hammam Boughrara",
    wilaya_id: 13,
    commune_name: "حمام بوغرارة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 420,
    code_postal: "13029",
    ok_postal_code: "13029",
    second_name: "Souahlia",
    nom: "Souahlia",
    wilaya_id: 13,
    commune_name: "السواحلية",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 421,
    code_postal: "13030",
    ok_postal_code: "13030",
    second_name: "MSirda Fouaga",
    nom: "Msirda Fouaga",
    wilaya_id: 13,
    commune_name: "مسيردة الفواقة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 422,
    code_postal: "13031",
    ok_postal_code: "13031",
    second_name: "A\u00efn Fetah",
    nom: "Ain Fetah",
    wilaya_id: 13,
    commune_name: "عين فتاح",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 423,
    code_postal: "13032",
    ok_postal_code: "13032",
    second_name: "El Aricha",
    nom: "El Aricha",
    wilaya_id: 13,
    commune_name: "العريشة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 424,
    code_postal: "13033",
    ok_postal_code: "13033",
    second_name: "Souk Tlata",
    nom: "Souk Thlata",
    wilaya_id: 13,
    commune_name: "سوق الثلاثاء",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 425,
    code_postal: "13034",
    ok_postal_code: "13034",
    second_name: "Sidi Abdelli",
    nom: "Sidi Abdelli",
    wilaya_id: 13,
    commune_name: "سيدي العبدلي",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 426,
    code_postal: "13035",
    ok_postal_code: "13035",
    second_name: "Sebdou",
    nom: "Sebdou",
    wilaya_id: 13,
    commune_name: "سبدو",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 427,
    code_postal: "13036",
    ok_postal_code: "13036",
    second_name: "Beni Ouarsous",
    nom: "Beni Ouarsous",
    wilaya_id: 13,
    commune_name: "بني وارسوس",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 428,
    code_postal: "13037",
    ok_postal_code: "13037",
    second_name: "Sidi Medjahed",
    nom: "Sidi Medjahed",
    wilaya_id: 13,
    commune_name: "سيدي مجاهد",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 429,
    code_postal: "13038",
    ok_postal_code: "13038",
    second_name: "Beni Boussaid",
    nom: "Beni Boussaid",
    wilaya_id: 13,
    commune_name: "بني بوسعيد",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 430,
    code_postal: "13039",
    ok_postal_code: "13039",
    second_name: "Marsa Ben M'Hidi",
    nom: "Marsa Ben Mhidi",
    wilaya_id: 13,
    commune_name: "مرسى بن مهيدي",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 431,
    code_postal: "13040",
    ok_postal_code: "13040",
    second_name: "Nedroma",
    nom: "Nedroma",
    wilaya_id: 13,
    commune_name: "ندرومة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 432,
    code_postal: "13041",
    ok_postal_code: "13041",
    second_name: "Sidi Djillali",
    nom: "Sidi Djillali",
    wilaya_id: 13,
    commune_name: "سيدي الجيلالي",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 433,
    code_postal: "13042",
    ok_postal_code: "13042",
    second_name: "Beni Bahdel",
    nom: "Beni Bahdel",
    wilaya_id: 13,
    commune_name: "بني بهدل",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 434,
    code_postal: "13043",
    ok_postal_code: "13043",
    second_name: "El Bouihi",
    nom: "El Bouihi",
    wilaya_id: 13,
    commune_name: "البويهي",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 12:15:05",
  },
  {
    id: 435,
    code_postal: "13044",
    ok_postal_code: "13044",
    second_name: "Hona\u00efne",
    nom: "Honaine",
    wilaya_id: 13,
    commune_name: "هنين",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 436,
    code_postal: "13045",
    ok_postal_code: "13045",
    second_name: "Tienet",
    nom: "Tianet",
    wilaya_id: 13,
    commune_name: "تيانت",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 437,
    code_postal: "13046",
    ok_postal_code: "13046",
    second_name: "Ouled Riyah",
    nom: "Ouled Riyah",
    wilaya_id: 13,
    commune_name: "أولاد رياح",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 438,
    code_postal: "13047",
    ok_postal_code: "13047",
    second_name: "Bouhlou",
    nom: "Bouhlou",
    wilaya_id: 13,
    commune_name: "بوحلو",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 439,
    code_postal: "13048",
    ok_postal_code: "13048",
    second_name: "Souk El Khemis",
    nom: "Souk El Khemis",
    wilaya_id: 13,
    commune_name: "السواني",
    wilaya_name: "تلمسان",

    // TODO(arabic-match): "Souk El Khemis". done
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 440,
    code_postal: "13049",
    ok_postal_code: "13049",
    second_name: "A\u00efn Ghoraba",
    nom: "Ain Ghoraba",
    wilaya_id: 13,
    commune_name: "عين غرابة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 441,
    code_postal: "13050",
    ok_postal_code: "13050",
    second_name: "Chetouane",
    nom: "Chetouane",
    wilaya_id: 13,
    commune_name: "شتوان",
    wilaya_name: "تلمسان",
    hub_id: 9,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 442,
    code_postal: "13051",
    ok_postal_code: "13051",
    second_name: "Mansourah",
    nom: "Mansourah",
    wilaya_id: 13,
    commune_name: "منصورة",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 443,
    code_postal: "13052",
    ok_postal_code: "13052",
    second_name: "Beni Semiel",
    nom: "Beni Semiel",
    wilaya_id: 13,
    commune_name: "بني صميل",
    wilaya_name: "تلمسان",
    hub_id: 110,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 13:15:00",
  },
  {
    id: 444,
    code_postal: "13053",
    ok_postal_code: "13053",
    second_name: "A\u00efn Kebira",
    nom: "Ain Kebira",
    wilaya_id: 13,
    commune_name: "عين الكبيرة",
    wilaya_name: "تلمسان",
    hub_id: 71,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:24:34",
  },
  {
    id: 445,
    code_postal: "14001",
    ok_postal_code: "14001",
    second_name: "Tiaret",
    nom: "Tiaret",
    wilaya_id: 14,
    commune_name: "تيارت",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:07:29",
  },
  {
    id: 446,
    code_postal: "14002",
    ok_postal_code: "14002",
    second_name: "Medroussa",
    nom: "Medroussa",
    wilaya_id: 14,
    commune_name: "مدروسة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 447,
    code_postal: "14003",
    ok_postal_code: "14003",
    second_name: "A\u00efn Bouchekif",
    nom: "Ain Bouchekif",
    wilaya_id: 14,
    commune_name: "عين بوشقيف",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:07:39",
  },
  {
    id: 448,
    code_postal: "14004",
    ok_postal_code: "14004",
    second_name: "Sidi Ali Mellal",
    nom: "Sidi Ali Mellal",
    wilaya_id: 14,
    commune_name: "سيدي علي ملال",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:07:42",
  },
  {
    id: 449,
    code_postal: "14005",
    ok_postal_code: "14005",
    second_name: "A\u00efn Dzarit",
    nom: "Ain Zarit",
    wilaya_id: 14,
    commune_name: "عين دزاريت",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:07:46",
  },
  {
    id: 450,
    code_postal: "14006",
    ok_postal_code: "14006",
    second_name: "A\u00efn Deheb",
    nom: "Ain Deheb",
    wilaya_id: 14,
    commune_name: "عين الذهب",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 451,
    code_postal: "14007",
    ok_postal_code: "14007",
    second_name: "Sidi Bakhti",
    nom: "Sidi Bakhti",
    wilaya_id: 14,
    commune_name: "سيدي بختي",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 452,
    code_postal: "14008",
    ok_postal_code: "14008",
    second_name: "Medrissa",
    nom: "Medrissa",
    wilaya_id: 14,
    commune_name: "مدريسة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 453,
    code_postal: "14009",
    ok_postal_code: "14009",
    second_name: "Zmalet El Emir Abdelkader",
    nom: "Zmalet El Emir Aek",
    wilaya_id: 14,
    commune_name: "زمالة  الأمير عبد القادر",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 454,
    code_postal: "14010",
    ok_postal_code: "14010",
    second_name: "Madna",
    nom: "Madna",
    wilaya_id: 14,
    commune_name: "مادنة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 455,
    code_postal: "14011",
    ok_postal_code: "14011",
    second_name: "Sebt",
    nom: "Sebt",
    wilaya_id: 14,
    commune_name: "السبت",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:04",
  },
  {
    id: 456,
    code_postal: "14012",
    ok_postal_code: "14012",
    second_name: "Mellakou",
    nom: "Mellakou",
    wilaya_id: 14,
    commune_name: "ملاكو",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 457,
    code_postal: "14013",
    ok_postal_code: "14013",
    second_name: "Dahmouni",
    nom: "Dahmouni",
    wilaya_id: 14,
    commune_name: "دحموني",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:12",
  },
  {
    id: 458,
    code_postal: "14014",
    ok_postal_code: "14014",
    second_name: "Rahouia",
    nom: "Rahouia",
    wilaya_id: 14,
    commune_name: "الرحوية",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:16",
  },
  {
    id: 459,
    code_postal: "14015",
    ok_postal_code: "14015",
    second_name: "Mahdia",
    nom: "Mahdia",
    wilaya_id: 14,
    commune_name: "مهدية",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:22",
  },
  {
    id: 460,
    code_postal: "14016",
    ok_postal_code: "14016",
    second_name: "Sougueur",
    nom: "Sougueur",
    wilaya_id: 14,
    commune_name: "السوقر",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:33",
  },
  {
    id: 461,
    code_postal: "14017",
    ok_postal_code: "14017",
    second_name: "Si Abdelghani",
    nom: "Sidi Abdelghani",
    wilaya_id: 14,
    commune_name: "سي عبد الغني",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:39",
  },
  {
    id: 462,
    code_postal: "14018",
    ok_postal_code: "14018",
    second_name: "A\u00efn El Hadid",
    nom: "Ain El Hadid",
    wilaya_id: 14,
    commune_name: "عين الحديد",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 463,
    code_postal: "14019",
    ok_postal_code: "14019",
    second_name: null,
    nom: "Ouled Djerad",
    wilaya_id: 14,
    commune_name: "مدريسة",
    wilaya_name: "تيارت",
    // TODO(arabic-match):  "Ouled Djerad". done
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 23:11:15",
  },
  {
    id: 464,
    code_postal: "14020",
    ok_postal_code: "14020",
    second_name: "Naima",
    nom: "Naima",
    wilaya_id: 14,
    commune_name: "النعيمة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:09:57",
  },
  {
    id: 465,
    code_postal: "14021",
    ok_postal_code: "14021",
    second_name: "Meghila",
    nom: "Meghila",
    wilaya_id: 14,
    commune_name: "مغيلة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:10:18",
  },
  {
    id: 466,
    code_postal: "14022",
    ok_postal_code: "14022",
    second_name: "Guertoufa",
    nom: "Guertoufa",
    wilaya_id: 14,
    commune_name: "قرطوفة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:10:23",
  },
  {
    id: 467,
    code_postal: "14023",
    ok_postal_code: "14023",
    second_name: "Sidi Hosni",
    nom: "Sidi Hosni",
    wilaya_id: 14,
    commune_name: "سيدي حسني",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:10:36",
  },
  {
    id: 468,
    code_postal: "14024",
    ok_postal_code: "14024",
    second_name: "Djillali Ben Amar",
    nom: "Djillali Ben Amar",
    wilaya_id: 14,
    commune_name: "جيلالي بن عمار",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 469,
    code_postal: "14025",
    ok_postal_code: "14025",
    second_name: "Sebaine",
    nom: "Sebaine",
    wilaya_id: 14,
    commune_name: "السبعين",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:11:02",
  },
  {
    id: 470,
    code_postal: "14026",
    ok_postal_code: "14026",
    second_name: "Tousnina",
    nom: "Tousnina",
    wilaya_id: 14,
    commune_name: "توسنينة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 471,
    code_postal: "14027",
    ok_postal_code: "14027",
    second_name: "Frenda",
    nom: "Frenda",
    wilaya_id: 14,
    commune_name: "فرندة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 472,
    code_postal: "14028",
    ok_postal_code: "14028",
    second_name: "A\u00efn Kermes",
    nom: "Ain Kermes",
    wilaya_id: 14,
    commune_name: "عين كرمس",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 473,
    code_postal: "14029",
    ok_postal_code: "14029",
    second_name: "Ksar Chellala",
    nom: "Ksar Chellala",
    wilaya_id: 14,
    commune_name: "قصر الشلالة",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 474,
    code_postal: "14030",
    ok_postal_code: "14030",
    second_name: "Rechaiga",
    nom: "Rechaiga",
    wilaya_id: 14,
    commune_name: "الرشايقة",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 475,
    code_postal: "14031",
    ok_postal_code: "14031",
    second_name: "Nadorah",
    nom: "Nadorah",
    wilaya_id: 14,
    commune_name: "الناظورة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:12:28",
  },
  {
    id: 476,
    code_postal: "14032",
    ok_postal_code: "14032",
    second_name: "Tagdemt",
    nom: "Tagdemt",
    wilaya_id: 14,
    commune_name: "تاقدمت",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:12:48",
  },
  {
    id: 477,
    code_postal: "14033",
    ok_postal_code: "14033",
    second_name: "Oued Lilli",
    nom: "Oued Lilli",
    wilaya_id: 14,
    commune_name: "وادي ليلي",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:13:00",
  },
  {
    id: 478,
    code_postal: "14034",
    ok_postal_code: "14034",
    second_name: "Mechraa Safa",
    nom: "Mechraa Safa",
    wilaya_id: 14,
    commune_name: "مشرع الصفا",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 479,
    code_postal: "14035",
    ok_postal_code: "14035",
    second_name: "Hamadia",
    nom: "Hamadia",
    wilaya_id: 14,
    commune_name: "حمادية",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 480,
    code_postal: "14036",
    ok_postal_code: "14036",
    second_name: "Chehaima",
    nom: "Chehaima",
    wilaya_id: 14,
    commune_name: "شحيمة",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 481,
    code_postal: "14037",
    ok_postal_code: "14037",
    second_name: "Takhemaret",
    nom: "Takhemaret",
    wilaya_id: 14,
    commune_name: "تخمرت",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 482,
    code_postal: "14038",
    ok_postal_code: "14038",
    second_name: "Sidi Abderahmane",
    nom: "Sidi Abderrahmane",
    wilaya_id: 14,
    commune_name: "سيدي عبد الرحمن",
    wilaya_name: "تيارت",
    hub_id: 94,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-03 21:41:30",
  },
  {
    id: 483,
    code_postal: "14039",
    ok_postal_code: "14039",
    second_name: "Serghine",
    nom: "Serghine",
    wilaya_id: 14,
    commune_name: "سرغين",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 484,
    code_postal: "14040",
    ok_postal_code: "14040",
    second_name: "Bougara",
    nom: "Bougara",
    wilaya_id: 14,
    commune_name: "بوقرة",
    wilaya_name: "تيارت",
    hub_id: 118,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 22:13:25",
  },
  {
    id: 485,
    code_postal: "14041",
    ok_postal_code: "14041",
    second_name: "Faidja",
    nom: "Faidja",
    wilaya_id: 14,
    commune_name: "الفايجة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:08:00",
  },
  {
    id: 486,
    code_postal: "14042",
    ok_postal_code: "14042",
    second_name: "Tidda",
    nom: "Tidda",
    wilaya_id: 14,
    commune_name: "تيدة",
    wilaya_name: "تيارت",
    hub_id: 19,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 16:07:54",
  },
  {
    id: 487,
    code_postal: "15001",
    ok_postal_code: "15001",
    second_name: "Tizi Ouzou",
    nom: "Tizi Ouzou",
    wilaya_id: 15,
    commune_name: "تيزي وزو",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 488,
    code_postal: "15002",
    ok_postal_code: "15002",
    second_name: "Ain El Hammam",
    nom: "Ain El Hammam",
    wilaya_id: 15,
    commune_name: "عين الحمام",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 489,
    code_postal: "15003",
    ok_postal_code: "15003",
    second_name: "Akbil",
    nom: "Akbil",
    wilaya_id: 15,
    commune_name: "اقبيل",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 490,
    code_postal: "15004",
    ok_postal_code: "15004",
    second_name: "Freha",
    nom: "Freha",
    wilaya_id: 15,
    commune_name: "فريحة",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 491,
    code_postal: "15005",
    ok_postal_code: "15005",
    second_name: "Souama\u00e2",
    nom: "Souamaa",
    wilaya_id: 15,
    commune_name: "صوامـــع",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 492,
    code_postal: "15006",
    ok_postal_code: "15006",
    second_name: "Mechtras",
    nom: "Mechtrass",
    wilaya_id: 15,
    commune_name: "مشطراس",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 493,
    code_postal: "15007",
    ok_postal_code: "15007",
    second_name: "Irdjen",
    nom: "Irdjen",
    wilaya_id: 15,
    commune_name: "إيرجـــن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 494,
    code_postal: "15008",
    ok_postal_code: "15008",
    second_name: "Timizart",
    nom: "Timizart",
    wilaya_id: 15,
    commune_name: "تيمـيزار",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 495,
    code_postal: "15009",
    ok_postal_code: "15009",
    second_name: "Makouda",
    nom: "Makouda",
    wilaya_id: 15,
    commune_name: "ماكودة",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 496,
    code_postal: "15010",
    ok_postal_code: "15010",
    second_name: "Dra\u00e2 El Mizan",
    nom: "Draa El Mizan",
    wilaya_id: 15,
    commune_name: "ذراع الميزان",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 497,
    code_postal: "15011",
    ok_postal_code: "15011",
    second_name: "Tizi Gheniff",
    nom: "Tizi Ghenif",
    wilaya_id: 15,
    commune_name: "تيزي غنيف",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 498,
    code_postal: "15012",
    ok_postal_code: "15012",
    second_name: "Bounouh",
    nom: "Bounouh",
    wilaya_id: 15,
    commune_name: "بونوح",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 499,
    code_postal: "15013",
    ok_postal_code: "15013",
    second_name: "A\u00eft Chaf\u00e2a",
    nom: "Ait Chaffaa",
    wilaya_id: 15,
    commune_name: "أيت شافع",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-13 10:57:33",
  },
  {
    id: 500,
    code_postal: "15014",
    ok_postal_code: "15014",
    second_name: "Frikat",
    nom: "Frikat",
    wilaya_id: 15,
    commune_name: "فريقات",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 501,
    code_postal: "15015",
    ok_postal_code: "15015",
    second_name: "Beni A\u00efssi",
    nom: "Beni Aissi",
    wilaya_id: 15,
    commune_name: "بني عيسي",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 502,
    code_postal: "15016",
    ok_postal_code: "15016",
    second_name: "Beni Zmenzer",
    nom: "Beni Zmenzer",
    wilaya_id: 15,
    commune_name: "بنــــي زمنزار",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-09 16:52:49",
  },
  {
    id: 503,
    code_postal: "15017",
    ok_postal_code: "15017",
    second_name: "Iferhoun\u00e8ne",
    nom: "Iferhounene",
    wilaya_id: 15,
    commune_name: "إفــرحــونان",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 504,
    code_postal: "15018",
    ok_postal_code: "15018",
    second_name: "Azazga",
    nom: "Azazga",
    wilaya_id: 15,
    commune_name: "عزازقة",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 505,
    code_postal: "15019",
    ok_postal_code: "15019",
    second_name: "Illoula Oumalou",
    nom: "Iloula Oumalou",
    wilaya_id: 15,
    commune_name: "إيلولة أومـــالو",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 506,
    code_postal: "15020",
    ok_postal_code: "15020",
    second_name: "Yakouren",
    nom: "Yakouren",
    wilaya_id: 15,
    commune_name: "إعــكورن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 507,
    code_postal: "15021",
    ok_postal_code: "15021",
    second_name: "Larba\u00e2 Nath Irathen",
    nom: "Larba Nait Irathen",
    wilaya_id: 15,
    commune_name: "الأربعــاء ناث إيراثن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 508,
    code_postal: "15022",
    ok_postal_code: "15022",
    second_name: "Tizi Rached",
    nom: "Tizi Rached",
    wilaya_id: 15,
    commune_name: "تيزي راشد",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 509,
    code_postal: "15023",
    ok_postal_code: "15023",
    second_name: "Zekri",
    nom: "Zekri",
    wilaya_id: 15,
    commune_name: "زكري",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 510,
    code_postal: "15024",
    ok_postal_code: "15024",
    second_name: "Ouaguenoun",
    nom: "Ouaguenoun",
    wilaya_id: 15,
    commune_name: "واقنون",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 511,
    code_postal: "15025",
    ok_postal_code: "15025",
    second_name: "A\u00efn Zaouia",
    nom: "Ain Zaouia",
    wilaya_id: 15,
    commune_name: "عين الزاوية",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 512,
    code_postal: "15026",
    ok_postal_code: "15026",
    second_name: "M'Kira",
    nom: "Mkira",
    wilaya_id: 15,
    commune_name: "مكيرة",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 513,
    code_postal: "15027",
    ok_postal_code: "15027",
    second_name: "A\u00eft Yahia",
    nom: "Ait Yahia",
    wilaya_id: 15,
    commune_name: "أيت يحيى",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 514,
    code_postal: "15028",
    ok_postal_code: "15028",
    second_name: "A\u00eft Mahmoud",
    nom: "Ait Mahmoud",
    wilaya_id: 15,
    commune_name: "أيت محمود",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 515,
    code_postal: "15029",
    ok_postal_code: "15029",
    second_name: "M\u00e2atkas",
    nom: "Maatka",
    wilaya_id: 15,
    commune_name: "معـــاتقة",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 516,
    code_postal: "15030",
    ok_postal_code: "15030",
    second_name: "A\u00eft Boumahdi",
    nom: "Ait Boumehdi",
    wilaya_id: 15,
    commune_name: "أيت بومهدي",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 517,
    code_postal: "15031",
    ok_postal_code: "15031",
    second_name: "Abi Youcef",
    nom: "Abi Youcef",
    wilaya_id: 15,
    commune_name: "أبي يوسف",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 518,
    code_postal: "15032",
    ok_postal_code: "15032",
    second_name: "Beni Douala",
    nom: "Beni Douala",
    wilaya_id: 15,
    commune_name: "بني دوالة",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 519,
    code_postal: "15033",
    ok_postal_code: "15033",
    second_name: "Illilten",
    nom: "Illilten",
    wilaya_id: 15,
    commune_name: "إيلـيــلتـن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 520,
    code_postal: "15034",
    ok_postal_code: "15034",
    second_name: "Bouzguen",
    nom: "Bouzguen",
    wilaya_id: 15,
    commune_name: "بوزقــن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 521,
    code_postal: "15035",
    ok_postal_code: "15035",
    second_name: "A\u00eft Aggouacha",
    nom: "Ait Aggouacha",
    wilaya_id: 15,
    commune_name: "أيت عقـواشة",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 522,
    code_postal: "15036",
    ok_postal_code: "15036",
    second_name: "Ouadhia",
    nom: "Ouadhia",
    wilaya_id: 15,
    commune_name: "واضية",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 523,
    code_postal: "15037",
    ok_postal_code: "15037",
    second_name: "Azeffoun",
    nom: "Azzefoun",
    wilaya_id: 15,
    commune_name: "أزفون",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 524,
    code_postal: "15038",
    ok_postal_code: "15038",
    second_name: "Tigzirt",
    nom: "Tigzirt",
    wilaya_id: 15,
    commune_name: "تيقـزيرت",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 525,
    code_postal: "15039",
    ok_postal_code: "15039",
    second_name: "A\u00eft A\u00efssa Mimoun",
    nom: "Ait Aissa Mimoun",
    wilaya_id: 15,
    commune_name: "أيت عيسى ميمون",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 526,
    code_postal: "15040",
    ok_postal_code: "15040",
    second_name: "Boghni",
    nom: "Boghni",
    wilaya_id: 15,
    commune_name: "بوغني",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 527,
    code_postal: "15041",
    ok_postal_code: "15041",
    second_name: "Ifigha",
    nom: "Ifigha",
    wilaya_id: 15,
    commune_name: "إيفيغاء",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 528,
    code_postal: "15042",
    ok_postal_code: "15042",
    second_name: "A\u00eft Oumalou",
    nom: "Ait Oumalou",
    wilaya_id: 15,
    commune_name: "أيت  أومالو",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 529,
    code_postal: "15043",
    ok_postal_code: "15043",
    second_name: "Tirmitine",
    nom: "Tirmitine",
    wilaya_id: 15,
    commune_name: "تيرمتين",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 530,
    code_postal: "15044",
    ok_postal_code: "15044",
    second_name: "Akerrou",
    nom: "Akerrou",
    wilaya_id: 15,
    commune_name: "أقرو",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 531,
    code_postal: "15045",
    ok_postal_code: "15045",
    second_name: "Yatafen",
    nom: "Yatafen",
    wilaya_id: 15,
    commune_name: "يطــافن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 532,
    code_postal: "15046",
    ok_postal_code: "15046",
    second_name: "Ath Zikki",
    nom: "Beni Ziki",
    wilaya_id: 15,
    commune_name: "بني زيكــي",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 533,
    code_postal: "15047",
    ok_postal_code: "15047",
    second_name: "Dra\u00e2 Ben Khedda",
    nom: "Draa Ben Khedda",
    wilaya_id: 15,
    commune_name: "ذراع بن خدة",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 534,
    code_postal: "15048",
    ok_postal_code: "15048",
    second_name: "Ouacif",
    nom: "Ouacif",
    wilaya_id: 15,
    commune_name: "واسيف",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 535,
    code_postal: "15049",
    ok_postal_code: "15049",
    second_name: "Idjeur",
    nom: "Idjeur",
    wilaya_id: 15,
    commune_name: "إيجــار",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 536,
    code_postal: "15050",
    ok_postal_code: "15050",
    second_name: "Mekla",
    nom: "Mekla",
    wilaya_id: 15,
    commune_name: "مقــلع",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 537,
    code_postal: "15051",
    ok_postal_code: "15051",
    second_name: "Tizi N'Tleta",
    nom: "Tizi Nthlata",
    wilaya_id: 15,
    commune_name: "تيزي نثلاثة",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-09 16:52:49",
  },
  {
    id: 538,
    code_postal: "15052",
    ok_postal_code: "15052",
    second_name: "A\u00eft Yenni",
    nom: "Beni Yenni",
    wilaya_id: 15,
    commune_name: "بني يني",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 539,
    code_postal: "15053",
    ok_postal_code: "15053",
    second_name: "Aghribs",
    nom: "Aghrib",
    wilaya_id: 15,
    commune_name: "أغريب",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 540,
    code_postal: "15054",
    ok_postal_code: "15054",
    second_name: "Iflissen",
    nom: "Iflissen",
    wilaya_id: 15,
    commune_name: "إفليـــسن",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 541,
    code_postal: "15055",
    ok_postal_code: "15055",
    second_name: "Boudjima",
    nom: "Boudjima",
    wilaya_id: 15,
    commune_name: "بوجيمة",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 542,
    code_postal: "15056",
    ok_postal_code: "15056",
    second_name: "A\u00eft Yahia Moussa",
    nom: "Ait Yahia Moussa",
    wilaya_id: 15,
    commune_name: "أيت يحي موسى",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 543,
    code_postal: "15057",
    ok_postal_code: "15057",
    second_name: "Souk El Thenine",
    nom: "Souk El Thenine",
    wilaya_id: 15,
    commune_name: "سوق الإثنين",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 544,
    code_postal: "15058",
    ok_postal_code: "15058",
    second_name: "A\u00eft Khellili",
    nom: "Ait Khelil",
    wilaya_id: 15,
    commune_name: "أيت خليلي",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 545,
    code_postal: "15059",
    ok_postal_code: "15059",
    second_name: "Sidi Namane",
    nom: "Sidi Naamane",
    wilaya_id: 15,
    commune_name: "سيدي نعمان",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 546,
    code_postal: "15060",
    ok_postal_code: "15060",
    second_name: "Iboudraren",
    nom: "Iboudraren",
    wilaya_id: 15,
    commune_name: "إبودرارن",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 547,
    code_postal: "15061",
    ok_postal_code: "15061",
    second_name: "Agouni Gueghrane",
    nom: "Aghni Goughran",
    wilaya_id: 15,
    commune_name: "أقني قغران",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 548,
    code_postal: "15062",
    ok_postal_code: "15062",
    second_name: "Mizrana",
    nom: "Mizrana",
    wilaya_id: 15,
    commune_name: "ميزرانـــة",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 549,
    code_postal: "15063",
    ok_postal_code: "15063",
    second_name: "Imsouhel",
    nom: "Imsouhal",
    wilaya_id: 15,
    commune_name: "إمســوحال",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 550,
    code_postal: "15064",
    ok_postal_code: "15064",
    second_name: "Tadma\u00eft",
    nom: "Tadmait",
    wilaya_id: 15,
    commune_name: "تادمايت",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 551,
    code_postal: "15065",
    ok_postal_code: "15065",
    second_name: "A\u00eft Bouadou",
    nom: "Ait Bouadou",
    wilaya_id: 15,
    commune_name: "أيت بــوادو",
    wilaya_name: "تيزي وزو",
    hub_id: 21,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 552,
    code_postal: "15066",
    ok_postal_code: "15066",
    second_name: "Assi Youcef",
    nom: "Assi Youcef",
    wilaya_id: 15,
    commune_name: "أسي يوسف",
    wilaya_name: "تيزي وزو",
    hub_id: 96,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-07 13:37:43",
  },
  {
    id: 553,
    code_postal: "15067",
    ok_postal_code: "15067",
    second_name: "A\u00eft Toudert",
    nom: "Ait Toudert",
    wilaya_id: 15,
    commune_name: "أيت تودرت",
    wilaya_name: "تيزي وزو",
    hub_id: 72,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-11 14:49:27",
  },
  {
    id: 554,
    code_postal: "16001",
    ok_postal_code: "16001",
    second_name: "Alger Centre",
    nom: "Alger Centre",
    wilaya_id: 16,
    commune_name: "الجزائر الوسطى",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 555,
    code_postal: "16002",
    ok_postal_code: "16002",
    second_name: "Sidi M'Hamed",
    nom: "Sidi Mhamed",
    wilaya_id: 16,
    commune_name: "سيدي امحمد",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 556,
    code_postal: "16003",
    ok_postal_code: "16003",
    second_name: "El Madania",
    nom: "El Madania",
    wilaya_id: 16,
    commune_name: "المدنية",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 557,
    code_postal: "16004",
    ok_postal_code: "16004",
    second_name: "Belouizdad",
    nom: "Hamma Anassers",
    wilaya_id: 16,
    commune_name: "محمد بلوزداد",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 558,
    code_postal: "16005",
    ok_postal_code: "16005",
    second_name: "Bab El Oued",
    nom: "Bab El Oued",
    wilaya_id: 16,
    commune_name: "باب الوادي",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 559,
    code_postal: "16006",
    ok_postal_code: "16006",
    second_name: "Bologhine",
    nom: "Bologhine Ibn Ziri",
    wilaya_id: 16,
    commune_name: "بولوغين بن زيري",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 560,
    code_postal: "16007",
    ok_postal_code: "16007",
    second_name: "Casbah",
    nom: "Casbah",
    wilaya_id: 16,
    commune_name: "القصبة",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 561,
    code_postal: "16008",
    ok_postal_code: "16008",
    second_name: "Oued Koriche",
    nom: "Oued Koriche",
    wilaya_id: 16,
    commune_name: "وادي قريش",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 562,
    code_postal: "16009",
    ok_postal_code: "16009",
    second_name: "Bir Mourad Ra\u00efs",
    nom: "Bir Mourad Rais",
    wilaya_id: 16,
    commune_name: "بئر مراد رايس",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 563,
    code_postal: "16010",
    ok_postal_code: "16010",
    second_name: "El Biar",
    nom: "El Biar",
    wilaya_id: 16,
    commune_name: "الابيار",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 564,
    code_postal: "16011",
    ok_postal_code: "16011",
    second_name: "Bouzareah",
    nom: "Bouzareah",
    wilaya_id: 16,
    commune_name: "بوزريعة",
    wilaya_name: "الجزائر",
    hub_id: 50,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 565,
    code_postal: "16012",
    ok_postal_code: "16012",
    second_name: "Birkhadem",
    nom: "Birkhadem",
    wilaya_id: 16,
    commune_name: "بئر خادم",
    wilaya_name: "الجزائر",
    hub_id: 106,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-10 15:24:31",
  },
  {
    id: 566,
    code_postal: "16013",
    ok_postal_code: "16013",
    second_name: "El Harrach",
    nom: "El Harrach",
    wilaya_id: 16,
    commune_name: "الحراش",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-10 07:24:05",
  },
  {
    id: 567,
    code_postal: "16014",
    ok_postal_code: "16014",
    second_name: "Baraki",
    nom: "Baraki",
    wilaya_id: 16,
    commune_name: "براقي",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:36:49",
  },
  {
    id: 568,
    code_postal: "16015",
    ok_postal_code: "16015",
    second_name: "Oued Smar",
    nom: "Oued Smar",
    wilaya_id: 16,
    commune_name: "وادي السمار",
    wilaya_name: "الجزائر",
    hub_id: 37,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-01 17:53:51",
  },
  {
    id: 569,
    code_postal: "16016",
    ok_postal_code: "16016",
    second_name: "Bourouba",
    nom: "Bourouba",
    wilaya_id: 16,
    commune_name: "بوروبة",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-10 07:24:05",
  },
  {
    id: 570,
    code_postal: "16017",
    ok_postal_code: "16017",
    second_name: "Hussein Dey",
    nom: "Hussein Dey",
    wilaya_id: 16,
    commune_name: "حسين داي",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-07 20:41:20",
  },
  {
    id: 571,
    code_postal: "16018",
    ok_postal_code: "16018",
    second_name: "Kouba",
    nom: "Kouba",
    wilaya_id: 16,
    commune_name: "القبة",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 572,
    code_postal: "16019",
    ok_postal_code: "16019",
    second_name: "Bachdjerrah",
    nom: "Bachedjerah",
    wilaya_id: 16,
    commune_name: "باش جراح",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-10 07:24:05",
  },
  {
    id: 573,
    code_postal: "16020",
    ok_postal_code: "16020",
    second_name: "Dar El Be\u00efda",
    nom: "Dar El Beida",
    wilaya_id: 16,
    commune_name: "الدار البيضاء",
    wilaya_name: "الجزائر",
    hub_id: 37,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-01 17:53:51",
  },
  {
    id: 574,
    code_postal: "16021",
    ok_postal_code: "16021",
    second_name: "Bab Ezzouar",
    nom: "Bab Azzouar",
    wilaya_id: 16,
    commune_name: "باب الزوار",
    wilaya_name: "الجزائر",
    hub_id: 37,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 575,
    code_postal: "16022",
    ok_postal_code: "16022",
    second_name: "Ben Aknoun",
    nom: "Ben Aknoun",
    wilaya_id: 16,
    commune_name: "ابن عكنون",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 576,
    code_postal: "16023",
    ok_postal_code: "16023",
    second_name: "Dely Ibrahim",
    nom: "Dely Ibrahim",
    wilaya_id: 16,
    commune_name: "دالي ابراهيم",
    wilaya_name: "الجزائر",
    hub_id: 50,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 577,
    code_postal: "16024",
    ok_postal_code: "16024",
    second_name: "El Hammamet",
    nom: "Bains Romains",
    wilaya_id: 16,
    commune_name: "الحمامات",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 578,
    code_postal: "16025",
    ok_postal_code: "16025",
    second_name: "Ra\u00efs Hamidou",
    nom: "Rais Hamidou",
    wilaya_id: 16,
    commune_name: "الرايس حميدو",
    wilaya_name: "الجزائر",
    hub_id: 69,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-30 15:55:46",
  },
  {
    id: 579,
    code_postal: "16026",
    ok_postal_code: "16026",
    second_name: "Djasr Kasentina",
    nom: "Djasr Kasentina",
    wilaya_id: 16,
    commune_name: "جسر قسنطينة",
    wilaya_name: "الجزائر",
    hub_id: 106,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-10 15:24:31",
  },
  {
    id: 580,
    code_postal: "16027",
    ok_postal_code: "16027",
    second_name: "El Mouradia",
    nom: "El Mouradia",
    wilaya_id: 16,
    commune_name: "المرادية",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 581,
    code_postal: "16028",
    ok_postal_code: "16028",
    second_name: "Hydra",
    nom: "Hydra",
    wilaya_id: 16,
    commune_name: "حيدرة",
    wilaya_name: "الجزائر",
    hub_id: 24,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 582,
    code_postal: "16029",
    ok_postal_code: "16029",
    second_name: "Mohammadia",
    nom: "Mohammadia",
    wilaya_id: 16,
    commune_name: "المحمدية",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-07 20:41:20",
  },
  {
    id: 583,
    code_postal: "16030",
    ok_postal_code: "16030",
    second_name: "Bordj El Kiffan",
    nom: "Bordj El Kiffan",
    wilaya_id: 16,
    commune_name: "برج الكيفان",
    wilaya_name: "الجزائر",
    hub_id: 37,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-29 22:32:10",
  },
  {
    id: 584,
    code_postal: "16031",
    ok_postal_code: "16031",
    second_name: "El Magharia",
    nom: "El Magharia",
    wilaya_id: 16,
    commune_name: "المغارية",
    wilaya_name: "الجزائر",
    hub_id: 115,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-07 20:41:20",
  },
  {
    id: 585,
    code_postal: "16032",
    ok_postal_code: "16032",
    second_name: "Beni Messous",
    nom: "Beni Messous",
    wilaya_id: 16,
    commune_name: "بني مسوس",
    wilaya_name: "الجزائر",
    hub_id: 50,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 586,
    code_postal: "16033",
    ok_postal_code: "16033",
    second_name: "Les Eucalyptus",
    nom: "Les Eucalyptus",
    wilaya_id: 16,
    commune_name: "الكاليتوس",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:36:49",
  },
  {
    id: 587,
    code_postal: "16034",
    ok_postal_code: "16034",
    second_name: "Birtouta",
    nom: "Birtouta",
    wilaya_id: 16,
    commune_name: "بئر توتة",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2025-04-24 21:24:22",
  },
  {
    id: 588,
    code_postal: "16035",
    ok_postal_code: "16035",
    second_name: "Tessala El Merdja",
    nom: "Tassala El Merdja",
    wilaya_id: 16,
    commune_name: "تسالة المرجة",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2025-04-24 21:24:22",
  },
  {
    id: 589,
    code_postal: "16036",
    ok_postal_code: "16036",
    second_name: "Ouled Chebel",
    nom: "Ouled Chebel",
    wilaya_id: 16,
    commune_name: "اولاد شبل",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:36:49",
  },
  {
    id: 590,
    code_postal: "16037",
    ok_postal_code: "16037",
    second_name: "Sidi Moussa",
    nom: "Sidi Moussa",
    wilaya_id: 16,
    commune_name: "سيدي موسى",
    wilaya_name: "الجزائر",
    hub_id: 81,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:36:49",
  },
  {
    id: 591,
    code_postal: "16038",
    ok_postal_code: "16038",
    second_name: "A\u00efn Taya",
    nom: "Ain Taya",
    wilaya_id: 16,
    commune_name: "عين طاية",
    wilaya_name: "الجزائر",
    hub_id: 86,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-29 22:32:48",
  },
  {
    id: 592,
    code_postal: "16039",
    ok_postal_code: "16039",
    second_name: "Bordj El Bahri",
    nom: "Bordj El Bahri",
    wilaya_id: 16,
    commune_name: "برج البحري",
    wilaya_name: "الجزائر",
    hub_id: 86,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-29 22:32:48",
  },
  {
    id: 593,
    code_postal: "16040",
    ok_postal_code: "16040",
    second_name: null,
    nom: "Marsa",
    wilaya_id: 16,
    commune_name: "المرسى",
    wilaya_name: "الجزائر",
    hub_id: 86,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-29 22:32:48",
  },
  {
    id: 594,
    code_postal: "16041",
    ok_postal_code: "16041",
    second_name: "H'raoua",
    nom: "Haraoua",
    wilaya_id: 16,
    commune_name: "هراوة",
    wilaya_name: "الجزائر",
    hub_id: 62,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 595,
    code_postal: "16042",
    ok_postal_code: "16042",
    second_name: "Rou\u00efba",
    nom: "Rouiba",
    wilaya_id: 16,
    commune_name: "الرويبة",
    wilaya_name: "الجزائر",
    hub_id: 62,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 596,
    code_postal: "16043",
    ok_postal_code: "16043",
    second_name: "Regha\u00efa",
    nom: "Reghaia",
    wilaya_id: 16,
    commune_name: "رغاية",
    wilaya_name: "الجزائر",
    hub_id: 62,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 597,
    code_postal: "16044",
    ok_postal_code: "16044",
    second_name: "A\u00efn Benian",
    nom: "Ain Benian",
    wilaya_id: 16,
    commune_name: "عين بنيان",
    wilaya_name: "الجزائر",
    hub_id: 93,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:48:22",
  },
  {
    id: 598,
    code_postal: "16045",
    ok_postal_code: "16045",
    second_name: "Staoueli",
    nom: "Staoueli",
    wilaya_id: 16,
    commune_name: "سطاوالي",
    wilaya_name: "الجزائر",
    hub_id: 93,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:48:22",
  },
  {
    id: 599,
    code_postal: "16046",
    ok_postal_code: "16046",
    second_name: "Zeralda",
    nom: "Zeralda",
    wilaya_id: 16,
    commune_name: "زرالدة",
    wilaya_name: "الجزائر",
    hub_id: 93,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:48:22",
  },
  {
    id: 600,
    code_postal: "16047",
    ok_postal_code: "16047",
    second_name: "Mahelma",
    nom: "Mahelma",
    wilaya_id: 16,
    commune_name: "المعالمة",
    wilaya_name: "الجزائر",
    hub_id: 93,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:48:22",
  },
  {
    id: 601,
    code_postal: "16048",
    ok_postal_code: "16048",
    second_name: "Rahmania",
    nom: "Rahmania",
    wilaya_id: 16,
    commune_name: "الرحمانية",
    wilaya_name: "الجزائر",
    hub_id: 70,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:12:48",
  },
  {
    id: 602,
    code_postal: "16049",
    ok_postal_code: "16049",
    second_name: "Souidania",
    nom: "Souidania",
    wilaya_id: 16,
    commune_name: "سويدانية",
    wilaya_name: "الجزائر",
    hub_id: 70,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:12:48",
  },
  {
    id: 603,
    code_postal: "16050",
    ok_postal_code: "16050",
    second_name: "Cheraga",
    nom: "Cheraga",
    wilaya_id: 16,
    commune_name: "الشراقة",
    wilaya_name: "الجزائر",
    hub_id: 50,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 604,
    code_postal: "16051",
    ok_postal_code: "16051",
    second_name: "Ouled Fayet",
    nom: "Ouled Fayet",
    wilaya_id: 16,
    commune_name: "اولاد فايت",
    wilaya_name: "الجزائر",
    hub_id: 70,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:12:48",
  },
  {
    id: 605,
    code_postal: "16052",
    ok_postal_code: "16052",
    second_name: "El Achour",
    nom: "El Achour",
    wilaya_id: 16,
    commune_name: "العاشور",
    wilaya_name: "الجزائر",
    hub_id: 119,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-18 19:27:15",
  },
  {
    id: 606,
    code_postal: "16053",
    ok_postal_code: "16053",
    second_name: "Draria",
    nom: "Draria",
    wilaya_id: 16,
    commune_name: "الدرارية",
    wilaya_name: "الجزائر",
    hub_id: 119,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-18 19:27:15",
  },
  {
    id: 607,
    code_postal: "16054",
    ok_postal_code: "16054",
    second_name: "Douera",
    nom: "Douera",
    wilaya_id: 16,
    commune_name: "الدويرة",
    wilaya_name: "الجزائر",
    hub_id: 70,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:12:48",
  },
  {
    id: 608,
    code_postal: "16055",
    ok_postal_code: "16055",
    second_name: "Baba Hassen",
    nom: "Baba Hassen",
    wilaya_id: 16,
    commune_name: "بابا حسن",
    wilaya_name: "الجزائر",
    hub_id: 70,
    is_active: 1,
    created_at: null,
    updated_at: "2024-09-06 23:12:48",
  },
  {
    id: 609,
    code_postal: "16056",
    ok_postal_code: "16056",
    second_name: "Khraicia",
    nom: "Khracia",
    wilaya_id: 16,
    commune_name: "الخرايسية",
    wilaya_name: "الجزائر",
    hub_id: 119,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-18 19:27:15",
  },
  {
    id: 610,
    code_postal: "16057",
    ok_postal_code: "16057",
    second_name: "Saoula",
    nom: "Saoula",
    wilaya_id: 16,
    commune_name: "السحاولة",
    wilaya_name: "الجزائر",
    hub_id: 119,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-18 19:27:15",
  },
  {
    id: 611,
    code_postal: "17001",
    ok_postal_code: "17001",
    second_name: "Djelfa",
    nom: "Djelfa",
    wilaya_id: 17,
    commune_name: "الجلفة",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 612,
    code_postal: "17002",
    ok_postal_code: "17002",
    second_name: "Moudjebara",
    nom: "Moudjebara",
    wilaya_id: 17,
    commune_name: "مجبارة",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 613,
    code_postal: "17003",
    ok_postal_code: "17003",
    second_name: "El Guedid",
    nom: "El Guedid",
    wilaya_id: 17,
    commune_name: "القديد",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 614,
    code_postal: "17004",
    ok_postal_code: "17004",
    second_name: "Hassi Bahbah",
    nom: "Hassi Bahbah",
    wilaya_id: 17,
    commune_name: "حاسي بحبح",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 615,
    code_postal: "17005",
    ok_postal_code: "17005",
    second_name: "A\u00efn Maabed",
    nom: "Ain Maabed",
    wilaya_id: 17,
    commune_name: "عين معبد",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-15 10:11:29",
  },
  {
    id: 616,
    code_postal: "17006",
    ok_postal_code: "17006",
    second_name: "Sed Rahal",
    nom: "Sed Rahal",
    wilaya_id: 17,
    commune_name: "سد الرحال",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 617,
    code_postal: "17007",
    ok_postal_code: "17007",
    second_name: "Faidh El Botma",
    nom: "Feidh El Botma",
    wilaya_id: 17,
    commune_name: "فيض البطمة",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-13 18:09:16",
  },
  {
    id: 618,
    code_postal: "17008",
    ok_postal_code: "17008",
    second_name: "Birine",
    nom: "Birine",
    wilaya_id: 17,
    commune_name: "بيرين",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 619,
    code_postal: "17009",
    ok_postal_code: "17009",
    second_name: "Bouira Lahdab",
    nom: "Bouira Lahdeb",
    wilaya_id: 17,
    commune_name: "بويرة الأحداب",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 620,
    code_postal: "17010",
    ok_postal_code: "17010",
    second_name: "Zaccar",
    nom: "Zaccar",
    wilaya_id: 17,
    commune_name: "زكار",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 621,
    code_postal: "17011",
    ok_postal_code: "17011",
    second_name: "El Khemis",
    nom: "El Khemis",
    wilaya_id: 17,
    commune_name: "الخميس",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:28:54",
  },
  {
    id: 622,
    code_postal: "17012",
    ok_postal_code: "17012",
    second_name: "Sidi Baizid",
    nom: "Sidi Baizid",
    wilaya_id: 17,
    commune_name: "سيدي بايزيد",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 623,
    code_postal: "17013",
    ok_postal_code: "17013",
    second_name: "M'Liliha",
    nom: "Mliliha",
    wilaya_id: 17,
    commune_name: "مليليحة",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 624,
    code_postal: "17014",
    ok_postal_code: "17014",
    second_name: "El Idrissia",
    nom: "El Idrissia",
    wilaya_id: 17,
    commune_name: "الادريسية",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 625,
    code_postal: "17015",
    ok_postal_code: "17015",
    second_name: "Douis",
    nom: "Douis",
    wilaya_id: 17,
    commune_name: "دويس",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 626,
    code_postal: "17016",
    ok_postal_code: "17016",
    second_name: "Hassi El Euch",
    nom: "Hassi El Euch",
    wilaya_id: 17,
    commune_name: "حاسي العش",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 627,
    code_postal: "17017",
    ok_postal_code: "17017",
    second_name: "Messaad",
    nom: "Messaad",
    wilaya_id: 17,
    commune_name: "مسعد",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 629,
    code_postal: "17019",
    ok_postal_code: "17019",
    second_name: "Sidi Ladjel",
    nom: "Sidi Ladjel",
    wilaya_id: 17,
    commune_name: "سيدي لعجال",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 630,
    code_postal: "17020",
    ok_postal_code: "17020",
    second_name: "Had Sahary",
    nom: "Had Sahary",
    wilaya_id: 17,
    commune_name: "حد الصحاري",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 631,
    code_postal: "17021",
    ok_postal_code: "17021",
    second_name: "Guernini",
    nom: "Guernini",
    wilaya_id: 17,
    commune_name: "قرنيني",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 632,
    code_postal: "17022",
    ok_postal_code: "17022",
    second_name: "Selmana",
    nom: "Selmana",
    wilaya_id: 17,
    commune_name: "سلمانة",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 633,
    code_postal: "17023",
    ok_postal_code: "17023",
    second_name: "A\u00efn Chouhada",
    nom: "Ain Chouhada",
    wilaya_id: 17,
    commune_name: "عين الشهداء",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-13 18:09:28",
  },
  {
    id: 635,
    code_postal: "17025",
    ok_postal_code: "17025",
    second_name: "Dar Chioukh",
    nom: "Dar Chouikh",
    wilaya_id: 17,
    commune_name: "دار الشيوخ",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 636,
    code_postal: "17026",
    ok_postal_code: "17026",
    second_name: "Charef",
    nom: "Charef",
    wilaya_id: 17,
    commune_name: "الشارف",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 637,
    code_postal: "17027",
    ok_postal_code: "17027",
    second_name: "Beni Yagoub",
    nom: "Beni Yacoub",
    wilaya_id: 17,
    commune_name: "بن يعقوب",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 638,
    code_postal: "17028",
    ok_postal_code: "17028",
    second_name: "Zaafrane",
    nom: "Zaafrane",
    wilaya_id: 17,
    commune_name: "زعفران",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2025-04-24 21:24:49",
  },
  {
    id: 639,
    code_postal: "17029",
    ok_postal_code: "17029",
    second_name: "Deldoul",
    nom: "Deldoul",
    wilaya_id: 17,
    commune_name: "دلدول",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 640,
    code_postal: "17030",
    ok_postal_code: "17030",
    second_name: "A\u00efn El Ibel",
    nom: "Ain El Ibel",
    wilaya_id: 17,
    commune_name: "عين الإبل",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 641,
    code_postal: "17031",
    ok_postal_code: "17031",
    second_name: "A\u00efn Oussara",
    nom: "Ain Oussera",
    wilaya_id: 17,
    commune_name: "عين وسارة",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 642,
    code_postal: "17032",
    ok_postal_code: "17032",
    second_name: "Benhar",
    nom: "Benhar",
    wilaya_id: 17,
    commune_name: "بنهار",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 643,
    code_postal: "17033",
    ok_postal_code: "17033",
    second_name: "Hassi Fedoul",
    nom: "Hassi Fedoul",
    wilaya_id: 17,
    commune_name: "حاسي فدول",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 645,
    code_postal: "17035",
    ok_postal_code: "17035",
    second_name: "A\u00efn Feka",
    nom: "Ain Fekka",
    wilaya_id: 17,
    commune_name: "عين فقه",
    wilaya_name: "الجلفة",
    hub_id: 85,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-14 23:25:22",
  },
  {
    id: 646,
    code_postal: "17036",
    ok_postal_code: "17036",
    second_name: "Tadmit",
    nom: "Tadmit",
    wilaya_id: 17,
    commune_name: "تعظميت",
    wilaya_name: "الجلفة",
    hub_id: 32,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 647,
    code_postal: "18001",
    ok_postal_code: "18001",
    second_name: "Jijel",
    nom: "Jijel",
    wilaya_id: 18,
    commune_name: "جيجل",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 649,
    code_postal: "18003",
    ok_postal_code: "18003",
    second_name: "El Aouana",
    nom: "El Aouana",
    wilaya_id: 18,
    commune_name: "العوانة",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 650,
    code_postal: "18004",
    ok_postal_code: "18004",
    second_name: "Ziama Mansouriah",
    nom: "Ziamma Mansouriah",
    wilaya_id: 18,
    commune_name: "زيامة منصورية",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 651,
    code_postal: "18005",
    ok_postal_code: "18005",
    second_name: "Taher",
    nom: "Taher",
    wilaya_id: 18,
    commune_name: "الطاهير",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 652,
    code_postal: "18006",
    ok_postal_code: "18006",
    second_name: "Emir Abdelkader",
    nom: "Emir Abdelkader",
    wilaya_id: 18,
    commune_name: "الامير عبد القادر",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 653,
    code_postal: "18007",
    ok_postal_code: "18007",
    second_name: "Chekfa",
    nom: "Chekfa",
    wilaya_id: 18,
    commune_name: "الشقفة",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 655,
    code_postal: "18009",
    ok_postal_code: "18009",
    second_name: "El Milia",
    nom: "El Milia",
    wilaya_id: 18,
    commune_name: "الميلية",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 656,
    code_postal: "18010",
    ok_postal_code: "18010",
    second_name: "Sidi Maarouf",
    nom: "Sidi Maarouf",
    wilaya_id: 18,
    commune_name: "سيدي معروف",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 657,
    code_postal: "18011",
    ok_postal_code: "18011",
    second_name: "Settara",
    nom: "Settara",
    wilaya_id: 18,
    commune_name: "السطارة",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 658,
    code_postal: "18012",
    ok_postal_code: "18012",
    second_name: "El Ancer",
    nom: "El Ancer",
    wilaya_id: 18,
    commune_name: "العنصر",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 20:01:41",
  },
  {
    id: 659,
    code_postal: "18013",
    ok_postal_code: "18013",
    second_name: "Sidi Abdelaziz",
    nom: "Sidi Abdelaziz",
    wilaya_id: 18,
    commune_name: "سيدي عبد العزيز",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 20:01:41",
  },
  {
    id: 660,
    code_postal: "18014",
    ok_postal_code: "18014",
    second_name: "Kaous",
    nom: "Kaous",
    wilaya_id: 18,
    commune_name: "قاوس",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 661,
    code_postal: "18015",
    ok_postal_code: "18015",
    second_name: "Ghebala",
    nom: "Ghebala",
    wilaya_id: 18,
    commune_name: "غبالة",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 662,
    code_postal: "18016",
    ok_postal_code: "18016",
    second_name: "Bouraoui Belhadef",
    nom: "Bouraoui Belhadef",
    wilaya_id: 18,
    commune_name: "بوراوي بلهادف",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 20:01:41",
  },
  {
    id: 663,
    code_postal: "18017",
    ok_postal_code: "18017",
    second_name: "Djimla",
    nom: "Djmila",
    wilaya_id: 18,
    commune_name: "جيملة",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 666,
    code_postal: "18020",
    ok_postal_code: "18020",
    second_name: "El Kennar Nouchfi",
    nom: "El Kennar Nouchfi",
    wilaya_id: 18,
    commune_name: "القنار نشفي",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 667,
    code_postal: "18021",
    ok_postal_code: "18021",
    second_name: "Ouled Yahia Khedrouche",
    nom: "Ouled Yahia Khadrouch",
    wilaya_id: 18,
    commune_name: "أولاد يحيى خدروش",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 669,
    code_postal: "18023",
    ok_postal_code: "18023",
    second_name: "Khe\u00efri Oued Adjoul",
    nom: "Kemir Oued Adjoul",
    wilaya_id: 18,
    commune_name: "خيري واد عجول",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 20:01:41",
  },
  {
    id: 670,
    code_postal: "18024",
    ok_postal_code: "18024",
    second_name: "Texenna",
    nom: "Texena",
    wilaya_id: 18,
    commune_name: "تاكسنة",
    wilaya_name: "جيجل",
    hub_id: 18,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 671,
    code_postal: "18025",
    ok_postal_code: "18025",
    second_name: "Djemaa Beni Habibi",
    nom: "Djemaa Beni Habibi",
    wilaya_id: 18,
    commune_name: "الجمعة بني حبيبي",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-11 20:01:41",
  },
  {
    id: 673,
    code_postal: "18027",
    ok_postal_code: "18027",
    second_name: "Ouled Rabah",
    nom: "Ouled Rabah",
    wilaya_id: 18,
    commune_name: "أولاد رابح",
    wilaya_name: "جيجل",
    hub_id: 111,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-22 22:23:56",
  },
  {
    id: 675,
    code_postal: "19001",
    ok_postal_code: "19001",
    second_name: "S\u00e9tif",
    nom: "Setif",
    wilaya_id: 19,
    commune_name: "سطيف",
    wilaya_name: "سطيف",
    hub_id: 3,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 676,
    code_postal: "19002",
    ok_postal_code: "19002",
    second_name: "A\u00efn El Kebira",
    nom: "Ain El Kebira",
    wilaya_id: 19,
    commune_name: "عين الكبيرة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 677,
    code_postal: "19003",
    ok_postal_code: "19003",
    second_name: "Beni Aziz",
    nom: "Beni Aziz",
    wilaya_id: 19,
    commune_name: "بني عزيز",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 678,
    code_postal: "19004",
    ok_postal_code: "19004",
    second_name: "Ouled Si Ahmed",
    nom: "Ouled Sidi Ahmed",
    wilaya_id: 19,
    commune_name: "أولاد سي أحمد",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 679,
    code_postal: "19005",
    ok_postal_code: "19005",
    second_name: "Boutaleb",
    nom: "Boutaleb",
    wilaya_id: 19,
    commune_name: "بوطالب",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 680,
    code_postal: "19006",
    ok_postal_code: "19006",
    second_name: "A\u00efn Roua",
    nom: "Ain Roua",
    wilaya_id: 19,
    commune_name: "عين الروى",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 681,
    code_postal: "19007",
    ok_postal_code: "19007",
    second_name: "Draa Kebila",
    nom: "Draa Kebila",
    wilaya_id: 19,
    commune_name: "ذراع قبيلة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 682,
    code_postal: "19008",
    ok_postal_code: "19008",
    second_name: "Bir El Arch",
    nom: "Bir El Arch",
    wilaya_id: 19,
    commune_name: "بئر العرش",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 683,
    code_postal: "19009",
    ok_postal_code: "19009",
    second_name: "Beni Chebana",
    nom: "Beni Chebana",
    wilaya_id: 19,
    commune_name: "بني شبانة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 684,
    code_postal: "19010",
    ok_postal_code: "19010",
    second_name: "Ouled Tebben",
    nom: "Ouled Tebben",
    wilaya_id: 19,
    commune_name: "أولاد تبان",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:30:49",
  },
  {
    id: 685,
    code_postal: "19011",
    ok_postal_code: "19011",
    second_name: "Hamma",
    nom: "Hamma",
    wilaya_id: 19,
    commune_name: "الحامة",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 686,
    code_postal: "19012",
    ok_postal_code: "19012",
    second_name: "Maaouia",
    nom: "Maaouia",
    wilaya_id: 19,
    commune_name: "معاوية",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-10-26 14:22:28",
  },
  {
    id: 687,
    code_postal: "19013",
    ok_postal_code: "19013",
    second_name: "A\u00efn Legradj",
    nom: "Ain Legraj",
    wilaya_id: 19,
    commune_name: "عين لقراج",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 688,
    code_postal: "19014",
    ok_postal_code: "19014",
    second_name: "A\u00efn Abessa",
    nom: "Ain Abessa",
    wilaya_id: 19,
    commune_name: "عين عباسة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 689,
    code_postal: "19015",
    ok_postal_code: "19015",
    second_name: "Dehamcha",
    nom: "Dehamcha",
    wilaya_id: 19,
    commune_name: "الدهامشة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-29 18:34:22",
  },
  {
    id: 690,
    code_postal: "19016",
    ok_postal_code: "19016",
    second_name: "Babor",
    nom: "Babor",
    wilaya_id: 19,
    commune_name: "بابور",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 691,
    code_postal: "19017",
    ok_postal_code: "19017",
    second_name: "Guidjel",
    nom: "Guidjel",
    wilaya_id: 19,
    commune_name: "قجال",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 692,
    code_postal: "19018",
    ok_postal_code: "19018",
    second_name: "A\u00efn Lahdjar",
    nom: "Ain Lahdjar",
    wilaya_id: 19,
    commune_name: "عين الحجر",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 693,
    code_postal: "19019",
    ok_postal_code: "19019",
    second_name: "Bousselam",
    nom: "Bousselam",
    wilaya_id: 19,
    commune_name: "بوسلام",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 694,
    code_postal: "19020",
    ok_postal_code: "19020",
    second_name: "El Eulma",
    nom: "El Eulma",
    wilaya_id: 19,
    commune_name: "العلمة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 695,
    code_postal: "19021",
    ok_postal_code: "19021",
    second_name: "Djemila",
    nom: "Djemila",
    wilaya_id: 19,
    commune_name: "جميلة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 696,
    code_postal: "19022",
    ok_postal_code: "19022",
    second_name: "A\u00eft Wertilan",
    nom: "Beni Ouartilane",
    wilaya_id: 19,
    commune_name: "بني ورتيلان",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 697,
    code_postal: "19023",
    ok_postal_code: "19023",
    second_name: "Rasfa",
    nom: "Rosfa",
    wilaya_id: 19,
    commune_name: "الرصفة",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 698,
    code_postal: "19024",
    ok_postal_code: "19024",
    second_name: "Ouled Addouane",
    nom: "Ouled Addouane",
    wilaya_id: 19,
    commune_name: "أولاد عدوان",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 699,
    code_postal: "19025",
    ok_postal_code: "19025",
    second_name: "Belaa",
    nom: "Belaa",
    wilaya_id: 19,
    commune_name: "بلاعة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 700,
    code_postal: "19026",
    ok_postal_code: "19026",
    second_name: "A\u00efn Arnat",
    nom: "Ain Arnat",
    wilaya_id: 19,
    commune_name: "عين أرنات",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:21:16",
  },
  {
    id: 701,
    code_postal: "19027",
    ok_postal_code: "19027",
    second_name: "Amoucha",
    nom: "Amoucha",
    wilaya_id: 19,
    commune_name: "عموشة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 702,
    code_postal: "19028",
    ok_postal_code: "19028",
    second_name: "A\u00efn Oulmene",
    nom: "Ain Oulmane",
    wilaya_id: 19,
    commune_name: "عين ولمان",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 703,
    code_postal: "19029",
    ok_postal_code: "19029",
    second_name: "Beidha Bordj",
    nom: "Beidha Bordj",
    wilaya_id: 19,
    commune_name: "بيضاء برج",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 704,
    code_postal: "19030",
    ok_postal_code: "19030",
    second_name: "Bouandas",
    nom: "Bouandas",
    wilaya_id: 19,
    commune_name: "بوعنداس",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 705,
    code_postal: "19031",
    ok_postal_code: "19031",
    second_name: "Bazer Sakhra",
    nom: "Bazer Sakhra",
    wilaya_id: 19,
    commune_name: "بازر سكرة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 706,
    code_postal: "19032",
    ok_postal_code: "19032",
    second_name: "Hammam Soukhna",
    nom: "Hammam Essokhna",
    wilaya_id: 19,
    commune_name: "حمام السخنة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 707,
    code_postal: "19033",
    ok_postal_code: "19033",
    second_name: "Mezloug",
    nom: "Mezloug",
    wilaya_id: 19,
    commune_name: "مزلوق",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 708,
    code_postal: "19034",
    ok_postal_code: "19034",
    second_name: "Bir Haddada",
    nom: "Bir Haddada",
    wilaya_id: 19,
    commune_name: "بئر حدادة",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 709,
    code_postal: "19035",
    ok_postal_code: "19035",
    second_name: "Serdj El Ghoul",
    nom: "Serdj El Ghoul",
    wilaya_id: 19,
    commune_name: "سرج الغول",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 710,
    code_postal: "19036",
    ok_postal_code: "19036",
    second_name: "Harbil",
    nom: "Harbil",
    wilaya_id: 19,
    commune_name: "حربيل",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 711,
    code_postal: "19037",
    ok_postal_code: "19037",
    second_name: "El Ouricia",
    nom: "El Ouricia",
    wilaya_id: 19,
    commune_name: "أوريسيا",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:21:16",
  },
  {
    id: 712,
    code_postal: "19038",
    ok_postal_code: "19038",
    second_name: "Tizi N'Bechar",
    nom: "Tizi Nbechar",
    wilaya_id: 19,
    commune_name: "تيزي نبشار",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 713,
    code_postal: "19039",
    ok_postal_code: "19039",
    second_name: "Salah Bey",
    nom: "Salah Bey",
    wilaya_id: 19,
    commune_name: "صالح باي",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 714,
    code_postal: "19040",
    ok_postal_code: "19040",
    second_name: "A\u00efn Azel",
    nom: "Ain Azal",
    wilaya_id: 19,
    commune_name: "عين أزال",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 715,
    code_postal: "19041",
    ok_postal_code: "19041",
    second_name: "Guenzet",
    nom: "Guenzet",
    wilaya_id: 19,
    commune_name: "قنزات",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 716,
    code_postal: "19042",
    ok_postal_code: "19042",
    second_name: "Talaifacene",
    nom: "Talaifacene",
    wilaya_id: 19,
    commune_name: "تالة إيفاسن",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 717,
    code_postal: "19043",
    ok_postal_code: "19043",
    second_name: "Bougaa",
    nom: "Bougaa",
    wilaya_id: 19,
    commune_name: "بوقاعة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 718,
    code_postal: "19044",
    ok_postal_code: "19044",
    second_name: "Beni Fouda",
    nom: "Beni Fouda",
    wilaya_id: 19,
    commune_name: "بني فودة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 719,
    code_postal: "19045",
    ok_postal_code: "19045",
    second_name: "Tachouda",
    nom: "Tachouda",
    wilaya_id: 19,
    commune_name: "تاشودة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-10-26 14:24:12",
  },
  {
    id: 720,
    code_postal: "19046",
    ok_postal_code: "19046",
    second_name: "Beni Mouhli",
    nom: "Beni Mouhli",
    wilaya_id: 19,
    commune_name: "بني موحلي",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 721,
    code_postal: "19047",
    ok_postal_code: "19047",
    second_name: "Ouled Sabor",
    nom: "Ouled Sabor",
    wilaya_id: 19,
    commune_name: "أولاد صابر",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:23:13",
  },
  {
    id: 722,
    code_postal: "19048",
    ok_postal_code: "19048",
    second_name: "Guellal",
    nom: "Guellal",
    wilaya_id: 19,
    commune_name: "قلال",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 723,
    code_postal: "19049",
    ok_postal_code: "19049",
    second_name: "A\u00efn Sebt",
    nom: "Ain Sebt",
    wilaya_id: 19,
    commune_name: "عين السبت",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-10-26 14:24:38",
  },
  {
    id: 724,
    code_postal: "19050",
    ok_postal_code: "19050",
    second_name: "Hammam Guergour",
    nom: "Hammam Guergour",
    wilaya_id: 19,
    commune_name: "حمام قرقور",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 725,
    code_postal: "19051",
    ok_postal_code: "19051",
    second_name: "A\u00eft Naoual Mezada",
    nom: "Ait Naoual Mezada",
    wilaya_id: 19,
    commune_name: "أيت نوال مزادة",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 726,
    code_postal: "19052",
    ok_postal_code: "19052",
    second_name: "Ksar El Abtal",
    nom: "Ksar El Abtal",
    wilaya_id: 19,
    commune_name: "قصر الابطال",
    wilaya_name: "سطيف",
    hub_id: 76,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-01 14:23:24",
  },
  {
    id: 727,
    code_postal: "19053",
    ok_postal_code: "19053",
    second_name: "Beni Hocine",
    nom: "Beni Hocine",
    wilaya_id: 19,
    daira_name: "صالح باي",
    wilaya_name: "سطيف",
    // TODO(arabic-match):  "Beni Hocine". done
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 728,
    code_postal: "19054",
    ok_postal_code: "19054",
    second_name: "A\u00eft Tizi",
    nom: "Ait Tizi",
    wilaya_id: 19,
    commune_name: "ايت تيزي",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 729,
    code_postal: "19055",
    ok_postal_code: "19055",
    second_name: "Maoklane",
    nom: "Maouklane",
    wilaya_id: 19,
    commune_name: "ماوكلان",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 730,
    code_postal: "19056",
    ok_postal_code: "19056",
    second_name: "Guelta Zerka",
    nom: "Guelta Zerka",
    wilaya_id: 19,
    commune_name: "قلتة زرقاء",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 731,
    code_postal: "19057",
    ok_postal_code: "19057",
    second_name: "Oued El Barad",
    nom: "Oued El Barad",
    wilaya_id: 19,
    commune_name: "واد البارد",
    wilaya_name: "سطيف",
    hub_id: 82,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-20 18:48:34",
  },
  {
    id: 732,
    code_postal: "19058",
    ok_postal_code: "19058",
    second_name: "Taya",
    nom: "Taya",
    wilaya_id: 19,
    commune_name: "الطاية",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-10-26 14:24:58",
  },
  {
    id: 733,
    code_postal: "19059",
    ok_postal_code: "19059",
    second_name: "El Ouldja",
    nom: "El Ouldja",
    wilaya_id: 19,
    commune_name: "الولجة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-10-26 14:24:51",
  },
  {
    id: 734,
    code_postal: "19060",
    ok_postal_code: "19060",
    second_name: "Tella",
    nom: "Tella",
    wilaya_id: 19,
    commune_name: "التلة",
    wilaya_name: "سطيف",
    hub_id: 44,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 735,
    code_postal: "20001",
    ok_postal_code: "20001",
    second_name: "Sa\u00efda",
    nom: "Saida",
    wilaya_id: 20,
    commune_name: "سعيدة",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 736,
    code_postal: "20002",
    ok_postal_code: "20002",
    second_name: "Doui Thabet",
    nom: "Doui Thabet",
    wilaya_id: 20,
    commune_name: "دوي ثابت",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 737,
    code_postal: "20003",
    ok_postal_code: "20003",
    second_name: "A\u00efn El Hadjar",
    nom: "Ain El Hadjar",
    wilaya_id: 20,
    commune_name: "عين الحجر",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 738,
    code_postal: "20004",
    ok_postal_code: "20004",
    second_name: "Ouled Khaled",
    nom: "Ouled Khaled",
    wilaya_id: 20,
    commune_name: "أولاد خالد",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 739,
    code_postal: "20005",
    ok_postal_code: "20005",
    second_name: "Moulay Larbi",
    nom: "Moulay Larbi",
    wilaya_id: 20,
    commune_name: "مولاي العربي",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 740,
    code_postal: "20006",
    ok_postal_code: "20006",
    second_name: "Youb",
    nom: "Youb",
    wilaya_id: 20,
    commune_name: "يوب",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 741,
    code_postal: "20007",
    ok_postal_code: "20007",
    second_name: "Hounet",
    nom: "Hounet",
    wilaya_id: 20,
    commune_name: "هونت",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 742,
    code_postal: "20008",
    ok_postal_code: "20008",
    second_name: "Sidi Amar",
    nom: "Sidi Amar",
    wilaya_id: 20,
    commune_name: "سيدي عمر",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 743,
    code_postal: "20009",
    ok_postal_code: "20009",
    second_name: "Sidi Boubekeur",
    nom: "Sidi Boubekeur",
    wilaya_id: 20,
    commune_name: "سيدي بوبكر",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 744,
    code_postal: "20010",
    ok_postal_code: "20010",
    second_name: "El Hassasna",
    nom: "El Hassasna",
    wilaya_id: 20,
    commune_name: "الحساسنة",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 745,
    code_postal: "20011",
    ok_postal_code: "20011",
    second_name: "Maamora",
    nom: "Maamora",
    wilaya_id: 20,
    commune_name: "المعمورة",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 747,
    code_postal: "20013",
    ok_postal_code: "20013",
    second_name: "A\u00efn Sekhouna",
    nom: "Ain Sekhouna",
    wilaya_id: 20,
    commune_name: "عين السخونة",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 748,
    code_postal: "20014",
    ok_postal_code: "20014",
    second_name: "Ouled Brahim",
    nom: "Ouled Brahim",
    wilaya_id: 20,
    commune_name: "أولاد إبراهيم",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 749,
    code_postal: "20015",
    ok_postal_code: "20015",
    second_name: "Tircine",
    nom: "Tircine",
    wilaya_id: 20,
    commune_name: "تيرسين",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 750,
    code_postal: "20016",
    ok_postal_code: "20016",
    second_name: "A\u00efn Soltane",
    nom: "Ain Soltane",
    wilaya_id: 20,
    commune_name: "عين السلطان",
    wilaya_name: "سعيدة",
    hub_id: 45,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 751,
    code_postal: "21001",
    ok_postal_code: "21001",
    second_name: "Skikda",
    nom: "Skikda",
    wilaya_id: 21,
    commune_name: "سكيكدة",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 752,
    code_postal: "21002",
    ok_postal_code: "21002",
    second_name: "A\u00efn Zouit",
    nom: "Ain Zouit",
    wilaya_id: 21,
    commune_name: "عين زويت",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:11:00",
  },
  {
    id: 753,
    code_postal: "21003",
    ok_postal_code: "21003",
    second_name: "El Hadaiek",
    nom: "El Hadaik",
    wilaya_id: 21,
    commune_name: "الحدائق",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 754,
    code_postal: "21004",
    ok_postal_code: "21004",
    second_name: "Azzaba",
    nom: "Azzaba",
    wilaya_id: 21,
    commune_name: "عزابة",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-16 00:25:40",
  },
  {
    id: 755,
    code_postal: "21005",
    ok_postal_code: "21005",
    second_name: "Djendel Saadi Mohamed",
    nom: "Djendel Saadi Mohamed",
    wilaya_id: 21,
    commune_name: "جندل سعدي محمد",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 756,
    code_postal: "21006",
    ok_postal_code: "21006",
    second_name: "A\u00efn Charchar",
    nom: "Ain Cherchar",
    wilaya_id: 21,
    commune_name: "عين شرشار",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 757,
    code_postal: "21007",
    ok_postal_code: "21007",
    second_name: "Bekkouche Lakhdar",
    nom: "Bekkouche Lakhdar",
    wilaya_id: 21,
    commune_name: "بكوش لخضر",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 758,
    code_postal: "21008",
    ok_postal_code: "21008",
    second_name: "Ben Azzouz",
    nom: "Benazouz",
    wilaya_id: 21,
    commune_name: "بن عزوز",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 759,
    code_postal: "21009",
    ok_postal_code: "21009",
    second_name: "Es Sebt",
    nom: "Es Sebt",
    wilaya_id: 21,
    commune_name: "السبت",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 760,
    code_postal: "21010",
    ok_postal_code: "21010",
    second_name: "Collo",
    nom: "Collo",
    wilaya_id: 21,
    commune_name: "القل",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 761,
    code_postal: "21011",
    ok_postal_code: "21011",
    second_name: "Beni Zid",
    nom: "Beni Zid",
    wilaya_id: 21,
    commune_name: "بني زيد",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:56:26",
  },
  {
    id: 762,
    code_postal: "21012",
    ok_postal_code: "21012",
    second_name: "Kerkera",
    nom: "Kerkera",
    wilaya_id: 21,
    commune_name: "الكركرة",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 763,
    code_postal: "21013",
    ok_postal_code: "21013",
    second_name: "Ouled Attia",
    nom: "Ouled Attia",
    wilaya_id: 21,
    commune_name: "أولاد عطية",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:56:26",
  },
  {
    id: 764,
    code_postal: "21014",
    ok_postal_code: "21014",
    second_name: "Oued Zehour",
    nom: "Oued Zehour",
    wilaya_id: 21,
    commune_name: "وادي الزهور",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:11:00",
  },
  {
    id: 765,
    code_postal: "21015",
    ok_postal_code: "21015",
    second_name: "Zitouna",
    nom: "Zitouna",
    wilaya_id: 21,
    commune_name: "الزيتونة",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:56:26",
  },
  {
    id: 766,
    code_postal: "21016",
    ok_postal_code: "21016",
    second_name: "El Harrouch",
    nom: "El Harrouch",
    wilaya_id: 21,
    commune_name: "الحروش",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 767,
    code_postal: "21017",
    ok_postal_code: "21017",
    second_name: "Zerdaza",
    nom: "Zerdazas",
    wilaya_id: 21,
    commune_name: "زردازة",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 768,
    code_postal: "21018",
    ok_postal_code: "21018",
    second_name: "Ouled Hbaba",
    nom: "Ouled Hebaba",
    wilaya_id: 21,
    commune_name: "أولاد حبابة",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:11:38",
  },
  {
    id: 769,
    code_postal: "21019",
    ok_postal_code: "21019",
    second_name: "Sidi Mezghiche",
    nom: "Sidi Mezghiche",
    wilaya_id: 21,
    commune_name: "سيدي مزغيش",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-18 15:15:11",
  },
  {
    id: 770,
    code_postal: "21020",
    ok_postal_code: "21020",
    second_name: "Emdjez Edchich",
    nom: "Emdjez Edchich",
    wilaya_id: 21,
    commune_name: "مجاز الدشيش",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:04:02",
  },
  {
    id: 771,
    code_postal: "21021",
    ok_postal_code: "21021",
    second_name: "Beni Oulbane",
    nom: "Beni Oulbane",
    wilaya_id: 21,
    commune_name: "بني ولبان",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 772,
    code_postal: "21022",
    ok_postal_code: "21022",
    second_name: "A\u00efn Bouziane",
    nom: "Ain Bouziane",
    wilaya_id: 21,
    commune_name: "عين بوزيان",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:12:58",
  },
  {
    id: 773,
    code_postal: "21023",
    ok_postal_code: "21023",
    second_name: "Ramdane Djamel",
    nom: "Ramdane Djamel",
    wilaya_id: 21,
    commune_name: "رمضان جمال",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 774,
    code_postal: "21024",
    ok_postal_code: "21024",
    second_name: "Beni Bechir",
    nom: "Beni Bachir",
    wilaya_id: 21,
    commune_name: "بني بشير",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 775,
    code_postal: "21025",
    ok_postal_code: "21025",
    second_name: "Salah Bouchaour",
    nom: "Salah Bouchaour",
    wilaya_id: 21,
    commune_name: "صالح بو الشعور",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 776,
    code_postal: "21026",
    ok_postal_code: "21026",
    second_name: "Tamalous",
    nom: "Tamalous",
    wilaya_id: 21,
    commune_name: "تمالوس",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 777,
    code_postal: "21027",
    ok_postal_code: "21027",
    second_name: "A\u00efn Kechra",
    nom: "Ain Kechra",
    wilaya_id: 21,
    commune_name: "عين قشرة",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:56:26",
  },
  {
    id: 778,
    code_postal: "21028",
    ok_postal_code: "21028",
    second_name: "Oum Toub",
    nom: "Oum Toub",
    wilaya_id: 21,
    commune_name: "أم الطوب",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 779,
    code_postal: "21029",
    ok_postal_code: "21029",
    second_name: "Bin El Ouiden",
    nom: "Bein El Ouiden",
    wilaya_id: 21,
    commune_name: "بين الويدان",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 780,
    code_postal: "21030",
    ok_postal_code: "21030",
    second_name: "Filfila",
    nom: "Fil Fila",
    wilaya_id: 21,
    commune_name: "فلفلة",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 781,
    code_postal: "21031",
    ok_postal_code: "21031",
    second_name: "Cheraia",
    nom: "Cheraia",
    wilaya_id: 21,
    commune_name: "الشرايع",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 22:47:07",
  },
  {
    id: 782,
    code_postal: "21032",
    ok_postal_code: "21032",
    second_name: "Kanoua",
    nom: "Kanoua",
    wilaya_id: 21,
    commune_name: "قنواع",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:11:00",
  },
  {
    id: 783,
    code_postal: "21033",
    ok_postal_code: "21033",
    second_name: "El Ghedir",
    nom: "El Ghedir",
    wilaya_id: 21,
    commune_name: "الغدير",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 784,
    code_postal: "21034",
    ok_postal_code: "21034",
    second_name: "Bouchtata",
    nom: "Bouchtata",
    wilaya_id: 21,
    commune_name: "بوشطاطة",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 785,
    code_postal: "21035",
    ok_postal_code: "21035",
    second_name: "Ouldja Boulballout",
    nom: "Ouldja Boulbalout",
    wilaya_id: 21,
    commune_name: "الولجة بولبلوط",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:11:00",
  },
  {
    id: 786,
    code_postal: "21036",
    ok_postal_code: "21036",
    second_name: "Kheneg Mayoum",
    nom: "Kheneg Mayoum",
    wilaya_id: 21,
    commune_name: "خناق مايو",
    wilaya_name: "سكيكدة",
    hub_id: 116,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:11:00",
  },
  {
    id: 787,
    code_postal: "21037",
    ok_postal_code: "21037",
    second_name: "Hamadi Krouma",
    nom: "Hamadi Krouma",
    wilaya_id: 21,
    commune_name: "حمادي كرومة",
    wilaya_name: "سكيكدة",
    hub_id: 35,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 788,
    code_postal: "21038",
    ok_postal_code: "21038",
    second_name: "El Marsa",
    nom: "El Marsa",
    wilaya_id: 21,
    commune_name: "المرسى",
    wilaya_name: "سكيكدة",
    hub_id: 91,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-23 13:10:21",
  },
  {
    id: 789,
    code_postal: "22001",
    ok_postal_code: "22001",
    second_name: "Sidi Bel Abbes",
    nom: "Sidi Bel Abbes",
    wilaya_id: 22,
    commune_name: "سيدي بلعباس",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 790,
    code_postal: "22002",
    ok_postal_code: "22002",
    second_name: "Tessala",
    nom: "Tessala",
    wilaya_id: 22,
    commune_name: "تسالة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 791,
    code_postal: "22003",
    ok_postal_code: "22003",
    second_name: "Sidi Brahim",
    nom: "Sidi Brahim",
    wilaya_id: 22,
    commune_name: "سيدي ابراهيم",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 792,
    code_postal: "22004",
    ok_postal_code: "22004",
    second_name: "Mostefa Ben Brahim",
    nom: "Mostefa Ben Brahim",
    wilaya_id: 22,
    commune_name: "مصطفى بن ابراهيم",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 793,
    code_postal: "22005",
    ok_postal_code: "22005",
    second_name: "Telagh",
    nom: "Telagh",
    wilaya_id: 22,
    commune_name: "تلاغ",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 794,
    code_postal: "22006",
    ok_postal_code: "22006",
    second_name: "Mezaourou",
    nom: "Mezaourou",
    wilaya_id: 22,
    commune_name: "مزاورو",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 795,
    code_postal: "22007",
    ok_postal_code: "22007",
    second_name: "Boukhanafis",
    nom: "Boukhanafis",
    wilaya_id: 22,
    commune_name: "بوخنفيس",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 796,
    code_postal: "22008",
    ok_postal_code: "22008",
    second_name: "Sidi Ali Boussidi",
    nom: "Sidi Ali Boussidi",
    wilaya_id: 22,
    commune_name: "سيدي علي بوسيدي",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 797,
    code_postal: "22009",
    ok_postal_code: "22009",
    second_name: "Badredine El Mokrani",
    nom: "Badredine El Mokrani",
    wilaya_id: 22,
    commune_name: "بضرابين المقراني",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 798,
    code_postal: "22010",
    ok_postal_code: "22010",
    second_name: "Marhoum",
    nom: "Marhoum",
    wilaya_id: 22,
    commune_name: "مرحوم",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 799,
    code_postal: "22011",
    ok_postal_code: "22011",
    second_name: "Tafissour",
    nom: "Tafissour",
    wilaya_id: 22,
    commune_name: "تفسور",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 800,
    code_postal: "22012",
    ok_postal_code: "22012",
    second_name: "Amarnas",
    nom: "Amarnas",
    wilaya_id: 22,
    commune_name: "العمارنة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 801,
    code_postal: "22013",
    ok_postal_code: "22013",
    second_name: "Tilmouni",
    nom: "Tilmouni",
    wilaya_id: 22,
    commune_name: "تلموني",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 802,
    code_postal: "22014",
    ok_postal_code: "22014",
    second_name: "Sidi Lahcene",
    nom: "Sidi Lahcene",
    wilaya_id: 22,
    commune_name: "سيدي لحسن",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 803,
    code_postal: "22015",
    ok_postal_code: "22015",
    second_name: "A\u00efn Thrid",
    nom: "Ain Thrid",
    wilaya_id: 22,
    commune_name: "عين الثريد",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 804,
    code_postal: "22016",
    ok_postal_code: "22016",
    second_name: "Makedra",
    nom: "Makedra",
    wilaya_id: 22,
    commune_name: "مكدرة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 805,
    code_postal: "22017",
    ok_postal_code: "22017",
    second_name: "Tenira",
    nom: "Tenira",
    wilaya_id: 22,
    commune_name: "تنيرة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 806,
    code_postal: "22018",
    ok_postal_code: "22018",
    second_name: "Moulay Slissen",
    nom: "Moulay Slissen",
    wilaya_id: 22,
    commune_name: "مولاي سليسن",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 807,
    code_postal: "22019",
    ok_postal_code: "22019",
    second_name: "El Ha\u00e7aiba",
    nom: "El Hacaiba",
    wilaya_id: 22,
    commune_name: "الحصيبة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 808,
    code_postal: "22020",
    ok_postal_code: "22020",
    second_name: "Hassi Zehana",
    nom: "Hassi Zehana",
    wilaya_id: 22,
    commune_name: "حاسي زهانة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 809,
    code_postal: "22021",
    ok_postal_code: "22021",
    second_name: "Tabia",
    nom: "Tabia",
    wilaya_id: 22,
    commune_name: "طابية",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 810,
    code_postal: "22022",
    ok_postal_code: "22022",
    second_name: "Merine",
    nom: "Merine",
    wilaya_id: 22,
    commune_name: "مرين",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 811,
    code_postal: "22023",
    ok_postal_code: "22023",
    second_name: "Ras El Ma",
    nom: "Ras El Ma",
    wilaya_id: 22,
    commune_name: "راس الماء",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 812,
    code_postal: "22024",
    ok_postal_code: "22024",
    second_name: "A\u00efn Tindamine",
    nom: "Ain Tindamine",
    wilaya_id: 22,
    commune_name: "عين تندمين",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 813,
    code_postal: "22025",
    ok_postal_code: "22025",
    second_name: "A\u00efn Kada",
    nom: "Ain Kada",
    wilaya_id: 22,
    commune_name: "عين قادة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 814,
    code_postal: "22026",
    ok_postal_code: "22026",
    second_name: "M'Cid",
    nom: "Mcid",
    wilaya_id: 22,
    commune_name: "مسيد",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 815,
    code_postal: "22027",
    ok_postal_code: "22027",
    second_name: "Sidi Khaled",
    nom: "Sidi Khaled",
    wilaya_id: 22,
    commune_name: "سيدي خالد",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 816,
    code_postal: "22028",
    ok_postal_code: "22028",
    second_name: "A\u00efn El Berd",
    nom: "Ain El Berd",
    wilaya_id: 22,
    commune_name: "عين البرد",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 817,
    code_postal: "22029",
    ok_postal_code: "22029",
    second_name: "Sfisef",
    nom: "Sfissef",
    wilaya_id: 22,
    commune_name: "سفيزف",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 818,
    code_postal: "22030",
    ok_postal_code: "22030",
    second_name: "A\u00efn Adden",
    nom: "Ain Adden",
    wilaya_id: 22,
    commune_name: "عين أدن",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 819,
    code_postal: "22031",
    ok_postal_code: "22031",
    second_name: "Oued Taourira",
    nom: "Oued Taourira",
    wilaya_id: 22,
    commune_name: "وادي تاوريرة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 820,
    code_postal: "22032",
    ok_postal_code: "22032",
    second_name: "Dhaya",
    nom: "Dhaya",
    wilaya_id: 22,
    commune_name: "الضاية",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 821,
    code_postal: "22033",
    ok_postal_code: "22033",
    second_name: "Zerouala",
    nom: "Zerouala",
    wilaya_id: 22,
    commune_name: "زروالة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 822,
    code_postal: "22034",
    ok_postal_code: "22034",
    second_name: "Lamtar",
    nom: "Lamtar",
    wilaya_id: 22,
    commune_name: "لمطار",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 823,
    code_postal: "22035",
    ok_postal_code: "22035",
    second_name: "Sidi Chaib",
    nom: "Sidi Chaib",
    wilaya_id: 22,
    commune_name: "سيدي شعيب",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 824,
    code_postal: "22036",
    ok_postal_code: "22036",
    second_name: "Sidi Daho des Zairs",
    nom: "Sidi Dahou Dezairs",
    wilaya_id: 22,
    commune_name: "سيدي دحو الزاير",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 825,
    code_postal: "22037",
    ok_postal_code: "22037",
    second_name: "Oued Sebaa",
    nom: "Oued Sbaa",
    wilaya_id: 22,
    commune_name: "وادي السبع",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 826,
    code_postal: "22038",
    ok_postal_code: "22038",
    second_name: "Boudjebaa El Bordj",
    nom: "Boudjebaa El Bordj",
    wilaya_id: 22,
    commune_name: "بوجبهة البرج",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 827,
    code_postal: "22039",
    ok_postal_code: "22039",
    second_name: "Sehala Thaoura",
    nom: "Sehala Thaoura",
    wilaya_id: 22,
    commune_name: "السهالة الثورة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 828,
    code_postal: "22040",
    ok_postal_code: "22040",
    second_name: "Sidi Yacoub",
    nom: "Sidi Yacoub",
    wilaya_id: 22,
    commune_name: "سيدي يعقوب",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 829,
    code_postal: "22041",
    ok_postal_code: "22041",
    second_name: "Sidi Hamadouche",
    nom: "Sidi Hamadouche",
    wilaya_id: 22,
    commune_name: "سيدي حمادوش",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 830,
    code_postal: "22042",
    ok_postal_code: "22042",
    second_name: "Belarbi",
    nom: "Belarbi",
    wilaya_id: 22,
    commune_name: "بلعربي",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 831,
    code_postal: "22043",
    ok_postal_code: "22043",
    second_name: "Oued Sefioun",
    nom: "Oued Sefioun",
    wilaya_id: 22,
    commune_name: "وادي سفيون",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 832,
    code_postal: "22044",
    ok_postal_code: "22044",
    second_name: "Teghalimet",
    nom: "Teghalimet",
    wilaya_id: 22,
    commune_name: "تغاليمت",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 833,
    code_postal: "22045",
    ok_postal_code: "22045",
    second_name: "Ben Badis",
    nom: "Ben Badis",
    wilaya_id: 22,
    commune_name: "بن باديس",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 834,
    code_postal: "22046",
    ok_postal_code: "22046",
    second_name: "Sidi Ali Benyoub",
    nom: "Sidi Ali Benyoub",
    wilaya_id: 22,
    commune_name: "سيدي علي بن يوب",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 835,
    code_postal: "22047",
    ok_postal_code: "22047",
    second_name: "Chettouane Belaila",
    nom: "Chetouane Belaila",
    wilaya_id: 22,
    commune_name: "شيطوان البلايلة",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 836,
    code_postal: "22048",
    ok_postal_code: "22048",
    second_name: "Bir El Hammam",
    nom: "Bir El Hammam",
    wilaya_id: 22,
    commune_name: "بئر الحمام",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 837,
    code_postal: "22049",
    ok_postal_code: "22049",
    second_name: "Taoudmout",
    nom: "Taoudmout",
    wilaya_id: 22,
    commune_name: "تاودموت",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 838,
    code_postal: "22050",
    ok_postal_code: "22050",
    second_name: "Redjem Demouche",
    nom: "Redjem Demouche",
    wilaya_id: 22,
    commune_name: "رجم دموش",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 839,
    code_postal: "22051",
    ok_postal_code: "22051",
    second_name: "Benachiba Chelia",
    nom: "Benachiba Chelia",
    wilaya_id: 22,
    commune_name: "بن عشيبة شلية",
    wilaya_name: "سيدي بلعباس",
    hub_id: 108,
    is_active: 1,
    created_at: null,
    updated_at: "2026-05-08 13:45:17",
  },
  {
    id: 840,
    code_postal: "22052",
    ok_postal_code: "22052",
    second_name: "Hassi Dahou",
    nom: "Hassi Dahou",
    wilaya_id: 22,
    commune_name: "حاسي دحو",
    wilaya_name: "سيدي بلعباس",
    hub_id: 31,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 841,
    code_postal: "23001",
    ok_postal_code: "23001",
    second_name: "Annaba",
    nom: "Annaba",
    wilaya_id: 23,
    commune_name: "عنابة",
    wilaya_name: "عنابة",
    hub_id: 6,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:53:09",
  },
  {
    id: 842,
    code_postal: "23002",
    ok_postal_code: "23002",
    second_name: "Berrahal",
    nom: "Berrahel",
    wilaya_id: 23,
    commune_name: "برحال",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 843,
    code_postal: "23003",
    ok_postal_code: "23003",
    second_name: "El Hadjar",
    nom: "El Hadjar",
    wilaya_id: 23,
    commune_name: "الحجار",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-02 18:20:30",
  },
  {
    id: 844,
    code_postal: "23004",
    ok_postal_code: "23004",
    second_name: "Eulma",
    nom: "Eulma",
    wilaya_id: 23,
    commune_name: "العلمة",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 845,
    code_postal: "23005",
    ok_postal_code: "23005",
    second_name: "El Bouni",
    nom: "El Bouni",
    wilaya_id: 23,
    commune_name: "البوني",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 846,
    code_postal: "23006",
    ok_postal_code: "23006",
    second_name: "Oued El Aneb",
    nom: "Oued El Aneb",
    wilaya_id: 23,
    commune_name: "واد العنب",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 847,
    code_postal: "23007",
    ok_postal_code: "23007",
    second_name: "Cheurfa",
    nom: "Cheurfa",
    wilaya_id: 23,
    commune_name: "الشرفة",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 848,
    code_postal: "23008",
    ok_postal_code: "23008",
    second_name: "Sera\u00efdi",
    nom: "Seraidi",
    wilaya_id: 23,
    commune_name: "سرايدي",
    wilaya_name: "عنابة",
    hub_id: 6,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:54:02",
  },
  {
    id: 849,
    code_postal: "23009",
    ok_postal_code: "23009",
    second_name: "A\u00efn Berda",
    nom: "Ain Berda",
    wilaya_id: 23,
    commune_name: "عين الباردة",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 850,
    code_postal: "23010",
    ok_postal_code: "23010",
    second_name: "Cheta\u00efbi",
    nom: "Chetaibi",
    wilaya_id: 23,
    commune_name: "شطايبي",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 851,
    code_postal: "23011",
    ok_postal_code: "23011",
    second_name: null,
    nom: "Sidi Amer",
    wilaya_id: 23,
    commune_name: "سيدي عمار",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-07-25 13:16:22",
  },
  {
    id: 852,
    code_postal: "23012",
    ok_postal_code: "23012",
    second_name: "Treat",
    nom: "Treat",
    wilaya_id: 23,
    commune_name: "التريعات",
    wilaya_name: "عنابة",
    hub_id: 84,
    is_active: 1,
    created_at: null,
    updated_at: "2025-02-07 18:08:19",
  },
  {
    id: 853,
    code_postal: "24001",
    ok_postal_code: "24001",
    second_name: "Guelma",
    nom: "Guelma",
    wilaya_id: 24,
    commune_name: "قالمة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 854,
    code_postal: "24002",
    ok_postal_code: "24002",
    second_name: "Nechmaya",
    nom: "Nechmaya",
    wilaya_id: 24,
    commune_name: "نشماية",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 855,
    code_postal: "24003",
    ok_postal_code: "24003",
    second_name: "Bouati Mahmoud",
    nom: "Bouati Mahmoud",
    wilaya_id: 24,
    commune_name: "بوعاتي محمود",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 856,
    code_postal: "24004",
    ok_postal_code: "24004",
    second_name: "Oued Zenati",
    nom: "Oued Zenati",
    wilaya_id: 24,
    commune_name: "وادي الزناتي",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 857,
    code_postal: "24005",
    ok_postal_code: "24005",
    second_name: "Tamlouka",
    nom: "Tamlouka",
    wilaya_id: 24,
    commune_name: "تاملوكة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 858,
    code_postal: "24006",
    ok_postal_code: "24006",
    second_name: "Oued Fragha",
    nom: "Oued Fragha",
    wilaya_id: 24,
    commune_name: "وادي فراغة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 859,
    code_postal: "24007",
    ok_postal_code: "24007",
    second_name: "A\u00efn Sandel",
    nom: "Ain Sandel",
    wilaya_id: 24,
    commune_name: "عين صندل",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 860,
    code_postal: "24008",
    ok_postal_code: "24008",
    second_name: "Ras El Agba",
    nom: "Ras El Agba",
    wilaya_id: 24,
    commune_name: "رأس العقبة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 861,
    code_postal: "24009",
    ok_postal_code: "24009",
    second_name: "Dahouara",
    nom: "Dahouara",
    wilaya_id: 24,
    commune_name: "الدهوارة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 862,
    code_postal: "24010",
    ok_postal_code: "24010",
    second_name: "Belkheir",
    nom: "Belkhir",
    wilaya_id: 24,
    commune_name: "بلخير",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 863,
    code_postal: "24011",
    ok_postal_code: "24011",
    second_name: "Ben Djerrah",
    nom: "Ben Djarah",
    wilaya_id: 24,
    commune_name: "بن جراح",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 864,
    code_postal: "24012",
    ok_postal_code: "24012",
    second_name: "Bouhamdane",
    nom: "Bou Hamdane",
    wilaya_id: 24,
    commune_name: "بوحمدان",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 865,
    code_postal: "24013",
    ok_postal_code: "24013",
    second_name: "A\u00efn Makhlouf",
    nom: "Ain Makhlouf",
    wilaya_id: 24,
    commune_name: "عين مخلوف",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 866,
    code_postal: "24014",
    ok_postal_code: "24014",
    second_name: "A\u00efn Ben Beida",
    nom: "Ain Ben Beida",
    wilaya_id: 24,
    commune_name: "عين بن بيضاء",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 867,
    code_postal: "24015",
    ok_postal_code: "24015",
    second_name: "Khezarra",
    nom: "Khezara",
    wilaya_id: 24,
    commune_name: "لخزارة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 868,
    code_postal: "24016",
    ok_postal_code: "24016",
    second_name: "Beni Mezline",
    nom: "Beni Mezline",
    wilaya_id: 24,
    commune_name: "بني مزلين",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 869,
    code_postal: "24017",
    ok_postal_code: "24017",
    second_name: "Bouhachana",
    nom: "Bou Hachana",
    wilaya_id: 24,
    commune_name: "بوحشانة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 870,
    code_postal: "24018",
    ok_postal_code: "24018",
    second_name: "Guellat Bou Sbaa",
    nom: "Guelaat Bou Sbaa",
    wilaya_id: 24,
    commune_name: "قلعة بوصبع",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 871,
    code_postal: "24019",
    ok_postal_code: "24019",
    second_name: "Hammam Debagh",
    nom: "Hammam Maskhoutine",
    wilaya_id: 24,
    commune_name: "حمام دباغ",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 872,
    code_postal: "24020",
    ok_postal_code: "24020",
    second_name: "El Fedjoudj",
    nom: "El Fedjoudj",
    wilaya_id: 24,
    commune_name: "الفجوج",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 873,
    code_postal: "24021",
    ok_postal_code: "24021",
    second_name: "Bordj Sabath",
    nom: "Bordj Sabat",
    wilaya_id: 24,
    commune_name: "برج صباط",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 874,
    code_postal: "24022",
    ok_postal_code: "24022",
    second_name: "Hammam N'Bail",
    nom: "Hamman Nbail",
    wilaya_id: 24,
    commune_name: "حمام النبايل",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 876,
    code_postal: "24024",
    ok_postal_code: "24024",
    second_name: "Medjez Amar",
    nom: "Medjez Amar",
    wilaya_id: 24,
    commune_name: "مجاز عمار",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 877,
    code_postal: "24025",
    ok_postal_code: "24025",
    second_name: "Bouchegouf",
    nom: "Bouchegouf",
    wilaya_id: 24,
    commune_name: "بوشقوف",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 878,
    code_postal: "24026",
    ok_postal_code: "24026",
    second_name: "H\u00e9liopolis",
    nom: "Heliopolis",
    wilaya_id: 24,
    commune_name: "هيليوبوليس",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 879,
    code_postal: "24027",
    ok_postal_code: "24027",
    second_name: "Houari Boum\u00e9di\u00e8ne",
    nom: "Ain Hessania",
    wilaya_id: 24,
    commune_name: "هواري بومدين",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 880,
    code_postal: "24028",
    ok_postal_code: "24028",
    second_name: "Roknia",
    nom: "Roknia",
    wilaya_id: 24,
    commune_name: "الركنية",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2024-07-16 16:09:27",
  },
  {
    id: 881,
    code_postal: "24029",
    ok_postal_code: "24029",
    second_name: "Sellaoua Announa",
    nom: "Salaoua Announa",
    wilaya_id: 24,
    commune_name: "سلاوة عنونة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 882,
    code_postal: "24030",
    ok_postal_code: "24030",
    second_name: "Medjez Sfa",
    nom: "Medjez Sfa",
    wilaya_id: 24,
    commune_name: "مجاز الصفاء",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 883,
    code_postal: "24031",
    ok_postal_code: "24031",
    second_name: "Boumahra Ahmed",
    nom: "Boumahra Ahmed",
    wilaya_id: 24,
    commune_name: "بومهرة أحمد",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 884,
    code_postal: "24032",
    ok_postal_code: "24032",
    second_name: "A\u00efn Reggada",
    nom: "Ain Reggada",
    wilaya_id: 24,
    commune_name: "عين رقادة",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 885,
    code_postal: "24033",
    ok_postal_code: "24033",
    second_name: "Oued Cheham",
    nom: "Oued Cheham",
    wilaya_id: 24,
    commune_name: "وادي الشحم",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 886,
    code_postal: "24034",
    ok_postal_code: "24034",
    second_name: "Djeballah Khemissi",
    nom: "Djeballah Khemissi",
    wilaya_id: 24,
    commune_name: "جبالة الخميسي",
    wilaya_name: "قالمة",
    hub_id: 27,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 887,
    code_postal: "25001",
    ok_postal_code: "25001",
    second_name: "Constantine",
    nom: "Constantine",
    wilaya_id: 25,
    commune_name: "قسنطينة",
    wilaya_name: "قسنطينة",
    hub_id: 75,
    is_active: 1,
    created_at: null,
    updated_at: "2024-10-18 21:35:43",
  },
  {
    id: 888,
    code_postal: "25002",
    ok_postal_code: "25002",
    second_name: "Hamma Bouziane",
    nom: "Hamma Bouziane",
    wilaya_id: 25,
    commune_name: "حامة بوزيان",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 889,
    code_postal: "25003",
    ok_postal_code: "25003",
    second_name: "Ibn Badis",
    nom: "Ben Badis",
    wilaya_id: 25,
    commune_name: "أبن باديس الهرية",
    wilaya_name: "قسنطينة",
    hub_id: 52,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 890,
    code_postal: "25004",
    ok_postal_code: "25004",
    second_name: "Zighoud Youcef",
    nom: "Zighoud Youcef",
    wilaya_id: 25,
    commune_name: "زيغود يوسف",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 891,
    code_postal: "25005",
    ok_postal_code: "25005",
    second_name: "Didouche Mourad",
    nom: "Didouche Mourad",
    wilaya_id: 25,
    commune_name: "ديدوش مراد",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 892,
    code_postal: "25006",
    ok_postal_code: "25006",
    second_name: "El Khroub",
    nom: "El Khroub",
    wilaya_id: 25,
    commune_name: "الخروب",
    wilaya_name: "قسنطينة",
    hub_id: 52,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 893,
    code_postal: "25007",
    ok_postal_code: "25007",
    second_name: "A\u00efn Abid",
    nom: "Ain Abid",
    wilaya_id: 25,
    commune_name: "عين عبيد",
    wilaya_name: "قسنطينة",
    hub_id: 52,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 894,
    code_postal: "25008",
    ok_postal_code: "25008",
    second_name: "Beni Hamiden",
    nom: "Beni Hamiden",
    wilaya_id: 25,
    commune_name: "بني حميدان",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 895,
    code_postal: "25009",
    ok_postal_code: "25009",
    second_name: "Ouled Rahmoune",
    nom: "Ouled Rahmoune",
    wilaya_id: 25,
    commune_name: "أولاد رحمون",
    wilaya_name: "قسنطينة",
    hub_id: 52,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 896,
    code_postal: "25010",
    ok_postal_code: "25010",
    second_name: "A\u00efn Smara",
    nom: "Ain Smara",
    wilaya_id: 25,
    commune_name: "عين السمارة",
    wilaya_name: "قسنطينة",
    hub_id: 52,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 897,
    code_postal: "25011",
    ok_postal_code: "25011",
    second_name: "Messaoud Boudjriou",
    nom: "Mesaoud Boudjeriou",
    wilaya_id: 25,
    commune_name: "بوجريو مسعود",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 898,
    code_postal: "25012",
    ok_postal_code: "25012",
    second_name: "Ibn Ziad",
    nom: "Ibn Ziad",
    wilaya_id: 25,
    commune_name: "ابن زياد",
    wilaya_name: "قسنطينة",
    hub_id: 5,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 899,
    code_postal: "26001",
    ok_postal_code: "26001",
    second_name: "M\u00e9d\u00e9a",
    nom: "Medea",
    wilaya_id: 26,
    commune_name: "المدية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 900,
    code_postal: "26002",
    ok_postal_code: "26002",
    second_name: "Ouzera",
    nom: "Ouzera",
    wilaya_id: 26,
    commune_name: "وزرة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 901,
    code_postal: "26003",
    ok_postal_code: "26003",
    second_name: "Ouled Maaref",
    nom: "Ouled Maaref",
    wilaya_id: 26,
    commune_name: "أولاد امعرف",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 902,
    code_postal: "26004",
    ok_postal_code: "26004",
    second_name: "A\u00efn Boucif",
    nom: "Ain Boucif",
    wilaya_id: 26,
    commune_name: "عين بوسيف",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 903,
    code_postal: "26005",
    ok_postal_code: "26005",
    second_name: "Aissaouia",
    nom: "Aissaouia",
    wilaya_id: 26,
    commune_name: "العيساوية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 904,
    code_postal: "26006",
    ok_postal_code: "26006",
    second_name: "Ouled Deide",
    nom: "Ouled Deide",
    wilaya_id: 26,
    commune_name: "أولاد دايد",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 905,
    code_postal: "26007",
    ok_postal_code: "26007",
    second_name: "El Omaria",
    nom: "El Omaria",
    wilaya_id: 26,
    commune_name: "العمارية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 906,
    code_postal: "26008",
    ok_postal_code: "26008",
    second_name: "Derrag",
    nom: "Derrag",
    wilaya_id: 26,
    commune_name: "دراق",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 907,
    code_postal: "26009",
    ok_postal_code: "26009",
    second_name: "El Guelb El Kebir",
    nom: "El Guelbelkebir",
    wilaya_id: 26,
    commune_name: "القلب الكبير",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 908,
    code_postal: "26010",
    ok_postal_code: "26010",
    second_name: "Bou Aiche",
    nom: "Bouaiche",
    wilaya_id: 26,
    commune_name: "بوعيش",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 909,
    code_postal: "26011",
    ok_postal_code: "26011",
    second_name: "Mezerana",
    nom: "Mezerena",
    wilaya_id: 26,
    commune_name: "مزغنة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 910,
    code_postal: "26012",
    ok_postal_code: "26012",
    second_name: "Ouled Brahim",
    nom: "Ouled Brahim",
    wilaya_id: 26,
    commune_name: "أولاد إبراهيم",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 911,
    code_postal: "26013",
    ok_postal_code: "26013",
    second_name: "Tizi Mahdi",
    nom: "Damiat",
    wilaya_id: 26,
    commune_name: "تيزي مهدي",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 912,
    code_postal: "26014",
    ok_postal_code: "26014",
    second_name: "Sidi Ziane",
    nom: "Sidi Ziane",
    wilaya_id: 26,
    commune_name: "سيدي زيان",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 913,
    code_postal: "26015",
    ok_postal_code: "26015",
    second_name: "Tamesguida",
    nom: "Tamesguida",
    wilaya_id: 26,
    commune_name: "تمسقيدة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 914,
    code_postal: "26016",
    ok_postal_code: "26016",
    second_name: "El Hamdania",
    nom: "El Hamdania",
    wilaya_id: 26,
    commune_name: "الحمدانية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 915,
    code_postal: "26017",
    ok_postal_code: "26017",
    second_name: "Kef Lakhdar",
    nom: "Kef Lakhdar",
    wilaya_id: 26,
    commune_name: "الكاف الاخضر",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 916,
    code_postal: "26018",
    ok_postal_code: "26018",
    second_name: "Chellalet El Adhaoura",
    nom: "Chelalet El Adhaoura",
    wilaya_id: 26,
    commune_name: "شلالة العذاورة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 917,
    code_postal: "26019",
    ok_postal_code: "26019",
    second_name: "Bouskene",
    nom: "Bouskene",
    wilaya_id: 26,
    commune_name: "بوسكن",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 918,
    code_postal: "26020",
    ok_postal_code: "26020",
    second_name: "Rebaia",
    nom: "Rebaia",
    wilaya_id: 26,
    commune_name: "الربعية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 919,
    code_postal: "26021",
    ok_postal_code: "26021",
    second_name: "Bouchrahil",
    nom: "Bouchrahil",
    wilaya_id: 26,
    commune_name: "بوشراحيل",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 920,
    code_postal: "26022",
    ok_postal_code: "26022",
    second_name: "Ouled Hellal",
    nom: "Ouled Hellal",
    wilaya_id: 26,
    commune_name: "أولاد هلال",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 921,
    code_postal: "26023",
    ok_postal_code: "26023",
    second_name: "Tafraout",
    nom: "Tafraout",
    wilaya_id: 26,
    commune_name: "تفراوت",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 922,
    code_postal: "26024",
    ok_postal_code: "26024",
    second_name: "Baata",
    nom: "Baata",
    wilaya_id: 26,
    commune_name: "بعطة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 923,
    code_postal: "26025",
    ok_postal_code: "26025",
    second_name: "Boghar",
    nom: "Boghar",
    wilaya_id: 26,
    commune_name: "بوغار",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 924,
    code_postal: "26026",
    ok_postal_code: "26026",
    second_name: "Sidi Naamanez",
    nom: "Sidi Naamane",
    wilaya_id: 26,
    commune_name: "سيدي نعمان",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 925,
    code_postal: "26027",
    ok_postal_code: "26027",
    second_name: "Ouled Bouachra",
    nom: "Ouled Bouachra",
    wilaya_id: 26,
    commune_name: "أولاد بوعشرة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 926,
    code_postal: "26028",
    ok_postal_code: "26028",
    second_name: "Sidi Zahar",
    nom: "Sidi Zahar",
    wilaya_id: 26,
    commune_name: "سيدي زهار",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 927,
    code_postal: "26029",
    ok_postal_code: "26029",
    second_name: "Oued Harbil",
    nom: "Oued Harbil",
    wilaya_id: 26,
    commune_name: "وادي حربيل",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 928,
    code_postal: "26030",
    ok_postal_code: "26030",
    second_name: "Benchicao",
    nom: "Benchicao",
    wilaya_id: 26,
    commune_name: "بن شكاو",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 929,
    code_postal: "26031",
    ok_postal_code: "26031",
    second_name: "Sidi Damed",
    nom: "Sidi Damed",
    wilaya_id: 26,
    commune_name: "سيدي دامد",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 930,
    code_postal: "26032",
    ok_postal_code: "26032",
    second_name: "Aziz",
    nom: "Aziz",
    wilaya_id: 26,
    commune_name: "عزيز",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 931,
    code_postal: "26033",
    ok_postal_code: "26033",
    second_name: "Souagui",
    nom: "Souagui",
    wilaya_id: 26,
    commune_name: "السواقي",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 932,
    code_postal: "26034",
    ok_postal_code: "26034",
    second_name: "Zoubiria",
    nom: "Zoubiria",
    wilaya_id: 26,
    commune_name: "الزبيرية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 933,
    code_postal: "26035",
    ok_postal_code: "26035",
    second_name: "Ksar Boukhari",
    nom: "Ksar El Boukhari",
    wilaya_id: 26,
    commune_name: "قصر البخاري",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 934,
    code_postal: "26036",
    ok_postal_code: "26036",
    second_name: "El Azizia",
    nom: "El Azizia",
    wilaya_id: 26,
    commune_name: "العزيزية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 935,
    code_postal: "26037",
    ok_postal_code: "26037",
    second_name: "Djouab",
    nom: "Djouab",
    wilaya_id: 26,
    commune_name: "جواب",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 936,
    code_postal: "26038",
    ok_postal_code: "26038",
    second_name: "Chahbounia",
    nom: "Chahbounia",
    wilaya_id: 26,
    commune_name: "الشهبونية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 937,
    code_postal: "26039",
    ok_postal_code: "26039",
    second_name: "Meghraoua",
    nom: "Meghraoua",
    wilaya_id: 26,
    commune_name: "مغراوة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 938,
    code_postal: "26040",
    ok_postal_code: "26040",
    second_name: "Cheniguel",
    nom: "Cheniguel",
    wilaya_id: 26,
    commune_name: "شنيقل",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 939,
    code_postal: "26041",
    ok_postal_code: "26041",
    second_name: "A\u00efn Ouksir",
    nom: "Ain Ouksir",
    wilaya_id: 26,
    commune_name: "عين اقصير",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 940,
    code_postal: "26042",
    ok_postal_code: "26042",
    second_name: "Oum El Djalil",
    nom: "Oum El Djalil",
    wilaya_id: 26,
    commune_name: "أم الجليل",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 941,
    code_postal: "26043",
    ok_postal_code: "26043",
    second_name: "Ouamri",
    nom: "Ouamri",
    wilaya_id: 26,
    commune_name: "عوامري",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 942,
    code_postal: "26044",
    ok_postal_code: "26044",
    second_name: "Si Mahdjoub",
    nom: "Si Mahdjoub",
    wilaya_id: 26,
    commune_name: "سي المحجوب",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 943,
    code_postal: "26045",
    ok_postal_code: "26045",
    second_name: "Tlatet Eddouar",
    nom: "Tlatet Eddoair",
    wilaya_id: 26,
    commune_name: "ثلاث دوائر",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 944,
    code_postal: "26046",
    ok_postal_code: "26046",
    second_name: "Beni Slimane",
    nom: "Beni Slimane",
    wilaya_id: 26,
    commune_name: "بني سليمان",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 945,
    code_postal: "26047",
    ok_postal_code: "26047",
    second_name: "Berrouaghia",
    nom: "Berrouaghia",
    wilaya_id: 26,
    commune_name: "البرواقية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 946,
    code_postal: "26048",
    ok_postal_code: "26048",
    second_name: "Seghouane",
    nom: "Seghouane",
    wilaya_id: 26,
    commune_name: "سغوان",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 947,
    code_postal: "26049",
    ok_postal_code: "26049",
    second_name: "Meftaha",
    nom: "Meftaha",
    wilaya_id: 26,
    commune_name: "مفاتحة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 948,
    code_postal: "26050",
    ok_postal_code: "26050",
    second_name: "Mihoub",
    nom: "Mihoub",
    wilaya_id: 26,
    commune_name: "ميهوب",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 949,
    code_postal: "26051",
    ok_postal_code: "26051",
    second_name: "Boughezoul",
    nom: "Boughezoul",
    wilaya_id: 26,
    commune_name: "بوغزول",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 950,
    code_postal: "26052",
    ok_postal_code: "26052",
    second_name: "Tablat",
    nom: "Tablat",
    wilaya_id: 26,
    commune_name: "تابلاط",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 951,
    code_postal: "26053",
    ok_postal_code: "26053",
    second_name: "Deux Bassins",
    nom: "Deux Bassins",
    wilaya_id: 26,
        "commune_name": "سيدي دامد",

    // TODO(arabic-match):  "Deux Bassins".
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 952,
    code_postal: "26054",
    ok_postal_code: "26054",
    second_name: "Draa Essamar",
    nom: "Draa Essamar",
    wilaya_id: 26,
    commune_name: "ذراع السمار",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 953,
    code_postal: "26055",
    ok_postal_code: "26055",
    second_name: "Sidi Errabia",
    nom: "Sidi Errabia",
    wilaya_id: 26,
    commune_name: "سيدي الربيع",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 954,
    code_postal: "26056",
    ok_postal_code: "26056",
    second_name: "Bir Ben Laabed",
    nom: "Bir Ben Laabed",
    wilaya_id: 26,
    commune_name: "بئر بن عابد",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 955,
    code_postal: "26057",
    ok_postal_code: "26057",
    second_name: "El Ouinet",
    nom: "El Ouinet",
    wilaya_id: 26,
    commune_name: "العوينات",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 956,
    code_postal: "26058",
    ok_postal_code: "26058",
    second_name: "Ouled Antar",
    nom: "Ouled Antar",
    wilaya_id: 26,
    commune_name: "أولاد عنتر",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 957,
    code_postal: "26059",
    ok_postal_code: "26059",
    second_name: "Bouaichoune",
    nom: "Bouaichoune",
    wilaya_id: 26,
    commune_name: "بوعيشون",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 958,
    code_postal: "26060",
    ok_postal_code: "26060",
    second_name: "Hannacha",
    nom: "Hannacha",
    wilaya_id: 26,
    commune_name: "حناشة",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 959,
    code_postal: "26061",
    ok_postal_code: "26061",
    second_name: "Sedraia",
    nom: "Sedraia",
    wilaya_id: 26,
    commune_name: "سدراية",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 960,
    code_postal: "26062",
    ok_postal_code: "26062",
    second_name: "Moudjbar",
    nom: "Medjebar",
    wilaya_id: 26,
    commune_name: "مجبر",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 961,
    code_postal: "26063",
    ok_postal_code: "26063",
    second_name: "Khams Djouamaa",
    nom: "Khams Djouamaa",
    wilaya_id: 26,
    commune_name: "خمس جوامع",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 962,
    code_postal: "26064",
    ok_postal_code: "26064",
    second_name: "Saneg",
    nom: "Saneg",
    wilaya_id: 26,
    commune_name: "السانق",
    wilaya_name: "المدية",
    hub_id: 47,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 963,
    code_postal: "27001",
    ok_postal_code: "27001",
    second_name: "Mostaganem",
    nom: "Mostaganem",
    wilaya_id: 27,
    commune_name: "مستغانم",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 964,
    code_postal: "27002",
    ok_postal_code: "27002",
    second_name: "Sayada",
    nom: "Sayada",
    wilaya_id: 27,
    commune_name: "صيادة",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 965,
    code_postal: "27003",
    ok_postal_code: "27003",
    second_name: "Fornaka",
    nom: "Fornaka",
    wilaya_id: 27,
    commune_name: "فرناقة",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 966,
    code_postal: "27004",
    ok_postal_code: "27004",
    second_name: "Stidia",
    nom: "Stidia",
    wilaya_id: 27,
    commune_name: "ستيدية",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 967,
    code_postal: "27005",
    ok_postal_code: "27005",
    second_name: "A\u00efn Nouissy",
    nom: "Ain Nouissy",
    wilaya_id: 27,
    commune_name: "عين نويسي",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 968,
    code_postal: "27006",
    ok_postal_code: "27006",
    second_name: "Hassi Mameche",
    nom: "Hassi Maameche",
    wilaya_id: 27,
    commune_name: "حاسي ماماش",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 969,
    code_postal: "27007",
    ok_postal_code: "27007",
    second_name: "A\u00efn Tedles",
    nom: "Ain Tadles",
    wilaya_id: 27,
    commune_name: "عين تادلس",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:18:43",
  },
  {
    id: 970,
    code_postal: "27008",
    ok_postal_code: "27008",
    second_name: "Sour",
    nom: "Sour",
    wilaya_id: 27,
    commune_name: "سور",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:18:43",
  },
  {
    id: 971,
    code_postal: "27009",
    ok_postal_code: "27009",
    second_name: "Oued El Kheir",
    nom: "Oued El Kheir",
    wilaya_id: 27,
    commune_name: "وادي الخير",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 972,
    code_postal: "27010",
    ok_postal_code: "27010",
    second_name: "Sidi Belattar",
    nom: "Sidi Bellater",
    wilaya_id: 27,
    commune_name: "سيدي بلعطار",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-14 13:18:43",
  },
  {
    id: 973,
    code_postal: "27011",
    ok_postal_code: "27011",
    second_name: "Kheireddine",
    nom: "Kheiredine ",
    wilaya_id: 27,
    commune_name: "خير الدين",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 974,
    code_postal: "27012",
    ok_postal_code: "27012",
    second_name: "Sidi Ali",
    nom: "Sidi Ali",
    wilaya_id: 27,
    commune_name: "سيدي علي",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 975,
    code_postal: "27013",
    ok_postal_code: "27013",
    second_name: "Abdelmalek Ramdane",
    nom: "Abdelmalek Ramdane",
    wilaya_id: 27,
    commune_name: "بن عبد المالك رمضان",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 976,
    code_postal: "27014",
    ok_postal_code: "27014",
    second_name: "Hadjadj",
    nom: "Hadjadj",
    wilaya_id: 27,
    commune_name: "حجاج",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 977,
    code_postal: "27015",
    ok_postal_code: "27015",
    second_name: "Nekmaria",
    nom: "Nekmaria",
    wilaya_id: 27,
    commune_name: "نكمارية",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 978,
    code_postal: "27016",
    ok_postal_code: "27016",
    second_name: "Sidi Lakhdar",
    nom: "Sidi Lakhdar",
    wilaya_id: 27,
    commune_name: "سيدي لخضر",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 979,
    code_postal: "27017",
    ok_postal_code: "27017",
    second_name: "Achaacha",
    nom: "Achaacha",
    wilaya_id: 27,
    commune_name: "عشعاشة",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 980,
    code_postal: "27018",
    ok_postal_code: "27018",
    second_name: "Khadra",
    nom: "Khadra",
    wilaya_id: 27,
    commune_name: "خضرة",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 981,
    code_postal: "27019",
    ok_postal_code: "27019",
    second_name: "Bouguirat",
    nom: "Bouguirat",
    wilaya_id: 27,
    commune_name: "بوقيراط",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 982,
    code_postal: "27020",
    ok_postal_code: "27020",
    second_name: "Sirat",
    nom: "Sirat",
    wilaya_id: 27,
    commune_name: "سيرات",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 983,
    code_postal: "27021",
    ok_postal_code: "27021",
    second_name: "A\u00efn Sidi Cherif",
    nom: "Ain Sidi Cherif",
    wilaya_id: 27,
    commune_name: "عين سيدي الشريف",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 984,
    code_postal: "27022",
    ok_postal_code: "27022",
    second_name: "Mesra",
    nom: "Mesra",
    wilaya_id: 27,
    commune_name: "ماسرة",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 985,
    code_postal: "27023",
    ok_postal_code: "27023",
    second_name: "Mansourah",
    nom: "Mansourah",
    wilaya_id: 27,
    commune_name: "منصورة",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 986,
    code_postal: "27024",
    ok_postal_code: "27024",
    second_name: "Souaflia",
    nom: "Souaflia",
    wilaya_id: 27,
    commune_name: "السوافلية",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 987,
    code_postal: "27025",
    ok_postal_code: "27025",
    second_name: "Ouled Boughalem",
    nom: "Ouled Boughalem",
    wilaya_id: 27,
    commune_name: "أولاد بوغالم",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 988,
    code_postal: "27026",
    ok_postal_code: "27026",
    second_name: "Ouled Maallah",
    nom: "Ouled Maallah",
    wilaya_id: 27,
    commune_name: "أولاد مع الله",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 989,
    code_postal: "27027",
    ok_postal_code: "27027",
    second_name: "Mazagran",
    nom: "Mezghrane",
    wilaya_id: 27,
    commune_name: "مزغران",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 990,
    code_postal: "27028",
    ok_postal_code: "27028",
    second_name: "A\u00efn Boudinar",
    nom: "Ain Boudinar",
    wilaya_id: 27,
    commune_name: "عين بودينار",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 991,
    code_postal: "27029",
    ok_postal_code: "27029",
    second_name: "Tazgait",
    nom: "Tazgait",
    wilaya_id: 27,
    commune_name: "تزقايت",
    wilaya_name: "مستغانم",
    hub_id: 92,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 16:42:03",
  },
  {
    id: 992,
    code_postal: "27030",
    ok_postal_code: "27030",
    second_name: "Safsaf",
    nom: "Safsaf",
    wilaya_id: 27,
    commune_name: "صفصاف",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 993,
    code_postal: "27031",
    ok_postal_code: "27031",
    second_name: "Blad Touahria",
    nom: "Touahria",
    wilaya_id: 27,
    commune_name: "الطواهرية",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 994,
    code_postal: "27032",
    ok_postal_code: "27032",
    second_name: "El Hassaine",
    nom: "El Hassiane",
    wilaya_id: 27,
    commune_name: "الحسيان (بني ياحي",
    wilaya_name: "مستغانم",
    hub_id: 38,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 995,
    code_postal: "28001",
    ok_postal_code: "28001",
    second_name: "M'Sila",
    nom: "Msila",
    wilaya_id: 28,
    commune_name: "المسيلة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-17 10:10:49",
  },
  {
    id: 996,
    code_postal: "28002",
    ok_postal_code: "28002",
    second_name: "Maadid",
    nom: "Maadid",
    wilaya_id: 28,
    commune_name: "المعاضيد",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 997,
    code_postal: "28003",
    ok_postal_code: "28003",
    second_name: "Hammam Dhalaa",
    nom: "Hammam Dhalaa",
    wilaya_id: 28,
    commune_name: "حمام الضلعة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 998,
    code_postal: "28004",
    ok_postal_code: "28004",
    second_name: "Ouled Derradj",
    nom: "Ouled Derradj",
    wilaya_id: 28,
    commune_name: "أولاد دراج",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 999,
    code_postal: "28005",
    ok_postal_code: "28005",
    second_name: "Tarmount",
    nom: "Tarmount",
    wilaya_id: 28,
    commune_name: "تارمونت",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1000,
    code_postal: "28006",
    ok_postal_code: "28006",
    second_name: "M'Tarfa",
    nom: "Mtarfa",
    wilaya_id: 28,
    commune_name: "المطارفة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1001,
    code_postal: "28007",
    ok_postal_code: "28007",
    second_name: "Khoubana",
    nom: "Khoubana",
    wilaya_id: 28,
    commune_name: "خبانة",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-15 11:43:00",
  },
  {
    id: 1002,
    code_postal: "28008",
    ok_postal_code: "28008",
    second_name: "M'Cif",
    nom: "Mcif",
    wilaya_id: 28,
    commune_name: "مسيف",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-15 11:43:00",
  },
  {
    id: 1003,
    code_postal: "28009",
    ok_postal_code: "28009",
    second_name: "Chellal",
    nom: "Chellal",
    wilaya_id: 28,
    commune_name: "شلال",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1004,
    code_postal: "28010",
    ok_postal_code: "28010",
    second_name: "Ouled Madhi",
    nom: "Ouled Madhi",
    wilaya_id: 28,
    commune_name: "أولاد ماضي",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1005,
    code_postal: "28011",
    ok_postal_code: "28011",
    second_name: "Magra",
    nom: "Magra",
    wilaya_id: 28,
    commune_name: "مقرة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1006,
    code_postal: "28012",
    ok_postal_code: "28012",
    second_name: "Berhoum",
    nom: "Berhoum",
    wilaya_id: 28,
    commune_name: "برهوم",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1007,
    code_postal: "28013",
    ok_postal_code: "28013",
    second_name: "A\u00efn Khadra",
    nom: "Ain Khadra",
    wilaya_id: 28,
    commune_name: "عين الخضراء",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1008,
    code_postal: "28014",
    ok_postal_code: "28014",
    second_name: "Ouled Addi Guebala",
    nom: "Ouled Addi Guebala",
    wilaya_id: 28,
    commune_name: "أولاد عدي لقبالة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1009,
    code_postal: "28015",
    ok_postal_code: "28015",
    second_name: "Belaiba",
    nom: "Belaiba",
    wilaya_id: 28,
    commune_name: "بلعايبة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1010,
    code_postal: "28016",
    ok_postal_code: "28016",
    second_name: "Sidi A\u00efssa",
    nom: "Sidi Aissa",
    wilaya_id: 28,
    commune_name: "سيدي عيسى",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:37",
  },
  {
    id: 1011,
    code_postal: "28017",
    ok_postal_code: "28017",
    second_name: "A\u00efn El Hadjel",
    nom: "Ain El Hadjel",
    wilaya_id: 28,
    commune_name: "عين الحجل",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1012,
    code_postal: "28018",
    ok_postal_code: "28018",
    second_name: "Sidi Hadjeres",
    nom: "Sidi Hadjeres",
    wilaya_id: 28,
    commune_name: "سيدي هجرس",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1013,
    code_postal: "28019",
    ok_postal_code: "28019",
    second_name: "Ouanougha",
    nom: "Ouanougha",
    wilaya_id: 28,
    commune_name: "ونوغة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1014,
    code_postal: "28020",
    ok_postal_code: "28020",
    second_name: "Bou Sa\u00e2da",
    nom: "Bou Saada",
    wilaya_id: 28,
    commune_name: "بوسعادة",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1015,
    code_postal: "28021",
    ok_postal_code: "28021",
    second_name: "Ouled Sidi Brahim",
    nom: "Ouled Sidi Brahim",
    wilaya_id: 28,
    commune_name: "أولاد سيدي ابراهيم",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1016,
    code_postal: "28022",
    ok_postal_code: "28022",
    second_name: "Sidi Ameur",
    nom: "Sidi Ameur",
    wilaya_id: 28,
    commune_name: "سيدي عامر",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1017,
    code_postal: "28023",
    ok_postal_code: "28023",
    second_name: "Tamsa",
    nom: "Tamsa",
    wilaya_id: 28,
    commune_name: "تامسة",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1018,
    code_postal: "28024",
    ok_postal_code: "28024",
    second_name: "Ben Srour",
    nom: "Ben Srour",
    wilaya_id: 28,
    commune_name: "بن سرور",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1019,
    code_postal: "28025",
    ok_postal_code: "28025",
    second_name: "Ouled Slimane",
    nom: "Ouled Slimane",
    wilaya_id: 28,
    commune_name: "أولاد سليمان",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-15 11:43:00",
  },
  {
    id: 1020,
    code_postal: "28026",
    ok_postal_code: "28026",
    second_name: "El Houamed",
    nom: "El Houamed",
    wilaya_id: 28,
    commune_name: "الحوامد",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1021,
    code_postal: "28027",
    ok_postal_code: "28027",
    second_name: "El Hamel",
    nom: "El Hamel",
    wilaya_id: 28,
    commune_name: "الهامل",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1022,
    code_postal: "28028",
    ok_postal_code: "28028",
    second_name: "Ouled Mansour",
    nom: "Ouled Mansour",
    wilaya_id: 28,
    commune_name: "أولاد منصور",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1023,
    code_postal: "28029",
    ok_postal_code: "28029",
    second_name: "Maarif",
    nom: "Maarif",
    wilaya_id: 28,
    commune_name: "معاريف",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1024,
    code_postal: "28030",
    ok_postal_code: "28030",
    second_name: "Dehahna",
    nom: "Dehahna",
    wilaya_id: 28,
    commune_name: "دهاهنة",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1025,
    code_postal: "28031",
    ok_postal_code: "28031",
    second_name: "Bouti Sayah",
    nom: "Bouti Sayah",
    wilaya_id: 28,
    commune_name: "بوطي السايح",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1026,
    code_postal: "28032",
    ok_postal_code: "28032",
    second_name: "Khettouti Sed El Djir",
    nom: "Khettouti Sed Djir",
    wilaya_id: 28,
    commune_name: "خطوطي سد الجير",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1027,
    code_postal: "28033",
    ok_postal_code: "28033",
    second_name: "Zarzour",
    nom: "Zarzour",
    wilaya_id: 28,
    commune_name: "زرزور",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-09 13:13:26",
  },
  {
    id: 1028,
    code_postal: "28034",
    ok_postal_code: "28034",
    second_name: "Mohammed Boudiaf",
    nom: "Oued Chair",
    wilaya_id: 28,
    commune_name: "محمد بوضياف",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1029,
    code_postal: "28035",
    ok_postal_code: "28035",
    second_name: "Benzouh",
    nom: "Benzouh",
    wilaya_id: 28,
    commune_name: "بن زوه",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1030,
    code_postal: "28036",
    ok_postal_code: "28036",
    second_name: "Bir Foda",
    nom: "Bir Foda",
    wilaya_id: 28,
    commune_name: "بئر فضة",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-09 13:14:20",
  },
  {
    id: 1032,
    code_postal: "28038",
    ok_postal_code: "28038",
    second_name: "Sidi M'Hamed",
    nom: "Sidi Mhamed",
    wilaya_id: 28,
    commune_name: "سيدي امحمد",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1033,
    code_postal: "28039",
    ok_postal_code: "28039",
    second_name: "Ouled Atia",
    nom: "Ouled Atia",
    wilaya_id: 28,
    // TODO(arabic-match):  "Ouled Atia".
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-15 11:43:00",
  },
  {
    id: 1034,
    code_postal: "28040",
    ok_postal_code: "28040",
    second_name: "Souamaa",
    nom: "Souamaa",
    wilaya_id: 28,
    commune_name: "السوامع",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1035,
    code_postal: "28041",
    ok_postal_code: "28041",
    second_name: "A\u00efn El Melh",
    nom: "Ain El Melh",
    wilaya_id: 28,
    commune_name: "عين الملح",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1036,
    code_postal: "28042",
    ok_postal_code: "28042",
    second_name: "Medjedel",
    nom: "Medjedel",
    wilaya_id: 28,
    commune_name: "امجدل",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2024-12-15 10:50:52",
  },
  {
    id: 1037,
    code_postal: "28043",
    ok_postal_code: "28043",
    second_name: "Slim",
    nom: "Slim",
    wilaya_id: 28,
    commune_name: "سليم",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-09 13:14:08",
  },
  {
    id: 1038,
    code_postal: "28044",
    ok_postal_code: "28044",
    second_name: "A\u00efn Errich",
    nom: "Ain Errich",
    wilaya_id: 28,
    commune_name: "عين الريش",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1039,
    code_postal: "28045",
    ok_postal_code: "28045",
    second_name: "Beni Ilmane",
    nom: "Beni Ilmane",
    wilaya_id: 28,
    commune_name: "بني يلمان",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1040,
    code_postal: "28046",
    ok_postal_code: "28046",
    second_name: "Oultem",
    nom: "Oultene",
    wilaya_id: 28,
    commune_name: "ولتام",
    wilaya_name: "المسيلة",
    hub_id: 40,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1041,
    code_postal: "28047",
    ok_postal_code: "28047",
    second_name: "Djebel Messaad",
    nom: "Djebel Messaad",
    wilaya_id: 28,
    commune_name: "جبل مساعد",
    wilaya_name: "المسيلة",
    hub_id: 64,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1042,
    code_postal: "29001",
    ok_postal_code: "29001",
    second_name: "Mascara",
    nom: "Mascara",
    wilaya_id: 29,
    commune_name: "معسكر",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1043,
    code_postal: "29002",
    ok_postal_code: "29002",
    second_name: "Bou Hanifia",
    nom: "Bou Hanifia",
    wilaya_id: 29,
    commune_name: "بوحنيفية",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1044,
    code_postal: "29003",
    ok_postal_code: "29003",
    second_name: "Tizi",
    nom: "Tizi",
    wilaya_id: 29,
    commune_name: "تيزي",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1045,
    code_postal: "29004",
    ok_postal_code: "29004",
    second_name: "Hacine",
    nom: "Hacine",
    wilaya_id: 29,
    commune_name: "حسين",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2025-11-15 12:35:37",
  },
  {
    id: 1046,
    code_postal: "29005",
    ok_postal_code: "29005",
    second_name: "Maoussa",
    nom: "Maoussa",
    wilaya_id: 29,
    commune_name: "ماوسة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1047,
    code_postal: "29006",
    ok_postal_code: "29006",
    second_name: "Tighennif",
    nom: "Teghennif",
    wilaya_id: 29,
    commune_name: "تيغنيف",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1048,
    code_postal: "29007",
    ok_postal_code: "29007",
    second_name: "Hachem",
    nom: "El Hachem",
    wilaya_id: 29,
    commune_name: "الحشم",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1049,
    code_postal: "29008",
    ok_postal_code: "29008",
    second_name: "Sidi Kada",
    nom: "Sidi Kada",
    wilaya_id: 29,
    commune_name: "سيدي قادة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1050,
    code_postal: "29009",
    ok_postal_code: "29009",
    second_name: "Zelmata",
    nom: "Zelmata",
    wilaya_id: 29,
    commune_name: "زلامطة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1051,
    code_postal: "29010",
    ok_postal_code: "29010",
    second_name: "Oued El Abtal",
    nom: "Oued El Abtal",
    wilaya_id: 29,
    commune_name: "وادي الأبطال",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2023-04-30 18:59:40",
  },
  {
    id: 1052,
    code_postal: "29011",
    ok_postal_code: "29011",
    second_name: "A\u00efn Ferah",
    nom: "Ain Ferah",
    wilaya_id: 29,
    commune_name: "عين فراح",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1053,
    code_postal: "29012",
    ok_postal_code: "29012",
    second_name: "Ghriss",
    nom: "Ghriss",
    wilaya_id: 29,
    commune_name: "غريس",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1054,
    code_postal: "29013",
    ok_postal_code: "29013",
    second_name: "Froha",
    nom: "Froha",
    wilaya_id: 29,
    commune_name: "فروحة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1055,
    code_postal: "29014",
    ok_postal_code: "29014",
    second_name: "Matemore",
    nom: "Matemore",
    wilaya_id: 29,
    commune_name: "المطمور",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1056,
    code_postal: "29015",
    ok_postal_code: "29015",
    second_name: "Makdha",
    nom: "Makdha",
    wilaya_id: 29,
    commune_name: "ماقضة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1057,
    code_postal: "29016",
    ok_postal_code: "29016",
    second_name: "Sidi Boussaid",
    nom: "Sidi Boussaid",
    wilaya_id: 29,
    commune_name: "سيدي بوسعيد",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-12 11:36:51",
  },
  {
    id: 1058,
    code_postal: "29017",
    ok_postal_code: "29017",
    second_name: "El Bordj",
    nom: "El Bordj",
    wilaya_id: 29,
    commune_name: "البرج",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1059,
    code_postal: "29018",
    ok_postal_code: "29018",
    second_name: "A\u00efn Fekan",
    nom: "Ain Fekan",
    wilaya_id: 29,
    commune_name: "عين فكان",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1060,
    code_postal: "29019",
    ok_postal_code: "29019",
    second_name: "Beniane",
    nom: "Benian",
    wilaya_id: 29,
    commune_name: "بنيان",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1061,
    code_postal: "29020",
    ok_postal_code: "29020",
    second_name: "Khalouia",
    nom: "Khalouia",
    wilaya_id: 29,
    commune_name: "خلوية",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2025-09-26 15:41:58",
  },
  {
    id: 1062,
    code_postal: "29021",
    ok_postal_code: "29021",
    second_name: "El Menaouer",
    nom: "El Menaouer",
    wilaya_id: 29,
    commune_name: "المنور",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1063,
    code_postal: "29022",
    ok_postal_code: "29022",
    second_name: "Oued Taria",
    nom: "Oued Taria",
    wilaya_id: 29,
    commune_name: "وادي التاغية",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1064,
    code_postal: "29023",
    ok_postal_code: "29023",
    second_name: "Aouf",
    nom: "Aouf",
    wilaya_id: 29,
    commune_name: "عوف",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1065,
    code_postal: "29024",
    ok_postal_code: "29024",
    second_name: "A\u00efn Fares",
    nom: "Ain Fares",
    wilaya_id: 29,
    commune_name: "عين فارس",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1066,
    code_postal: "29025",
    ok_postal_code: "29025",
    second_name: "A\u00efn Fras",
    nom: "Ain Frass",
    wilaya_id: 29,
    commune_name: "عين أفرص",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1067,
    code_postal: "29026",
    ok_postal_code: "29026",
    second_name: "Sig",
    nom: "Sig",
    wilaya_id: 29,
    commune_name: "سيق",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1068,
    code_postal: "29027",
    ok_postal_code: "29027",
    second_name: "Oggaz",
    nom: "Oggaz",
    wilaya_id: 29,
    commune_name: "عقاز",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1069,
    code_postal: "29028",
    ok_postal_code: "29028",
    second_name: "Ala\u00efmia",
    nom: "Alaimia",
    wilaya_id: 29,
    commune_name: "العلايمية",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1071,
    code_postal: "29030",
    ok_postal_code: "29030",
    second_name: "Zahana",
    nom: "Zahana",
    wilaya_id: 29,
    commune_name: "زهانة",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1072,
    code_postal: "29031",
    ok_postal_code: "29031",
    second_name: "Mohammadia",
    nom: "Mohammadia",
    wilaya_id: 29,
    commune_name: "المحمدية",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1073,
    code_postal: "29032",
    ok_postal_code: "29032",
    second_name: "Sidi Abdelmoumen",
    nom: "Sidi Abdelmoumene",
    wilaya_id: 29,
    commune_name: "سيدي عبد المومن",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1074,
    code_postal: "29033",
    ok_postal_code: "29033",
    second_name: "Ferraguig",
    nom: "Ferraguig",
    wilaya_id: 29,
    commune_name: "فراقيق",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1075,
    code_postal: "29034",
    ok_postal_code: "29034",
    second_name: "El Ghomri",
    nom: "El Ghomri",
    wilaya_id: 29,
    commune_name: "الغمري",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1076,
    code_postal: "29035",
    ok_postal_code: "29035",
    second_name: "Sedjerara",
    nom: "Sedjerara",
    wilaya_id: 29,
    commune_name: "سجرارة",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1077,
    code_postal: "29036",
    ok_postal_code: "29036",
    second_name: "Mocta Douz",
    nom: "Moctadouz",
    wilaya_id: 29,
    commune_name: "مقطع الدوز",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1078,
    code_postal: "29037",
    ok_postal_code: "29037",
    second_name: "Bou Henni",
    nom: "Bou Henni",
    wilaya_id: 29,
    commune_name: "بوهني",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1079,
    code_postal: "29038",
    ok_postal_code: "29038",
    second_name: "El Guettana",
    nom: "Guettena",
    wilaya_id: 29,
    commune_name: "القطنة",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2026-04-12 11:36:51",
  },
  {
    id: 1080,
    code_postal: "29039",
    ok_postal_code: "29039",
    second_name: "Mamounia",
    nom: "El Mamounia",
    wilaya_id: 29,
    commune_name: "المأمونية",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1081,
    code_postal: "29040",
    ok_postal_code: "29040",
    second_name: "El Keurt",
    nom: "El Keurt",
    wilaya_id: 29,
    commune_name: "القرط",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1082,
    code_postal: "29041",
    ok_postal_code: "29041",
    second_name: "Gharrous",
    nom: "Gharrous",
    wilaya_id: 29,
    commune_name: "غروس",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1083,
    code_postal: "29042",
    ok_postal_code: "29042",
    second_name: "Guerdjoum",
    nom: "Gherdjoum",
    wilaya_id: 29,
    commune_name: "قرجوم",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1084,
    code_postal: "29043",
    ok_postal_code: "29043",
    second_name: "Chorfa",
    nom: "Chorfa",
    wilaya_id: 29,
    commune_name: "الشرفاء",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1085,
    code_postal: "29044",
    ok_postal_code: "29044",
    second_name: "Ras El A\u00efn Amirouche",
    nom: "Ras Ain Amirouche",
    wilaya_id: 29,
    commune_name: "رأس عين عميروش",
    wilaya_name: "معسكر",
    hub_id: 16,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1086,
    code_postal: "29045",
    ok_postal_code: "29045",
    second_name: "Nesmoth",
    nom: "Nesmot",
    wilaya_id: 29,
    commune_name: "نسمط",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1087,
    code_postal: "29046",
    ok_postal_code: "29046",
    second_name: "Sidi Abdeldjebar",
    nom: "Sidi Abdeldjebar",
    wilaya_id: 29,
    commune_name: "سيدي عبد الجبار",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1088,
    code_postal: "29047",
    ok_postal_code: "29047",
    second_name: "Sehailia",
    nom: "Sehailia",
    wilaya_id: 29,
    commune_name: "السهايلية",
    wilaya_name: "معسكر",
    hub_id: 63,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1089,
    code_postal: "30001",
    ok_postal_code: "30001",
    second_name: "Ouargla",
    nom: "Ouargla",
    wilaya_id: 30,
    commune_name: "ورقلة",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1090,
    code_postal: "30002",
    ok_postal_code: "30002",
    second_name: "A\u00efn Beida",
    nom: "Ain Beida",
    wilaya_id: 30,
    commune_name: "عين البيضاء",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1091,
    code_postal: "30003",
    ok_postal_code: "30003",
    second_name: "N'Goussa",
    nom: "Ngoussa",
    wilaya_id: 30,
    commune_name: "انقوسة",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1092,
    code_postal: "30004",
    ok_postal_code: "30004",
    second_name: "Hassi Messaoud",
    nom: "Hassi Messaoud",
    wilaya_id: 30,
    commune_name: "حاسي مسعود",
    wilaya_name: "ورقلة",
    hub_id: 98,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-12 18:05:42",
  },
  {
    id: 1093,
    code_postal: "30005",
    ok_postal_code: "30005",
    second_name: "Rouissat",
    nom: "Rouissat",
    wilaya_id: 30,
    commune_name: "الرويسات",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1099,
    code_postal: "30011",
    ok_postal_code: "30011",
    second_name: "Sidi Khouiled",
    nom: "Sidi Khouiled",
    wilaya_id: 30,
    commune_name: "سيدي خويلد",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1100,
    code_postal: "30012",
    ok_postal_code: "30012",
    second_name: "Hassi Ben Abdellah",
    nom: "Hassi Ben Abdellah",
    wilaya_id: 30,
    commune_name: "حاسي بن عبد الله",
    wilaya_name: "ورقلة",
    hub_id: 34,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1110,
    code_postal: "31001",
    ok_postal_code: "31001",
    second_name: "Oran",
    nom: "Oran",
    wilaya_id: 31,
    commune_name: "وهران",
    wilaya_name: "وهران",
    hub_id: 68,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-16 20:57:13",
  },
  {
    id: 1111,
    code_postal: "31002",
    ok_postal_code: "31002",
    second_name: "Gdyel",
    nom: "Gdyel",
    wilaya_id: 31,
    commune_name: "قديل",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1112,
    code_postal: "31003",
    ok_postal_code: "31003",
    second_name: "Bir El Djir",
    nom: "Bir El Djir",
    wilaya_id: 31,
    commune_name: "بئر الجير",
    wilaya_name: "وهران",
    hub_id: 46,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1113,
    code_postal: "31004",
    ok_postal_code: "31004",
    second_name: "Hassi Bounif",
    nom: "Hassi Bounif",
    wilaya_id: 31,
    commune_name: "حاسي بونيف",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1114,
    code_postal: "31005",
    ok_postal_code: "31005",
    second_name: "Es Senia",
    nom: "Es Senia",
    wilaya_id: 31,
    commune_name: "السانية",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1115,
    code_postal: "31006",
    ok_postal_code: "31006",
    second_name: "Arzew",
    nom: "Arzew",
    wilaya_id: 31,
    commune_name: "أرزيو",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1116,
    code_postal: "31007",
    ok_postal_code: "31007",
    second_name: "Bethioua",
    nom: "Bethioua",
    wilaya_id: 31,
    commune_name: "بطيوة",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1117,
    code_postal: "31008",
    ok_postal_code: "31008",
    second_name: "Marsat El Hadjadj",
    nom: "Marsat El Hadjadj",
    wilaya_id: 31,
    commune_name: "مرسى الحجاج",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1118,
    code_postal: "31009",
    ok_postal_code: "31009",
    second_name: "A\u00efn El Turk",
    nom: "Ain Turk",
    wilaya_id: 31,
    commune_name: "عين الترك",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2024-08-17 02:37:14",
  },
  {
    id: 1119,
    code_postal: "31010",
    ok_postal_code: "31010",
    second_name: "El An\u00e7or",
    nom: "El Ancar",
    wilaya_id: 31,
    commune_name: "العنصر",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1120,
    code_postal: "31011",
    ok_postal_code: "31011",
    second_name: "Oued Tlelat",
    nom: "Oued Tlelat",
    wilaya_id: 31,
    commune_name: "وادي تليلات",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1121,
    code_postal: "31012",
    ok_postal_code: "31012",
    second_name: "Tafraoui",
    nom: "Tafraoui",
    wilaya_id: 31,
    commune_name: "طفراوي",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1122,
    code_postal: "31013",
    ok_postal_code: "31013",
    second_name: "Sidi Chami",
    nom: "Sidi Chami",
    wilaya_id: 31,
    commune_name: "سيدي الشحمي",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1123,
    code_postal: "31014",
    ok_postal_code: "31014",
    second_name: "Boufatis",
    nom: "Boufatis",
    wilaya_id: 31,
    commune_name: "بوفاتيس",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1124,
    code_postal: "31015",
    ok_postal_code: "31015",
    second_name: "Mers El K\u00e9bir",
    nom: "Mers El Kebir",
    wilaya_id: 31,
    commune_name: "المرسى الكبير",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1125,
    code_postal: "31016",
    ok_postal_code: "31016",
    second_name: "Bou Sfer",
    nom: "Bousfer",
    wilaya_id: 31,
    commune_name: "بوسفر",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1126,
    code_postal: "31017",
    ok_postal_code: "31017",
    second_name: "El Kerma",
    nom: "El Karma",
    wilaya_id: 31,
    commune_name: "الكرمة",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1127,
    code_postal: "31018",
    ok_postal_code: "31018",
    second_name: "El Braya",
    nom: "El Braya",
    wilaya_id: 31,
    commune_name: "البراية",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1128,
    code_postal: "31019",
    ok_postal_code: "31019",
    second_name: "Hassi Ben Okba",
    nom: "Hassi Ben Okba",
    wilaya_id: 31,
    commune_name: "حاسي بن عقبة",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1129,
    code_postal: "31020",
    ok_postal_code: "31020",
    second_name: "Ben Freha",
    nom: "Ben Freha",
    wilaya_id: 31,
    commune_name: "بن فريحة",
    wilaya_name: "وهران",
    hub_id: 114,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-31 16:07:05",
  },
  {
    id: 1130,
    code_postal: "31021",
    ok_postal_code: "31021",
    second_name: "Hassi Mefsoukh",
    nom: "Hassi Mefsoukh",
    wilaya_id: 31,
    commune_name: "حاسي مفسوخ",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1131,
    code_postal: "31022",
    ok_postal_code: "31022",
    second_name: "Sidi Benyebka",
    nom: "Sidi Ben Yabka",
    wilaya_id: 31,
    commune_name: "سيدي بن يبقى",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1132,
    code_postal: "31023",
    ok_postal_code: "31023",
    second_name: "Misserghin",
    nom: "Messerghin",
    wilaya_id: 31,
    commune_name: "مسرغين",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1133,
    code_postal: "31024",
    ok_postal_code: "31024",
    second_name: "Boutlelis",
    nom: "Boutlelis",
    wilaya_id: 31,
    commune_name: "بوتليليس",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1134,
    code_postal: "31025",
    ok_postal_code: "31025",
    second_name: "A\u00efn El Kerma",
    nom: "Ain Kerma",
    wilaya_id: 31,
    commune_name: "عين الكرمة",
    wilaya_name: "وهران",
    hub_id: 10,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1135,
    code_postal: "31026",
    ok_postal_code: "31026",
    second_name: "A\u00efn El Bia",
    nom: "Ain Biya",
    wilaya_id: 31,
    commune_name: "عين البية",
    wilaya_name: "وهران",
    hub_id: 95,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-10 11:39:42",
  },
  {
    id: 1136,
    code_postal: "32001",
    ok_postal_code: "32001",
    second_name: "El Bayadh",
    nom: "El Bayadh",
    wilaya_id: 32,
    commune_name: "البيض",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1137,
    code_postal: "32002",
    ok_postal_code: "32002",
    second_name: "Rogassa",
    nom: "Rogassa",
    wilaya_id: 32,
    commune_name: "رقاصة",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1138,
    code_postal: "32003",
    ok_postal_code: "32003",
    second_name: "Stitten",
    nom: "Stitten",
    wilaya_id: 32,
    commune_name: "ستيتن",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1139,
    code_postal: "32004",
    ok_postal_code: "32004",
    second_name: "Brezina",
    nom: "Brezina",
    wilaya_id: 32,
    commune_name: "بريزينة",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1140,
    code_postal: "32005",
    ok_postal_code: "32005",
    second_name: "Ghassoul",
    nom: "Ghassoul",
    wilaya_id: 32,
    commune_name: "الغاسول",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1141,
    code_postal: "32006",
    ok_postal_code: "32006",
    second_name: "Boualem",
    nom: "Boualem",
    wilaya_id: 32,
    commune_name: "بوعلام",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1142,
    code_postal: "32007",
    ok_postal_code: "32007",
    second_name: "El Abiodh Sidi Cheikh",
    nom: "El Abiodh Sidi Cheikh",
    wilaya_id: 32,
    commune_name: "الأبيض سيدي الشيخ",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1143,
    code_postal: "32008",
    ok_postal_code: "32008",
    second_name: "A\u00efn El Orak",
    nom: "Ain El Orak",
    wilaya_id: 32,
    commune_name: "عين العراك",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1144,
    code_postal: "32009",
    ok_postal_code: "32009",
    second_name: "Arbaouat",
    nom: "Arbaouat",
    wilaya_id: 32,
    commune_name: "اربوات",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1145,
    code_postal: "32010",
    ok_postal_code: "32010",
    second_name: "Bougtoub",
    nom: "Bougtoub",
    wilaya_id: 32,
    commune_name: "بوقطب",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1146,
    code_postal: "32011",
    ok_postal_code: "32011",
    second_name: "El Kheiter",
    nom: "El Kheither",
    wilaya_id: 32,
    commune_name: "الخيثر",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1147,
    code_postal: "32012",
    ok_postal_code: "32012",
    second_name: "Kef El Ahmar",
    nom: "Kef El Ahmar",
    wilaya_id: 32,
    commune_name: "الكاف الأحمر",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1148,
    code_postal: "32013",
    ok_postal_code: "32013",
    second_name: "Boussemghoun",
    nom: "Boussemghoun",
    wilaya_id: 32,
    commune_name: "بوسمغون",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1149,
    code_postal: "32014",
    ok_postal_code: "32014",
    second_name: "Chellala",
    nom: "Chellala",
    wilaya_id: 32,
    commune_name: "شلالة",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1150,
    code_postal: "32015",
    ok_postal_code: "32015",
    second_name: "Kraakda",
    nom: "Krakda",
    wilaya_id: 32,
    commune_name: "كراكدة",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1151,
    code_postal: "32016",
    ok_postal_code: "32016",
    second_name: "El Bnoud",
    nom: "El Bnoud",
    wilaya_id: 32,
    commune_name: "البنود",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1152,
    code_postal: "32017",
    ok_postal_code: "32017",
    second_name: "Cheguig",
    nom: "Cheguig",
    wilaya_id: 32,
    commune_name: "الشقيق",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1153,
    code_postal: "32018",
    ok_postal_code: "32018",
    second_name: "Sidi Ameur",
    nom: "Sidi Ameur",
    wilaya_id: 32,
    commune_name: "سيدي عامر",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1154,
    code_postal: "32019",
    ok_postal_code: "32019",
    second_name: "El Mehara",
    nom: "El Mehara",
    wilaya_id: 32,
    commune_name: "المحرة",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1155,
    code_postal: "32020",
    ok_postal_code: "32020",
    second_name: "Tousmouline",
    nom: "Tousmouline",
    wilaya_id: 32,
    commune_name: "توسمولين",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1156,
    code_postal: "32021",
    ok_postal_code: "32021",
    second_name: "Sidi Slimane",
    nom: "Sidi Slimane",
    wilaya_id: 32,
    commune_name: "سيدي سليمان",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1157,
    code_postal: "32022",
    ok_postal_code: "32022",
    second_name: "Sidi Tifour",
    nom: "Sidi Tifour",
    wilaya_id: 32,
    commune_name: "سيدي طيفور",
    wilaya_name: "البيض",
    hub_id: 60,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1158,
    code_postal: "33001",
    ok_postal_code: "33001",
    second_name: "Illizi",
    nom: "Illizi",
    wilaya_id: 33,
    commune_name: "إيليزي",
    wilaya_name: "إليزي",
    hub_id: 33,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1164,
    code_postal: "34001",
    ok_postal_code: "34001",
    second_name: "Bordj Bou Arreridj",
    nom: "Bordj Bou Arreridj",
    wilaya_id: 34,
    commune_name: "برج بوعريرج",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1165,
    code_postal: "34002",
    ok_postal_code: "34002",
    second_name: "Ras El Oued",
    nom: "Ras El Oued",
    wilaya_id: 34,
    commune_name: "رأس الوادي",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1166,
    code_postal: "34003",
    ok_postal_code: "34003",
    second_name: "Bordj Zemoura",
    nom: "Bordj Zemoura",
    wilaya_id: 34,
    commune_name: "برج زمورة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1167,
    code_postal: "34004",
    ok_postal_code: "34004",
    second_name: "Mansoura",
    nom: "Mansoura",
    wilaya_id: 34,
    commune_name: "المنصورة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1168,
    code_postal: "34005",
    ok_postal_code: "34005",
    second_name: "El M'hir",
    nom: "El Mhir",
    wilaya_id: 34,
    commune_name: "المهير",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1169,
    code_postal: "34006",
    ok_postal_code: "34006",
    second_name: "Ben Daoud",
    nom: "Ben Daoud",
    wilaya_id: 34,
    commune_name: "بن داود",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1170,
    code_postal: "34007",
    ok_postal_code: "34007",
    second_name: "El Achir",
    nom: "El Achir",
    wilaya_id: 34,
    commune_name: "الياشير",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1171,
    code_postal: "34008",
    ok_postal_code: "34008",
    second_name: "A\u00efn Taghrout",
    nom: "Ain Taghrout",
    wilaya_id: 34,
    commune_name: "عين تاغروت",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1172,
    code_postal: "34009",
    ok_postal_code: "34009",
    second_name: "Bordj Gh\u00e9dir",
    nom: "Bordj Ghdir",
    wilaya_id: 34,
    commune_name: "برج الغدير",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1173,
    code_postal: "34010",
    ok_postal_code: "34010",
    second_name: "Sidi Embarek",
    nom: "Sidi Embarek",
    wilaya_id: 34,
    commune_name: "سيدي أمبارك",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1174,
    code_postal: "34011",
    ok_postal_code: "34011",
    second_name: "El Hamadia",
    nom: "El Hamadia",
    wilaya_id: 34,
    commune_name: "الحمادية",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1175,
    code_postal: "34012",
    ok_postal_code: "34012",
    second_name: "Belimour",
    nom: "Belimour",
    wilaya_id: 34,
    commune_name: "بليمور",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1176,
    code_postal: "34013",
    ok_postal_code: "34013",
    second_name: "Medjana",
    nom: "Medjana",
    wilaya_id: 34,
    commune_name: "مجانة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1177,
    code_postal: "34014",
    ok_postal_code: "34014",
    second_name: "Teniet En Nasr",
    nom: "Teniet En Nasr",
    wilaya_id: 34,
    commune_name: "ثنية النصر",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1178,
    code_postal: "34015",
    ok_postal_code: "34015",
    second_name: "Djaafra",
    nom: "Djaafra",
    wilaya_id: 34,
    commune_name: "جعافرة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-15 11:04:47",
  },
  {
    id: 1179,
    code_postal: "34016",
    ok_postal_code: "34016",
    second_name: "El Main",
    nom: "El Main",
    wilaya_id: 34,
    commune_name: "الماين",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-15 11:04:55",
  },
  {
    id: 1180,
    code_postal: "34017",
    ok_postal_code: "34017",
    second_name: "Ouled Brahem",
    nom: "Ouled Brahem",
    wilaya_id: 34,
    commune_name: "أولاد أبراهم",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1181,
    code_postal: "34018",
    ok_postal_code: "34018",
    second_name: "Ouled Dahmane",
    nom: "Ouled Dahmane",
    wilaya_id: 34,
    commune_name: "أولاد دحمان",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1182,
    code_postal: "34019",
    ok_postal_code: "34019",
    second_name: "Hasnaoua",
    nom: "Hasnaoua",
    wilaya_id: 34,
    commune_name: "حسناوة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1183,
    code_postal: "34020",
    ok_postal_code: "34020",
    second_name: "Khelil",
    nom: "Khelil",
    wilaya_id: 34,
    commune_name: "خليل",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1184,
    code_postal: "34021",
    ok_postal_code: "34021",
    second_name: "Taglait",
    nom: "Taglait",
    wilaya_id: 34,
    commune_name: "تقلعيت",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1185,
    code_postal: "34022",
    ok_postal_code: "34022",
    second_name: "Ksour",
    nom: "Ksour",
    wilaya_id: 34,
    commune_name: "القصور",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1186,
    code_postal: "34023",
    ok_postal_code: "34023",
    second_name: "Ouled Sidi Brahim",
    nom: "Ouled Sidi Brahim",
    wilaya_id: 34,
    commune_name: "أولاد سيدي ابراهيم",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1187,
    code_postal: "34024",
    ok_postal_code: "34024",
    second_name: "Tefreg",
    nom: "Tafreg",
    wilaya_id: 34,
    commune_name: "تفرق",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-15 11:04:37",
  },
  {
    id: 1189,
    code_postal: "34026",
    ok_postal_code: "34026",
    second_name: "Tixter",
    nom: "Tixter",
    wilaya_id: 34,
    commune_name: "تيكستار",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1190,
    code_postal: "34027",
    ok_postal_code: "34027",
    second_name: "El Ach",
    nom: "El Ach",
    wilaya_id: 34,
    commune_name: "الياشير",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1191,
    code_postal: "34028",
    ok_postal_code: "34028",
    second_name: "El Anseur",
    nom: "El Anseur",
    wilaya_id: 34,
    commune_name: "العناصر",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1192,
    code_postal: "34029",
    ok_postal_code: "34029",
    second_name: "Tassameurt",
    nom: "Tesmart",
    wilaya_id: 34,
    commune_name: "تسامرت",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1193,
    code_postal: "34030",
    ok_postal_code: "34030",
    second_name: "A\u00efn Tesra",
    nom: "Ain Tesra",
    wilaya_id: 34,
    commune_name: "عين تسرة",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1194,
    code_postal: "34031",
    ok_postal_code: "34031",
    second_name: "Bir Kasdali",
    nom: "Bir Kasdali",
    wilaya_id: 34,
    commune_name: "بئر قاصد علي",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1195,
    code_postal: "34032",
    ok_postal_code: "34032",
    second_name: "Ghilassa",
    nom: "Ghilassa",
    wilaya_id: 34,
    commune_name: "غيلاسة",
    wilaya_name: "برج بوعريريج",
    hub_id: 112,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-12 23:01:48",
  },
  {
    id: 1196,
    code_postal: "34033",
    ok_postal_code: "34033",
    second_name: "Rabta",
    nom: "Rabta",
    wilaya_id: 34,
    commune_name: "الرابطة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1197,
    code_postal: "34034",
    ok_postal_code: "34034",
    second_name: "Haraza",
    nom: "Haraza",
    wilaya_id: 34,
    commune_name: "حرازة",
    wilaya_name: "برج بوعريريج",
    hub_id: 25,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1198,
    code_postal: "35001",
    ok_postal_code: "35001",
    second_name: "Boumerdes",
    nom: "Boumerdes",
    wilaya_id: 35,
    commune_name: "بومرداس",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1199,
    code_postal: "35002",
    ok_postal_code: "35002",
    second_name: "Boudouaou",
    nom: "Boudouaou",
    wilaya_id: 35,
    commune_name: "بودواو",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1200,
    code_postal: "35004",
    ok_postal_code: "35004",
    second_name: "Afir",
    nom: "Afir",
    wilaya_id: 35,
    commune_name: "أعفير",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1201,
    code_postal: "35005",
    ok_postal_code: "35005",
    second_name: "Bordj Menaiel",
    nom: "Bordj Menaiel",
    wilaya_id: 35,
    commune_name: "برج منايل",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1202,
    code_postal: "35006",
    ok_postal_code: "35006",
    second_name: "Baghlia",
    nom: "Baghlia",
    wilaya_id: 35,
    commune_name: "بغلية",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1203,
    code_postal: "35007",
    ok_postal_code: "35007",
    second_name: "Sidi Daoud",
    nom: "Sidi Daoud",
    wilaya_id: 35,
    commune_name: "سيدي داود",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1204,
    code_postal: "35008",
    ok_postal_code: "35008",
    second_name: "Naciria",
    nom: "Naciria",
    wilaya_id: 35,
    commune_name: "الناصرية",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1205,
    code_postal: "35009",
    ok_postal_code: "35009",
    second_name: "Djinet",
    nom: "Djinet",
    wilaya_id: 35,
    commune_name: "جنات",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1206,
    code_postal: "35010",
    ok_postal_code: "35010",
    second_name: "Issers",
    nom: "Isser",
    wilaya_id: 35,
    commune_name: "يسر",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1207,
    code_postal: "35011",
    ok_postal_code: "35011",
    second_name: "Zemmouri",
    nom: "Zemmouri",
    wilaya_id: 35,
    commune_name: "زموري",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1208,
    code_postal: "35012",
    ok_postal_code: "35012",
    second_name: "Si Mustapha",
    nom: "Si Mustapha",
    wilaya_id: 35,
    commune_name: "سي مصطفى",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1209,
    code_postal: "35013",
    ok_postal_code: "35013",
    second_name: "Tidjelabine",
    nom: "Tidjelabine",
    wilaya_id: 35,
    commune_name: "تيجلابين",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1210,
    code_postal: "35014",
    ok_postal_code: "35014",
    second_name: "Chabet el Ameur",
    nom: "Chabet El Ameur",
    wilaya_id: 35,
    commune_name: "شعبة العامر",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1211,
    code_postal: "35015",
    ok_postal_code: "35015",
    second_name: "Thenia",
    nom: "Thenia",
    wilaya_id: 35,
    commune_name: "الثنية",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1212,
    code_postal: "35018",
    ok_postal_code: "35018",
    second_name: "Timezrit",
    nom: "Timezrit",
    wilaya_id: 35,
    commune_name: "تيمزريت",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1213,
    code_postal: "35019",
    ok_postal_code: "35019",
    second_name: "Corso",
    nom: "Corso",
    wilaya_id: 35,
    commune_name: "قورصو",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1214,
    code_postal: "35020",
    ok_postal_code: "35020",
    second_name: "Ouled Moussa",
    nom: "Ouled Moussa",
    wilaya_id: 35,
    commune_name: "أولاد موسى",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1215,
    code_postal: "35021",
    ok_postal_code: "35021",
    second_name: "Larbatache",
    nom: "Larbatache",
    wilaya_id: 35,
    commune_name: "الاربعطاش",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1216,
    code_postal: "35022",
    ok_postal_code: "35022",
    second_name: "Bouzegza Keddara",
    nom: "Bouzegza Keddara",
    wilaya_id: 35,
    commune_name: "بوزقزة قدارة",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2025-08-20 15:13:31",
  },
  {
    id: 1217,
    code_postal: "35025",
    ok_postal_code: "35025",
    second_name: "Taourga",
    nom: "Taourga",
    wilaya_id: 35,
    commune_name: "تاورقة",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1218,
    code_postal: "35026",
    ok_postal_code: "35026",
    second_name: "Ouled Aissa",
    nom: "Ouled Aissa",
    wilaya_id: 35,
    commune_name: "أولاد عيسى",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1219,
    code_postal: "35027",
    ok_postal_code: "35027",
    second_name: "Ben Choud",
    nom: "Ben Choud",
    wilaya_id: 35,
    commune_name: "بن شود",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1220,
    code_postal: "35028",
    ok_postal_code: "35028",
    second_name: "Dellys",
    nom: "Dellys",
    wilaya_id: 35,
    commune_name: "دلس",
    wilaya_name: "بومرداس",
    hub_id: 104,
    is_active: 1,
    created_at: null,
    updated_at: "2026-01-23 17:43:05",
  },
  {
    id: 1221,
    code_postal: "35029",
    ok_postal_code: "35029",
    second_name: "Ammal",
    nom: "Ammal",
    wilaya_id: 35,
    commune_name: "عمال",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1222,
    code_postal: "35030",
    ok_postal_code: "35030",
    second_name: "Beni Amrane",
    nom: "Beni Amrane",
    wilaya_id: 35,
    commune_name: "بني عمران",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1223,
    code_postal: "35031",
    ok_postal_code: "35031",
    second_name: "Souk El Had",
    nom: "Souk El Had",
    wilaya_id: 35,
    commune_name: "سوق الحد",
    wilaya_name: "بومرداس",
    hub_id: 1,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1224,
    code_postal: "35032",
    ok_postal_code: "35032",
    second_name: "Boudouaou El Bahri",
    nom: "Boudouaou El Bahri",
    wilaya_id: 35,
    commune_name: "بودواو البحري",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1225,
    code_postal: "35033",
    ok_postal_code: "35033",
    second_name: "Ouled Hedadj",
    nom: "Ouled Hedadj",
    wilaya_id: 35,
    commune_name: "أولاد هداج",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1226,
    code_postal: "35035",
    ok_postal_code: "35035",
    second_name: "Leghata",
    nom: "Laghata",
    wilaya_id: 35,
    commune_name: "لقاطة",
    wilaya_name: "بومرداس",
    hub_id: 88,
    is_active: 1,
    created_at: null,
    updated_at: "2025-05-30 14:07:26",
  },
  {
    id: 1227,
    code_postal: "35036",
    ok_postal_code: "35036",
    second_name: "Hammedi",
    nom: "Hammedi",
    wilaya_id: 35,
    commune_name: "حمادي",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1228,
    code_postal: "35037",
    ok_postal_code: "35037",
    second_name: "Khemis El Khechna",
    nom: "Khemis El Khechna",
    wilaya_id: 35,
    commune_name: "خميس الخشنة",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1229,
    code_postal: "35038",
    ok_postal_code: "35038",
    second_name: "El Kharrouba",
    nom: "El Kharrouba",
    wilaya_id: 35,
    commune_name: "الخروبة",
    wilaya_name: "بومرداس",
    hub_id: 49,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 236,
    code_postal: "36016",
    ok_postal_code: "36016",
    second_name: "Besbes",
    nom: "Besbes",
    wilaya_id: 36,
    commune_name: "البسباس",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-07 09:59:16",
  },
  {
    id: 1230,
    code_postal: "36001",
    ok_postal_code: "36001",
    second_name: "El Tarf",
    nom: "El Tarf",
    wilaya_id: 36,
    commune_name: "الطارف",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1231,
    code_postal: "36002",
    ok_postal_code: "36002",
    second_name: "Bouhadjar",
    nom: "Bouhadjar",
    wilaya_id: 36,
    commune_name: "بوحجار",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1232,
    code_postal: "36003",
    ok_postal_code: "36003",
    second_name: "Ben Mehidi",
    nom: "Ben Mhidi",
    wilaya_id: 36,
    commune_name: "بن مهيدي",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1233,
    code_postal: "36004",
    ok_postal_code: "36004",
    second_name: "Bougous",
    nom: "Bougous",
    wilaya_id: 36,
    commune_name: "بوقوس",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:16:03",
  },
  {
    id: 1234,
    code_postal: "36005",
    ok_postal_code: "36005",
    second_name: "El Kala",
    nom: "El Kala",
    wilaya_id: 36,
    commune_name: "القالة",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1235,
    code_postal: "36006",
    ok_postal_code: "36006",
    second_name: "A\u00efn El Assel",
    nom: "Ain El Assel",
    wilaya_id: 36,
    commune_name: "عين العسل",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1236,
    code_postal: "36007",
    ok_postal_code: "36007",
    second_name: "El Aioun",
    nom: "El Aioun",
    wilaya_id: 36,
    commune_name: "العيون",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:16:11",
  },
  {
    id: 1237,
    code_postal: "36008",
    ok_postal_code: "36008",
    second_name: "Bouteldja",
    nom: "Bouteldja",
    wilaya_id: 36,
    commune_name: "بوثلجة",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1238,
    code_postal: "36009",
    ok_postal_code: "36009",
    second_name: "Souarekh",
    nom: "Souarekh",
    wilaya_id: 36,
    commune_name: "السوارخ",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2026-06-10 12:38:42",
  },
  {
    id: 1239,
    code_postal: "36010",
    ok_postal_code: "36010",
    second_name: "Berrihane",
    nom: "Berrihane",
    wilaya_id: 36,
    commune_name: "بريحان",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1240,
    code_postal: "36011",
    ok_postal_code: "36011",
    second_name: "Lac des Oiseaux",
    nom: "Lac Des Oiseaux",
    wilaya_id: 36,
    commune_name: "بحيرة الطيور",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1241,
    code_postal: "36012",
    ok_postal_code: "36012",
    second_name: "Chefia",
    nom: "Chefia",
    wilaya_id: 36,
    commune_name: "الشافية",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1242,
    code_postal: "36013",
    ok_postal_code: "36013",
    second_name: "Dr\u00e9an",
    nom: "Drean",
    wilaya_id: 36,
    commune_name: "الذرعـان",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1243,
    code_postal: "36014",
    ok_postal_code: "36014",
    second_name: "Chihani",
    nom: "Chihani",
    wilaya_id: 36,
    commune_name: "شحاني",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1244,
    code_postal: "36015",
    ok_postal_code: "36015",
    second_name: "Chebaita Mokhtar",
    nom: "Chebaita Mokhtar",
    wilaya_id: 36,
    commune_name: "شبيطة مختار",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1246,
    code_postal: "36017",
    ok_postal_code: "36017",
    second_name: "Asfour",
    nom: "Asfour",
    wilaya_id: 36,
    commune_name: "عصفور",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1247,
    code_postal: "36018",
    ok_postal_code: "36018",
    second_name: "Echatt",
    nom: "Echatt",
    wilaya_id: 36,
    commune_name: "الشط",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1248,
    code_postal: "36019",
    ok_postal_code: "36019",
    second_name: "Zerizer",
    nom: "Zerizer",
    wilaya_id: 36,
    commune_name: "زريزر",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1249,
    code_postal: "36020",
    ok_postal_code: "36020",
    second_name: "Zitouna",
    nom: "Zitouna",
    wilaya_id: 36,
    commune_name: "الزيتونة",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1250,
    code_postal: "36021",
    ok_postal_code: "36021",
    second_name: "A\u00efn Kerma",
    nom: "Ain Kerma",
    wilaya_id: 36,
    commune_name: "عين الكرمة",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1251,
    code_postal: "36022",
    ok_postal_code: "36022",
    second_name: "Oued Zitoun",
    nom: "Oued Zitoun",
    wilaya_id: 36,
    commune_name: "وادي الزيتون",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:16:32",
  },
  {
    id: 1252,
    code_postal: "36023",
    ok_postal_code: "36023",
    second_name: "Hammam Beni Salah",
    nom: "Hammam Beni Salah",
    wilaya_id: 36,
    commune_name: "حمام بني صالح",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:17:01",
  },
  {
    id: 1253,
    code_postal: "36024",
    ok_postal_code: "36024",
    second_name: "Raml Souk",
    nom: "Raml Souk",
    wilaya_id: 36,
    commune_name: "رمل السوق",
    wilaya_name: "الطارف",
    hub_id: 56,
    is_active: 1,
    created_at: null,
    updated_at: "2022-08-01 16:16:44",
  },
  {
    id: 1254,
    code_postal: "37001",
    ok_postal_code: "37001",
    second_name: "Tindouf",
    nom: "Tindouf",
    wilaya_id: 37,
    commune_name: "تندوف",
    wilaya_name: "تندوف",
    hub_id: 58,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1255,
    code_postal: "37002",
    ok_postal_code: "37002",
    second_name: "Oum el Assel",
    nom: "Oum El Assel",
    wilaya_id: 37,
    commune_name: "أم العسل",
    wilaya_name: "تندوف",
    hub_id: 11,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-23 12:54:49",
  },
  {
    id: 1256,
    code_postal: "38001",
    ok_postal_code: "38001",
    second_name: "Tissemsilt",
    nom: "Tissemsilt",
    wilaya_id: 38,
    commune_name: "تيسمسيلت",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1257,
    code_postal: "38002",
    ok_postal_code: "38002",
    second_name: "Bordj Bou Naama",
    nom: "Bordj Bou Naama",
    wilaya_id: 38,
    commune_name: "برج بونعامة",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1258,
    code_postal: "38003",
    ok_postal_code: "38003",
    second_name: "Theniet El Had",
    nom: "Theniet El Had",
    wilaya_id: 38,
    commune_name: "ثنية الاحد",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1259,
    code_postal: "38004",
    ok_postal_code: "38004",
    second_name: "Lazharia",
    nom: "Lazharia",
    wilaya_id: 38,
    commune_name: "الأزهرية",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1260,
    code_postal: "38005",
    ok_postal_code: "38005",
    second_name: "Beni Chaib",
    nom: "Beni Chaib",
    wilaya_id: 38,
    commune_name: "بني شعيب",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:16:40",
  },
  {
    id: 1261,
    code_postal: "38006",
    ok_postal_code: "38006",
    second_name: "Lardjem",
    nom: "Lardjem",
    wilaya_id: 38,
    commune_name: "لرجام",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1262,
    code_postal: "38007",
    ok_postal_code: "38007",
    second_name: "Melaab",
    nom: "Melaab",
    wilaya_id: 38,
    commune_name: "الملعب",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:16:44",
  },
  {
    id: 1263,
    code_postal: "38008",
    ok_postal_code: "38008",
    second_name: "Sidi Lantri",
    nom: "Sidi Lantri",
    wilaya_id: 38,
    commune_name: "سيدي العنتري",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:16:49",
  },
  {
    id: 1264,
    code_postal: "38009",
    ok_postal_code: "38009",
    second_name: "Bordj El Emir Abdelkader",
    nom: "Bordj El Emir Abdelkader",
    wilaya_id: 38,
    commune_name: "برج الأمير عبد القادر",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1265,
    code_postal: "38010",
    ok_postal_code: "38010",
    second_name: "Layoune",
    nom: "Layoune",
    wilaya_id: 38,
    commune_name: "العيون",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1266,
    code_postal: "38011",
    ok_postal_code: "38011",
    second_name: "Khemisti",
    nom: "Khemisti",
    wilaya_id: 38,
    commune_name: "خميستي",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1267,
    code_postal: "38012",
    ok_postal_code: "38012",
    second_name: "Ouled Bessem",
    nom: "Ouled Bessem",
    wilaya_id: 38,
    commune_name: "أولاد بسام",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1268,
    code_postal: "38013",
    ok_postal_code: "38013",
    second_name: "Ammari",
    nom: "Ammari",
    wilaya_id: 38,
    commune_name: "عماري",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1269,
    code_postal: "38014",
    ok_postal_code: "38014",
    second_name: "Youssoufia",
    nom: "Youssoufia",
    wilaya_id: 38,
    commune_name: "اليوسفية",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1270,
    code_postal: "38015",
    ok_postal_code: "38015",
    second_name: "Sidi Boutouchent",
    nom: "Sidi Boutouchent",
    wilaya_id: 38,
    commune_name: "سيدي بوتوشنت",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1271,
    code_postal: "38016",
    ok_postal_code: "38016",
    second_name: "Larbaa",
    nom: "Larbaa",
    wilaya_id: 38,
    commune_name: "الأربعاء",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:16:54",
  },
  {
    id: 1272,
    code_postal: "38017",
    ok_postal_code: "38017",
    second_name: "Maacem",
    nom: "Maasem",
    wilaya_id: 38,
    commune_name: "المعاصم",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:17:00",
  },
  {
    id: 1273,
    code_postal: "38018",
    ok_postal_code: "38018",
    second_name: "Sidi Abed",
    nom: "Sidi Abed",
    wilaya_id: 38,
    commune_name: "سيدي عابد",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1274,
    code_postal: "38019",
    ok_postal_code: "38019",
    second_name: "Tamalaht",
    nom: "Tamalaht",
    wilaya_id: 38,
    commune_name: "تملاحت",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1275,
    code_postal: "38020",
    ok_postal_code: "38020",
    second_name: "Sidi Slimane",
    nom: "Sidi Slimane",
    wilaya_id: 38,
    commune_name: "سيدي سليمان",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1276,
    code_postal: "38021",
    ok_postal_code: "38021",
    second_name: "Boucaid",
    nom: "Boucaid",
    wilaya_id: 38,
    commune_name: "بوقائد",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1277,
    code_postal: "38022",
    ok_postal_code: "38022",
    second_name: "Beni Lahcene",
    nom: "Beni Lahcene",
    wilaya_id: 38,
    commune_name: "بني لحسن",
    wilaya_name: "تيسمسيلت",
    hub_id: 61,
    is_active: 1,
    created_at: null,
    updated_at: "2022-06-27 15:17:04",
  },
  {
    id: 1278,
    code_postal: "39001",
    ok_postal_code: "39001",
    second_name: "El Oued",
    nom: "El Oued",
    wilaya_id: 39,
    commune_name: "الوادي",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1279,
    code_postal: "39002",
    ok_postal_code: "39002",
    second_name: "Robbah",
    nom: "Robbah",
    wilaya_id: 39,
    commune_name: "الرباح",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1280,
    code_postal: "39003",
    ok_postal_code: "39003",
    second_name: "Oued El Alenda",
    nom: "Oued El Alenda",
    wilaya_id: 39,
    commune_name: "وادي العلندة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1281,
    code_postal: "39004",
    ok_postal_code: "39004",
    second_name: "Bayadha",
    nom: "Bayadha",
    wilaya_id: 39,
    commune_name: "البياضة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1282,
    code_postal: "39005",
    ok_postal_code: "39005",
    second_name: "Nakhla",
    nom: "Nakhla",
    wilaya_id: 39,
    commune_name: "النخلة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1283,
    code_postal: "39006",
    ok_postal_code: "39006",
    second_name: "Guemar",
    nom: "Guemar",
    wilaya_id: 39,
    commune_name: "قمار",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1284,
    code_postal: "39007",
    ok_postal_code: "39007",
    second_name: "Kouinine",
    nom: "Kouinine",
    wilaya_id: 39,
    commune_name: "كوينين",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1285,
    code_postal: "39008",
    ok_postal_code: "39008",
    second_name: "Reguiba",
    nom: "Reguiba",
    wilaya_id: 39,
    commune_name: "الرقيبة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1286,
    code_postal: "39009",
    ok_postal_code: "39009",
    second_name: "Hamraia",
    nom: "Hamraia",
    wilaya_id: 39,
    commune_name: "الحمراية",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1287,
    code_postal: "39010",
    ok_postal_code: "39010",
    second_name: "Taghzout",
    nom: "Taghzout",
    wilaya_id: 39,
    commune_name: "تغزوت",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1288,
    code_postal: "39011",
    ok_postal_code: "39011",
    second_name: "Debila",
    nom: "Debila",
    wilaya_id: 39,
    commune_name: "الدبيلة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1289,
    code_postal: "39012",
    ok_postal_code: "39012",
    second_name: "Hassani Abdelkrim",
    nom: "Hassani Abdelkrim",
    wilaya_id: 39,
    commune_name: "حساني عبد الكريم",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1290,
    code_postal: "39013",
    ok_postal_code: "39013",
    second_name: "Hassi Khalifa",
    nom: "Hassi Khelifa",
    wilaya_id: 39,
    commune_name: "حاسي خليفة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1291,
    code_postal: "39014",
    ok_postal_code: "39014",
    second_name: "Taleb Larbi",
    nom: "Taleb Larbi",
    wilaya_id: 39,
    commune_name: "الطالب العربي",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1292,
    code_postal: "39015",
    ok_postal_code: "39015",
    second_name: "Douar El Ma",
    nom: "Douar El Ma",
    wilaya_id: 39,
    commune_name: "دوار الماء",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1293,
    code_postal: "39016",
    ok_postal_code: "39016",
    second_name: "Sidi Aoun",
    nom: "Sidi Aoun",
    wilaya_id: 39,
    commune_name: "سيدي عون",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1294,
    code_postal: "39017",
    ok_postal_code: "39017",
    second_name: "Trifaoui",
    nom: "Trifaoui",
    wilaya_id: 39,
    commune_name: "الطريفاوي",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1295,
    code_postal: "39018",
    ok_postal_code: "39018",
    second_name: "Magrane",
    nom: "Magrane",
    wilaya_id: 39,
    commune_name: "المقرن",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1296,
    code_postal: "39019",
    ok_postal_code: "39019",
    second_name: "Beni Guecha",
    nom: "Beni Guecha",
    wilaya_id: 39,
    commune_name: "بن  قشة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1297,
    code_postal: "39020",
    ok_postal_code: "39020",
    second_name: "Ourmas",
    nom: "Ourmas",
    wilaya_id: 39,
    commune_name: "ورماس",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1302,
    code_postal: "39025",
    ok_postal_code: "39025",
    second_name: "El Ogla",
    nom: "El Ogla",
    wilaya_id: 39,
    commune_name: "العقلة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1303,
    code_postal: "39026",
    ok_postal_code: "39026",
    second_name: "Mih Ouansa",
    nom: "Mih Ouansa",
    wilaya_id: 39,
    commune_name: "اميه وانسة",
    wilaya_name: "الوادي",
    hub_id: 57,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1308,
    code_postal: "40001",
    ok_postal_code: "40001",
    second_name: "Khenchela",
    nom: "Khenchela",
    wilaya_id: 40,
    commune_name: "خنشلة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1309,
    code_postal: "40002",
    ok_postal_code: "40002",
    second_name: "M'Toussa",
    nom: "Mtoussa",
    wilaya_id: 40,
    commune_name: "متوسة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1310,
    code_postal: "40003",
    ok_postal_code: "40003",
    second_name: "Kais",
    nom: "Kais",
    wilaya_id: 40,
    commune_name: "قايس",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1311,
    code_postal: "40004",
    ok_postal_code: "40004",
    second_name: "Baghai",
    nom: "Baghai",
    wilaya_id: 40,
    commune_name: "بغاي",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1312,
    code_postal: "40005",
    ok_postal_code: "40005",
    second_name: "El Hamma",
    nom: "El Hamma",
    wilaya_id: 40,
    commune_name: "الحامة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1313,
    code_postal: "40006",
    ok_postal_code: "40006",
    second_name: "A\u00efn Touila",
    nom: "Ain Touila",
    wilaya_id: 40,
    commune_name: "عين الطويلة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1314,
    code_postal: "40007",
    ok_postal_code: "40007",
    second_name: "Taouzient",
    nom: "Taouzianat",
    wilaya_id: 40,
    commune_name: "تاوزيانت",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1315,
    code_postal: "40008",
    ok_postal_code: "40008",
    second_name: "Bouhmama",
    nom: "Bouhmama",
    wilaya_id: 40,
    commune_name: "بوحمامة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1317,
    code_postal: "40010",
    ok_postal_code: "40010",
    second_name: "Remila",
    nom: "Remila",
    wilaya_id: 40,
    commune_name: "الرميلة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1318,
    code_postal: "40011",
    ok_postal_code: "40011",
    second_name: "Chechar",
    nom: "Cherchar",
    wilaya_id: 40,
    commune_name: "ششار",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1320,
    code_postal: "40013",
    ok_postal_code: "40013",
    second_name: "Babar",
    nom: "Babar",
    wilaya_id: 40,
    commune_name: "بابار",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1322,
    code_postal: "40015",
    ok_postal_code: "40015",
    second_name: "Ensigha",
    nom: "Ensigha",
    wilaya_id: 40,
    commune_name: "انسيغة",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1323,
    code_postal: "40016",
    ok_postal_code: "40016",
    second_name: "Ouled Rechache",
    nom: "Ouled Rechache",
    wilaya_id: 40,
    commune_name: "أولاد رشاش",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1324,
    code_postal: "40017",
    ok_postal_code: "40017",
    second_name: "El Mahmal",
    nom: "El Mahmal",
    wilaya_id: 40,
    commune_name: "المحمل",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1326,
    code_postal: "40019",
    ok_postal_code: "40019",
    second_name: "Yabous",
    nom: "Yabous",
    wilaya_id: 40,
    commune_name: "يابوس",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1328,
    code_postal: "40021",
    ok_postal_code: "40021",
    second_name: "Chelia",
    nom: "Chelia",
    wilaya_id: 40,
    commune_name: "شلية",
    wilaya_name: "خنشلة",
    hub_id: 42,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1329,
    code_postal: "41001",
    ok_postal_code: "41001",
    second_name: "Souk Ahras",
    nom: "Souk Ahras",
    wilaya_id: 41,
    commune_name: "سوق أهراس",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1330,
    code_postal: "41002",
    ok_postal_code: "41002",
    second_name: "Sedrata",
    nom: "Sedrata",
    wilaya_id: 41,
    commune_name: "سدراتة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1331,
    code_postal: "41003",
    ok_postal_code: "41003",
    second_name: "Hanancha",
    nom: "Hanancha",
    wilaya_id: 41,
    commune_name: "الحنانشة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1332,
    code_postal: "41004",
    ok_postal_code: "41004",
    second_name: "Mechroha",
    nom: "Mechroha",
    wilaya_id: 41,
    commune_name: "المشروحة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1333,
    code_postal: "41005",
    ok_postal_code: "41005",
    second_name: "Ouled Driss",
    nom: "Ouled Driss",
    wilaya_id: 41,
    commune_name: "أولاد إدريس",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1334,
    code_postal: "41006",
    ok_postal_code: "41006",
    second_name: "Tiffech",
    nom: "Tiffech",
    wilaya_id: 41,
    commune_name: "تيفاش",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1335,
    code_postal: "41007",
    ok_postal_code: "41007",
    second_name: "Zaarouria",
    nom: "Zaarouria",
    wilaya_id: 41,
    commune_name: "الزعرورية",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1336,
    code_postal: "41008",
    ok_postal_code: "41008",
    second_name: "Taoura",
    nom: "Taoura",
    wilaya_id: 41,
    commune_name: "تاورة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1337,
    code_postal: "41009",
    ok_postal_code: "41009",
    second_name: "Drea",
    nom: "Drea",
    wilaya_id: 41,
    commune_name: "الدريعة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1338,
    code_postal: "41010",
    ok_postal_code: "41010",
    second_name: "Heddada",
    nom: "Haddada",
    wilaya_id: 41,
    commune_name: "الحدادة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1339,
    code_postal: "41011",
    ok_postal_code: "41011",
    second_name: "Khedara",
    nom: "Khedara",
    wilaya_id: 41,
    commune_name: "الخضارة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1340,
    code_postal: "41012",
    ok_postal_code: "41012",
    second_name: "Merahna",
    nom: "Merahna",
    wilaya_id: 41,
    commune_name: "المراهنة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1341,
    code_postal: "41013",
    ok_postal_code: "41013",
    second_name: "Ouled Moumene",
    nom: "Ouled Moumen",
    wilaya_id: 41,
    commune_name: "أولاد مومن",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1342,
    code_postal: "41014",
    ok_postal_code: "41014",
    second_name: "Bir Bou Haouch",
    nom: "Bir Bouhouche",
    wilaya_id: 41,
    commune_name: "بئر بوحوش",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1343,
    code_postal: "41015",
    ok_postal_code: "41015",
    second_name: "M'daourouch",
    nom: "Mdaourouche",
    wilaya_id: 41,
    commune_name: "مداوروش",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1344,
    code_postal: "41016",
    ok_postal_code: "41016",
    second_name: "Oum El Adhaim",
    nom: "Oum El Adhaim",
    wilaya_id: 41,
    commune_name: "أم العظايم",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1345,
    code_postal: "41017",
    ok_postal_code: "41017",
    second_name: "A\u00efn Zana",
    nom: "Ain Zana",
    wilaya_id: 41,
    commune_name: "عين الزانة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1346,
    code_postal: "41018",
    ok_postal_code: "41018",
    second_name: "A\u00efn Soltane",
    nom: "Ain Soltane",
    wilaya_id: 41,
    commune_name: "عين سلطان",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1347,
    code_postal: "41019",
    ok_postal_code: "41019",
    second_name: "Ouillen",
    nom: "Quillen",
    wilaya_id: 41,
    commune_name: "ويلان",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1348,
    code_postal: "41020",
    ok_postal_code: "41020",
    second_name: "Sidi Fredj",
    nom: "Sidi Fredj",
    wilaya_id: 41,
    commune_name: "سيدي فرج",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1349,
    code_postal: "41021",
    ok_postal_code: "41021",
    second_name: "Safel El Ouiden",
    nom: "Safel El Ouiden",
    wilaya_id: 41,
    commune_name: "سافل الويدان",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1350,
    code_postal: "41022",
    ok_postal_code: "41022",
    second_name: "Ragouba",
    nom: "Ragouba",
    wilaya_id: 41,
    commune_name: "الراقوبة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1351,
    code_postal: "41023",
    ok_postal_code: "41023",
    second_name: "Khemissa",
    nom: "Khemissa",
    wilaya_id: 41,
    commune_name: "خميسة",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1352,
    code_postal: "41024",
    ok_postal_code: "41024",
    second_name: "Oued Keberit",
    nom: "Oued Keberit",
    wilaya_id: 41,
    commune_name: "وادي الكبريت",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1353,
    code_postal: "41025",
    ok_postal_code: "41025",
    second_name: "Terraguelt",
    nom: "Terraguelt",
    wilaya_id: 41,
    commune_name: "ترقالت",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1354,
    code_postal: "41026",
    ok_postal_code: "41026",
    second_name: "Zouabi",
    nom: "Zouabi",
    wilaya_id: 41,
    commune_name: "الزوابي",
    wilaya_name: "سوق أهراس",
    hub_id: 53,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1355,
    code_postal: "42001",
    ok_postal_code: "42001",
    second_name: "Tipaza",
    nom: "Tipaza",
    wilaya_id: 42,
    commune_name: "تيبازة",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1356,
    code_postal: "42002",
    ok_postal_code: "42002",
    second_name: "Menaceur",
    nom: "Menaceur",
    wilaya_id: 42,
    commune_name: "مناصر",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1357,
    code_postal: "42003",
    ok_postal_code: "42003",
    second_name: "Larhat",
    nom: "Larhat",
    wilaya_id: 42,
    commune_name: "الأرهاط",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1358,
    code_postal: "42004",
    ok_postal_code: "42004",
    second_name: "Douaouda",
    nom: "Douaouda",
    wilaya_id: 42,
    commune_name: "دواودة",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1359,
    code_postal: "42005",
    ok_postal_code: "42005",
    second_name: "Bourkika",
    nom: "Bourkika",
    wilaya_id: 42,
    commune_name: "بورقيقة",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1360,
    code_postal: "42006",
    ok_postal_code: "42006",
    second_name: "Khemisti",
    nom: "Khemisti",
    wilaya_id: 42,
    commune_name: "خميستي",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1361,
    code_postal: "42010",
    ok_postal_code: "42010",
    second_name: "Aghbal",
    nom: "Aghabal",
    wilaya_id: 42,
    commune_name: "أغبال",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1362,
    code_postal: "42012",
    ok_postal_code: "42012",
    second_name: "Hadjout",
    nom: "Hadjout",
    wilaya_id: 42,
    commune_name: "حجوط",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1363,
    code_postal: "42013",
    ok_postal_code: "42013",
    second_name: "Sidi Amar",
    nom: "Sidi Amar",
    wilaya_id: 42,
    commune_name: "سيدي عامر",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1364,
    code_postal: "42014",
    ok_postal_code: "42014",
    second_name: "Gouraya",
    nom: "Gouraya",
    wilaya_id: 42,
    commune_name: "قوراية",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1365,
    code_postal: "42015",
    ok_postal_code: "42015",
    second_name: "Nador",
    nom: "Nodor",
    wilaya_id: 42,
    commune_name: "الناظور",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1366,
    code_postal: "42016",
    ok_postal_code: "42016",
    second_name: "Chaiba",
    nom: "Chaiba",
    wilaya_id: 42,
    commune_name: "الشعيبة",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1367,
    code_postal: "42017",
    ok_postal_code: "42017",
    second_name: "A\u00efn Tagourait",
    nom: "Ain Tagourait",
    wilaya_id: 42,
    commune_name: "عين تاقورايت",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-20 10:23:22",
  },
  {
    id: 1368,
    code_postal: "42022",
    ok_postal_code: "42022",
    second_name: "Cherchell",
    nom: "Cherchel",
    wilaya_id: 42,
    commune_name: "شرشال",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1369,
    code_postal: "42023",
    ok_postal_code: "42023",
    second_name: "Damous",
    nom: "Damous",
    wilaya_id: 42,
    commune_name: "الداموس",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1370,
    code_postal: "42024",
    ok_postal_code: "42024",
    second_name: "Merad",
    nom: "Meurad",
    wilaya_id: 42,
    commune_name: "مراد",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1371,
    code_postal: "42025",
    ok_postal_code: "42025",
    second_name: "Fouka",
    nom: "Fouka",
    wilaya_id: 42,
    commune_name: "فوكة",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1372,
    code_postal: "42026",
    ok_postal_code: "42026",
    second_name: "Bou Isma\u00efl",
    nom: "Bou Ismail",
    wilaya_id: 42,
    commune_name: "بواسماعيل",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1373,
    code_postal: "42027",
    ok_postal_code: "42027",
    second_name: "Ahmar El A\u00efn",
    nom: "Ahmer El Ain",
    wilaya_id: 42,
    commune_name: "أحمر العين",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1374,
    code_postal: "42030",
    ok_postal_code: "42030",
    second_name: "Bouharoun",
    nom: "Bou Haroun",
    wilaya_id: 42,
    commune_name: "بوهارون",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1375,
    code_postal: "42032",
    ok_postal_code: "42032",
    second_name: "Sidi Ghiles",
    nom: "Sidi Ghiles",
    wilaya_id: 42,
    commune_name: "سيدي غيلاس",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1376,
    code_postal: "42033",
    ok_postal_code: "42033",
    second_name: "Messelmoun",
    nom: "Messelmoun",
    wilaya_id: 42,
    commune_name: "مسلمون",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1377,
    code_postal: "42034",
    ok_postal_code: "42034",
    second_name: "Sidi Rached",
    nom: "Sidi Rached",
    wilaya_id: 42,
    commune_name: "سيدي راشد",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1378,
    code_postal: "42035",
    ok_postal_code: "42035",
    second_name: "Kol\u00e9a",
    nom: "Kolea",
    wilaya_id: 42,
    commune_name: "القليعة",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1379,
    code_postal: "42036",
    ok_postal_code: "42036",
    second_name: "Attatba",
    nom: "Attatba",
    wilaya_id: 42,
    commune_name: "الحطاطبة",
    wilaya_name: "تيبازة",
    hub_id: 99,
    is_active: 1,
    created_at: null,
    updated_at: "2025-12-19 21:56:48",
  },
  {
    id: 1380,
    code_postal: "42040",
    ok_postal_code: "42040",
    second_name: "Sidi Semiane",
    nom: "Sidi Semiane",
    wilaya_id: 42,
    commune_name: "سيدي سميان",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1381,
    code_postal: "42041",
    ok_postal_code: "42041",
    second_name: "Beni Milleuk",
    nom: "Beni Milleuk",
    wilaya_id: 42,
    commune_name: "بني ميلك",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1382,
    code_postal: "42042",
    ok_postal_code: "42042",
    second_name: "Hadjeret Ennous",
    nom: "Hadjerat Ennous",
    wilaya_id: 42,
    commune_name: "حجرة النص",
    wilaya_name: "تيبازة",
    hub_id: 36,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1383,
    code_postal: "43001",
    ok_postal_code: "43001",
    second_name: "Mila",
    nom: "Mila",
    wilaya_id: 43,
    commune_name: "ميلة",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1384,
    code_postal: "43002",
    ok_postal_code: "43002",
    second_name: "Ferdjioua",
    nom: "Ferdjioua",
    wilaya_id: 43,
    commune_name: "فرجيوة",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1385,
    code_postal: "43003",
    ok_postal_code: "43003",
    second_name: "Chelghoum Laid",
    nom: "Chelghoum Laid",
    wilaya_id: 43,
    commune_name: "شلغوم العيد",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:27",
  },
  {
    id: 1386,
    code_postal: "43004",
    ok_postal_code: "43004",
    second_name: "Oued Athmania",
    nom: "Oued Athmenia",
    wilaya_id: 43,
    commune_name: "وادي العثمانية",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:03:26",
  },
  {
    id: 1387,
    code_postal: "43005",
    ok_postal_code: "43005",
    second_name: "A\u00efn Mellouk",
    nom: "Ain Mellouk",
    wilaya_id: 43,
    commune_name: "عين الملوك",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1388,
    code_postal: "43006",
    ok_postal_code: "43006",
    second_name: "Teleghma",
    nom: "Telerghma",
    wilaya_id: 43,
    commune_name: "التلاغمة",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-08-21 23:03:26",
  },
  {
    id: 1389,
    code_postal: "43007",
    ok_postal_code: "43007",
    second_name: "Oued Seguen",
    nom: "Oued Seguen",
    wilaya_id: 43,
    commune_name: "وادي سقان",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-07-28 13:05:26",
  },
  {
    id: 1390,
    code_postal: "43008",
    ok_postal_code: "43008",
    second_name: "Tadjenanet",
    nom: "Tadjenanet",
    wilaya_id: 43,
    commune_name: "تاجنانت",
    wilaya_name: "ميلة",
    hub_id: 90,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:46",
  },
  {
    id: 1391,
    code_postal: "43009",
    ok_postal_code: "43009",
    second_name: "Benyahia Abderrahmane",
    nom: "Benyahia Abderrahmane",
    wilaya_id: 43,
    commune_name: "بن يحي عبد الرحمن",
    wilaya_name: "ميلة",
    hub_id: 90,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:57:39",
  },
  {
    id: 1392,
    code_postal: "43010",
    ok_postal_code: "43010",
    second_name: "Oued Endja",
    nom: "Oued Endja",
    wilaya_id: 43,
    commune_name: "وادي النجاء",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1393,
    code_postal: "43011",
    ok_postal_code: "43011",
    second_name: "Ahmed Rachedi",
    nom: "Ahmed Rachedi",
    wilaya_id: 43,
    commune_name: "أحمد راشدي",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1394,
    code_postal: "43012",
    ok_postal_code: "43012",
    second_name: "Ouled Khalouf",
    nom: "Ouled Khalouf",
    wilaya_id: 43,
    commune_name: "أولاد اخلوف",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-10 12:52:27",
  },
  {
    id: 1395,
    code_postal: "43013",
    ok_postal_code: "43013",
    second_name: "Tiberguent",
    nom: "Tiberguent",
    wilaya_id: 43,
    commune_name: "تيبرقنت",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1396,
    code_postal: "43014",
    ok_postal_code: "43014",
    second_name: "Bouhatem",
    nom: "Bouhatem",
    wilaya_id: 43,
    commune_name: "بوحاتم",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1397,
    code_postal: "43015",
    ok_postal_code: "43015",
    second_name: "Rouached",
    nom: "Rouached",
    wilaya_id: 43,
    commune_name: "الرواشد",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1399,
    code_postal: "43017",
    ok_postal_code: "43017",
    second_name: "Grarem Gouga",
    nom: "Grarem Gouga",
    wilaya_id: 43,
    commune_name: "القرارم قوقة",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1400,
    code_postal: "43018",
    ok_postal_code: "43018",
    second_name: "Sidi Merouane",
    nom: "Sidi Merouane",
    wilaya_id: 43,
    commune_name: "سيدي مروان",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1401,
    code_postal: "43019",
    ok_postal_code: "43019",
    second_name: "Tassadane Haddada",
    nom: "Tassadane Haddada",
    wilaya_id: 43,
    commune_name: "تسدان حدادة",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1402,
    code_postal: "43020",
    ok_postal_code: "43020",
    second_name: "Derradji Bousselah",
    nom: "Derradji Bousselah",
    wilaya_id: 43,
    commune_name: "دراحي بوصلاح",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1403,
    code_postal: "43021",
    ok_postal_code: "43021",
    second_name: "Minar Zarza",
    nom: "Minar Zarza",
    wilaya_id: 43,
    commune_name: "مينار زارزة",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1404,
    code_postal: "43022",
    ok_postal_code: "43022",
    second_name: "Amira Arr\u00e8s",
    nom: "Amira Arras",
    wilaya_id: 43,
    commune_name: "اعميرة اراس",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1405,
    code_postal: "43023",
    ok_postal_code: "43023",
    second_name: "Terrai Bainen",
    nom: "Terrai Bainen",
    wilaya_id: 43,
    commune_name: "ترعي باينان",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1406,
    code_postal: "43024",
    ok_postal_code: "43024",
    second_name: "Hamala",
    nom: "Hamala",
    wilaya_id: 43,
    commune_name: "حمالة",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1407,
    code_postal: "43025",
    ok_postal_code: "43025",
    second_name: "A\u00efn Tine",
    nom: "Ain Tine",
    wilaya_id: 43,
    commune_name: "عين التين",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1408,
    code_postal: "43026",
    ok_postal_code: "43026",
    second_name: "El Mechira",
    nom: "El Mechira",
    wilaya_id: 43,
    commune_name: "مشيرة",
    wilaya_name: "ميلة",
    hub_id: 55,
    is_active: 1,
    created_at: null,
    updated_at: "2026-09-10 12:52:27",
  },
  {
    id: 1409,
    code_postal: "43027",
    ok_postal_code: "43027",
    second_name: "Sidi Khelifa",
    nom: "Sidi Khelifa",
    wilaya_id: 43,
    commune_name: "سيدي خليفة",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1410,
    code_postal: "43028",
    ok_postal_code: "43028",
    second_name: "Zeghaia",
    nom: "Zeghaia",
    wilaya_id: 43,
    commune_name: "زغاية",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1411,
    code_postal: "43029",
    ok_postal_code: "43029",
    second_name: "Elayadi Barbes",
    nom: "Elayadi Barbes",
    wilaya_id: 43,
    commune_name: "العياضي برباس",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1412,
    code_postal: "43030",
    ok_postal_code: "43030",
    second_name: "A\u00efn Beida Harriche",
    nom: "Ain Beida Harriche",
    wilaya_id: 43,
    commune_name: " عين البيضاء أحريش",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1413,
    code_postal: "43031",
    ok_postal_code: "43031",
    second_name: "Yahia Beni Guecha",
    nom: "Yahia Beniguecha",
    wilaya_id: 43,
    commune_name: "يحي بني قشة",
    wilaya_name: "ميلة",
    hub_id: 105,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:54:09",
  },
  {
    id: 1414,
    code_postal: "43032",
    ok_postal_code: "43032",
    second_name: "Chigara",
    nom: "Chigara",
    wilaya_id: 43,
    commune_name: "الشيقارة",
    wilaya_name: "ميلة",
    hub_id: 54,
    is_active: 1,
    created_at: null,
    updated_at: "2026-02-13 23:51:02",
  },
  {
    id: 1415,
    code_postal: "44001",
    ok_postal_code: "44001",
    second_name: "A\u00efn Defla",
    nom: "Ain Defla",
    wilaya_id: 44,
    commune_name: "عين الدفلى",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1416,
    code_postal: "44002",
    ok_postal_code: "44002",
    second_name: "Miliana",
    nom: "Miliana",
    wilaya_id: 44,
    commune_name: "مليانة",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1417,
    code_postal: "44003",
    ok_postal_code: "44003",
    second_name: "Boumedfaa",
    nom: "Boumedfaa",
    wilaya_id: 44,
    commune_name: "بومدفع",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1418,
    code_postal: "44004",
    ok_postal_code: "44004",
    second_name: "Khemis Miliana",
    nom: "Khemis Miliana",
    wilaya_id: 44,
    commune_name: "خميس مليانة",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1419,
    code_postal: "44005",
    ok_postal_code: "44005",
    second_name: "Hammam Righa",
    nom: "Hammam Righa",
    wilaya_id: 44,
    commune_name: "حمام ريغة",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1420,
    code_postal: "44006",
    ok_postal_code: "44006",
    second_name: "Arib",
    nom: "Arib",
    wilaya_id: 44,
    commune_name: "عريب",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1421,
    code_postal: "44007",
    ok_postal_code: "44007",
    second_name: "Djelida",
    nom: "Djelida",
    wilaya_id: 44,
    commune_name: "جليدة",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1422,
    code_postal: "44008",
    ok_postal_code: "44008",
    second_name: "El Amra",
    nom: "El Amra",
    wilaya_id: 44,
    commune_name: "العامرة",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1423,
    code_postal: "44009",
    ok_postal_code: "44009",
    second_name: "Bourached",
    nom: "Bourached",
    wilaya_id: 44,
    commune_name: "بوراشد",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1424,
    code_postal: "44010",
    ok_postal_code: "44010",
    second_name: "El Attaf",
    nom: "El Attaf",
    wilaya_id: 44,
    commune_name: "العطاف",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1425,
    code_postal: "44011",
    ok_postal_code: "44011",
    second_name: "El Abadia",
    nom: "El Abadia",
    wilaya_id: 44,
    commune_name: "العبادية",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1426,
    code_postal: "44012",
    ok_postal_code: "44012",
    second_name: "Djendel",
    nom: "Djendel",
    wilaya_id: 44,
    commune_name: "جندل",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1427,
    code_postal: "44013",
    ok_postal_code: "44013",
    second_name: "Oued Chorfa",
    nom: "Oued Chorfa",
    wilaya_id: 44,
    commune_name: "وادي الشرفاء",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1428,
    code_postal: "44014",
    ok_postal_code: "44014",
    second_name: "A\u00efn Lechiekh",
    nom: "Ain Lechiakh",
    wilaya_id: 44,
    commune_name: "عين الاشياخ",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1429,
    code_postal: "44015",
    ok_postal_code: "44015",
    second_name: "Oued Djemaa",
    nom: "Oued Djemaa",
    wilaya_id: 44,
    commune_name: "واد الجمعة",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1430,
    code_postal: "44016",
    ok_postal_code: "44016",
    second_name: "Rouina",
    nom: "Rouina",
    wilaya_id: 44,
    commune_name: "الروينة",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1431,
    code_postal: "44017",
    ok_postal_code: "44017",
    second_name: "Zeddine",
    nom: "Zeddine",
    wilaya_id: 44,
    commune_name: "زدين",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1432,
    code_postal: "44018",
    ok_postal_code: "44018",
    second_name: "El Hassania",
    nom: "El Hassania",
    wilaya_id: 44,
    commune_name: "الحسانية",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-28 11:51:54",
  },
  {
    id: 1433,
    code_postal: "44019",
    ok_postal_code: "44019",
    second_name: "Bir Ould Khelifa",
    nom: "Bir Ouled Khelifa",
    wilaya_id: 44,
    commune_name: "بئر ولد خليفة",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1434,
    code_postal: "44020",
    ok_postal_code: "44020",
    second_name: "A\u00efn Soltane",
    nom: "Ain Soltane",
    wilaya_id: 44,
    commune_name: "عين السلطان",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1435,
    code_postal: "44021",
    ok_postal_code: "44021",
    second_name: "Tarik Ibn Ziad",
    nom: "Tarik Ibn Ziad",
    wilaya_id: 44,
    commune_name: "طارق بن زياد",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1436,
    code_postal: "44022",
    ok_postal_code: "44022",
    second_name: "Bordj Emir Khaled",
    nom: "Bordj Emir Khaled",
    wilaya_id: 44,
    commune_name: "برج الأمير خالد",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1437,
    code_postal: "44023",
    ok_postal_code: "44023",
    second_name: "A\u00efn Torki",
    nom: "Ain Torki",
    wilaya_id: 44,
    commune_name: "عين التركي",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1438,
    code_postal: "44024",
    ok_postal_code: "44024",
    second_name: "Sidi Lakhdar",
    nom: "Sidi Lakhdar",
    wilaya_id: 44,
    commune_name: "سيدي الأخضر",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1439,
    code_postal: "44025",
    ok_postal_code: "44025",
    second_name: "Ben Allal",
    nom: "Ben Allal",
    wilaya_id: 44,
    commune_name: "بن علال",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1440,
    code_postal: "44026",
    ok_postal_code: "44026",
    second_name: "A\u00efn Benian",
    nom: "Ain Benian",
    wilaya_id: 44,
    commune_name: "عين البنيان",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1441,
    code_postal: "44027",
    ok_postal_code: "44027",
    second_name: "Hoceinia",
    nom: "Hoceinia",
    wilaya_id: 44,
    commune_name: "الحسينية",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-28 11:51:38",
  },
  {
    id: 1442,
    code_postal: "44028",
    ok_postal_code: "44028",
    second_name: "Birbouche",
    nom: "Barbouche",
    wilaya_id: 44,
    commune_name: "بربوش",
    wilaya_name: "عين الدفلة",
    hub_id: 83,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:47:10",
  },
  {
    id: 1443,
    code_postal: "44029",
    ok_postal_code: "44029",
    second_name: "Djemaa Ouled Cheikh",
    nom: "Djemaa Ouled Chikh",
    wilaya_id: 44,
    commune_name: "جمعة أولاد الشيخ",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:41:43",
  },
  {
    id: 1444,
    code_postal: "44030",
    ok_postal_code: "44030",
    second_name: "Mekhatria",
    nom: "Mekhatria",
    wilaya_id: 44,
    commune_name: "المخاطرية",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1445,
    code_postal: "44031",
    ok_postal_code: "44031",
    second_name: "Bathia",
    nom: "Bathia",
    wilaya_id: 44,
    commune_name: "بطحية",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:41:48",
  },
  {
    id: 1446,
    code_postal: "44032",
    ok_postal_code: "44032",
    second_name: "Tacheta Zougagha",
    nom: "Tachta Zegagha",
    wilaya_id: 44,
    commune_name: "تاشتة زقاغة",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:41:54",
  },
  {
    id: 1447,
    code_postal: "44033",
    ok_postal_code: "44033",
    second_name: "A\u00efn Bouyahia",
    nom: "Ain Bouyahia",
    wilaya_id: 44,
    commune_name: "عين بويحيى",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1448,
    code_postal: "44034",
    ok_postal_code: "44034",
    second_name: "El Maine",
    nom: "El Maine",
    wilaya_id: 44,
    commune_name: "الماين",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:42:03",
  },
  {
    id: 1449,
    code_postal: "44035",
    ok_postal_code: "44035",
    second_name: "Tiberkanine",
    nom: "Tiberkanine",
    wilaya_id: 44,
    commune_name: "تبركانين",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1450,
    code_postal: "44036",
    ok_postal_code: "44036",
    second_name: "Belaas",
    nom: "Belaas",
    wilaya_id: 44,
    commune_name: "بلعاص",
    wilaya_name: "عين الدفلة",
    hub_id: 39,
    is_active: 1,
    created_at: null,
    updated_at: "2025-01-24 18:42:07",
  },
  {
    id: 1451,
    code_postal: "45001",
    ok_postal_code: "45001",
    second_name: "Na\u00e2ma",
    nom: "Naama",
    wilaya_id: 45,
    commune_name: "النعامة",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1452,
    code_postal: "45002",
    ok_postal_code: "45002",
    second_name: "Mecheria",
    nom: "Mechria",
    wilaya_id: 45,
    commune_name: "المشرية",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1453,
    code_postal: "45003",
    ok_postal_code: "45003",
    second_name: "A\u00efn Sefra",
    nom: "Ain Sefra",
    wilaya_id: 45,
    commune_name: "عين الصفراء",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1454,
    code_postal: "45004",
    ok_postal_code: "45004",
    second_name: "Tiout",
    nom: "Tiout",
    wilaya_id: 45,
    commune_name: "تيوت",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1455,
    code_postal: "45005",
    ok_postal_code: "45005",
    second_name: "Sfissifa",
    nom: "Sfissifa",
    wilaya_id: 45,
    commune_name: "سفيسيفة",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1456,
    code_postal: "45006",
    ok_postal_code: "45006",
    second_name: "Moghrar",
    nom: "Moghrar",
    wilaya_id: 45,
    commune_name: "مغرار",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1457,
    code_postal: "45007",
    ok_postal_code: "45007",
    second_name: "Assela",
    nom: "Assela",
    wilaya_id: 45,
    commune_name: "عسلة",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1458,
    code_postal: "45008",
    ok_postal_code: "45008",
    second_name: "Djeniene Bourezg",
    nom: "Djeniane Bourzeg",
    wilaya_id: 45,
    commune_name: "جنين بورزق",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1459,
    code_postal: "45009",
    ok_postal_code: "45009",
    second_name: "A\u00efn Ben Khelil",
    nom: "Ain Ben Khelil",
    wilaya_id: 45,
    commune_name: "عين بن خليل",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1460,
    code_postal: "45010",
    ok_postal_code: "45010",
    second_name: "Makman Ben Amer",
    nom: "Makman Ben Amer",
    wilaya_id: 45,
    commune_name: "مكمن بن عمار",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1461,
    code_postal: "45011",
    ok_postal_code: "45011",
    second_name: "Kasdir",
    nom: "Kasdir",
    wilaya_id: 45,
    commune_name: "القصدير",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1462,
    code_postal: "45012",
    ok_postal_code: "45012",
    second_name: "El Biod",
    nom: "El Biod",
    wilaya_id: 45,
    commune_name: "البيوض",
    wilaya_name: "النعامة",
    hub_id: 20,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1463,
    code_postal: "46001",
    ok_postal_code: "46001",
    second_name: "A\u00efn T\u00e9mouchent",
    nom: "Ain Temouchent",
    wilaya_id: 46,
    commune_name: "عين تموشنت",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1464,
    code_postal: "46002",
    ok_postal_code: "46002",
    second_name: "Chaabat El Leham",
    nom: "Chaabet El Ham",
    wilaya_id: 46,
    commune_name: "شعبة اللحم",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:36",
  },
  {
    id: 1465,
    code_postal: "46003",
    ok_postal_code: "46003",
    second_name: "A\u00efn Kihal",
    nom: "Ain Kihal",
    wilaya_id: 46,
    commune_name: "عين الكيحل",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1466,
    code_postal: "46004",
    ok_postal_code: "46004",
    second_name: "Hammam Bouhadjar",
    nom: "Hammam Bouhadjar",
    wilaya_id: 46,
    commune_name: " حمام بوحجر",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1467,
    code_postal: "46005",
    ok_postal_code: "46005",
    second_name: "Bouzedjar",
    nom: "Bou Zedjar",
    wilaya_id: 46,
    commune_name: "بوزجار",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1468,
    code_postal: "46006",
    ok_postal_code: "46006",
    second_name: "Oued Berkeche",
    nom: "Oued Berkeche",
    wilaya_id: 46,
    commune_name: "وادي برقش",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1469,
    code_postal: "46007",
    ok_postal_code: "46007",
    second_name: "Aghlal",
    nom: "Aghlal",
    wilaya_id: 46,
    commune_name: "أغلال",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1470,
    code_postal: "46008",
    ok_postal_code: "46008",
    second_name: "Terga",
    nom: "Terga",
    wilaya_id: 46,
    commune_name: "تارقة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1471,
    code_postal: "46009",
    ok_postal_code: "46009",
    second_name: "A\u00efn El Arbaa",
    nom: "Ain El Arbaa",
    wilaya_id: 46,
    commune_name: "عين الأربعاء",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1472,
    code_postal: "46010",
    ok_postal_code: "46010",
    second_name: "Tamzoura",
    nom: "Tamzoura",
    wilaya_id: 46,
    commune_name: "تامزورة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1473,
    code_postal: "46011",
    ok_postal_code: "46011",
    second_name: "Chentouf",
    nom: "Chentouf",
    wilaya_id: 46,
    commune_name: "شنتوف",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1474,
    code_postal: "46012",
    ok_postal_code: "46012",
    second_name: "Sidi Ben Adda",
    nom: "Sidi Ben Adda",
    wilaya_id: 46,
    commune_name: "سيدي بن عدة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1475,
    code_postal: "46013",
    ok_postal_code: "46013",
    second_name: "Aoubellil",
    nom: "Aoubellil",
    wilaya_id: 46,
    commune_name: "عقب الليل",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1476,
    code_postal: "46014",
    ok_postal_code: "46014",
    second_name: "El Malah",
    nom: "El Malah",
    wilaya_id: 46,
    commune_name: "المالح",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1477,
    code_postal: "46015",
    ok_postal_code: "46015",
    second_name: "Sidi Boumedienne",
    nom: "Sidi Boumediene",
    wilaya_id: 46,
    commune_name: "سيدي بومدين",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1478,
    code_postal: "46016",
    ok_postal_code: "46016",
    second_name: "Oued Sabah",
    nom: "Oued Sabah",
    wilaya_id: 46,
    commune_name: "وادي الصباح",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1479,
    code_postal: "46017",
    ok_postal_code: "46017",
    second_name: "Ouled Boudjemaa",
    nom: "Ouled Boudjemaa",
    wilaya_id: 46,
    commune_name: "أولاد بوجمعة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1480,
    code_postal: "46018",
    ok_postal_code: "46018",
    second_name: "A\u00efn Tolba",
    nom: "Ain Tolba",
    wilaya_id: 46,
    commune_name: "عين الطلبة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1481,
    code_postal: "46019",
    ok_postal_code: "46019",
    second_name: "El Amria",
    nom: "El Amria",
    wilaya_id: 46,
    commune_name: "العامرية",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1482,
    code_postal: "46020",
    ok_postal_code: "46020",
    second_name: "Hassi El Ghella",
    nom: "Hassi El Ghella",
    wilaya_id: 46,
    commune_name: "حاسي الغلة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1483,
    code_postal: "46021",
    ok_postal_code: "46021",
    second_name: "Hassasna",
    nom: "Hassasna",
    wilaya_id: 46,
    commune_name: "الحساسنة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1484,
    code_postal: "46022",
    ok_postal_code: "46022",
    second_name: "Ouled Kihal",
    nom: "Ouled Kihal",
    wilaya_id: 46,
    commune_name: "أولاد الكيحل",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1485,
    code_postal: "46023",
    ok_postal_code: "46023",
    second_name: "Beni Saf",
    nom: "Beni Saf",
    wilaya_id: 46,
    commune_name: "بني صاف",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1486,
    code_postal: "46024",
    ok_postal_code: "46024",
    second_name: "Sidi Safi",
    nom: "Sidi Safi",
    wilaya_id: 46,
    commune_name: "سيدي صافي",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1487,
    code_postal: "46025",
    ok_postal_code: "46025",
    second_name: "Oulha\u00e7a El Gheraba",
    nom: "Oulhaca El Gheraba",
    wilaya_id: 46,
    commune_name: "ولهاصة الغرابة",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1488,
    code_postal: "46026",
    ok_postal_code: "46026",
    second_name: "Sidi Ouriache",
    nom: "Tadmaya",
    wilaya_id: 46,
    commune_name: "سيدي ورياش",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1489,
    code_postal: "46027",
    ok_postal_code: "46027",
    second_name: "El Emir Abdelkader",
    nom: "El Emir Abdelkader",
    wilaya_id: 46,
    commune_name: "الأمير عبد القادر",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1490,
    code_postal: "46028",
    ok_postal_code: "46028",
    second_name: "El Messaid",
    nom: "El Messaid",
    wilaya_id: 46,
    commune_name: "المساعيد",
    wilaya_name: "عين تيموشنت",
    hub_id: 48,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1491,
    code_postal: "47001",
    ok_postal_code: "47001",
    second_name: "Gharda\u00efa",
    nom: "Ghardaia",
    wilaya_id: 47,
    commune_name: "غرداية",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1493,
    code_postal: "47003",
    ok_postal_code: "47003",
    second_name: "Dhayet Bendhahoua",
    nom: "Dhayet Bendhahoua",
    wilaya_id: 47,
    commune_name: "ضاية بن ضحوة",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1494,
    code_postal: "47004",
    ok_postal_code: "47004",
    second_name: "Berriane",
    nom: "Berriane",
    wilaya_id: 47,
    commune_name: "بريان",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1495,
    code_postal: "47005",
    ok_postal_code: "47005",
    second_name: "Metlili",
    nom: "Metlili",
    wilaya_id: 47,
    commune_name: "متليلي",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1496,
    code_postal: "47006",
    ok_postal_code: "47006",
    second_name: "El Guerrara",
    nom: "El Guerrara",
    wilaya_id: 47,
    commune_name: "القرارة",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1497,
    code_postal: "47007",
    ok_postal_code: "47007",
    second_name: "El Atteuf",
    nom: "El Atteuf",
    wilaya_id: 47,
    commune_name: "العطف",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1498,
    code_postal: "47008",
    ok_postal_code: "47008",
    second_name: "Zelfana",
    nom: "Zelfana",
    wilaya_id: 47,
    commune_name: "زلفانة",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1500,
    code_postal: "47010",
    ok_postal_code: "47010",
    second_name: "Bounoura",
    nom: "Bounoura",
    wilaya_id: 47,
    commune_name: "بونورة",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1503,
    code_postal: "47013",
    ok_postal_code: "47013",
    second_name: "Mansoura",
    nom: "Mansoura",
    wilaya_id: 47,
    commune_name: "المنصورة",
    wilaya_name: "غرداية",
    hub_id: 23,
    is_active: 1,
    created_at: null,
    updated_at: "2025-10-13 11:45:22",
  },
  {
    id: 1504,
    code_postal: "48001",
    ok_postal_code: "48001",
    second_name: "Relizane",
    nom: "Relizane",
    wilaya_id: 48,
    commune_name: "غليزان",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1505,
    code_postal: "48002",
    ok_postal_code: "48002",
    second_name: "Oued Rhiou",
    nom: "Oued Rhiou",
    wilaya_id: 48,
    commune_name: "وادي رهيو",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1506,
    code_postal: "48003",
    ok_postal_code: "48003",
    second_name: "Belassel Bouzegza",
    nom: "Belaassel Bouzegza",
    wilaya_id: 48,
    commune_name: "بلعسل بوزقزة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1507,
    code_postal: "48004",
    ok_postal_code: "48004",
    second_name: "Sidi Saada",
    nom: "Sidi Saada",
    wilaya_id: 48,
    commune_name: "سيدي سعادة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1508,
    code_postal: "48005",
    ok_postal_code: "48005",
    second_name: "Ouled Aiche",
    nom: "Ouled Aiche",
    wilaya_id: 48,
    commune_name: "أولاد يعيش",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1509,
    code_postal: "48006",
    ok_postal_code: "48006",
    second_name: "Sidi Lazreg",
    nom: "Sidi Lazreg",
    wilaya_id: 48,
    commune_name: "سيدي لزرق",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:46:57",
  },
  {
    id: 1510,
    code_postal: "48007",
    ok_postal_code: "48007",
    second_name: "El Hamadna",
    nom: "El Hamadna",
    wilaya_id: 48,
    commune_name: "الحمادنة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1511,
    code_postal: "48008",
    ok_postal_code: "48008",
    second_name: "Sidi M'Hamed Ben Ali",
    nom: "Sidi Mhamed Ben Ali",
    wilaya_id: 48,
    commune_name: "سيدي أمحمد بن علي",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1512,
    code_postal: "48009",
    ok_postal_code: "48009",
    second_name: "Mediouna",
    nom: "Mediouna",
    wilaya_id: 48,
    commune_name: "مديونة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1513,
    code_postal: "48010",
    ok_postal_code: "48010",
    second_name: "Sidi Khettab",
    nom: "Sidi Khettab",
    wilaya_id: 48,
    commune_name: "سيدي  خطاب",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:47:42",
  },
  {
    id: 1514,
    code_postal: "48011",
    ok_postal_code: "48011",
    second_name: "Ammi Moussa",
    nom: "Ammi Moussa",
    wilaya_id: 48,
    commune_name: "عمي موسى",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1515,
    code_postal: "48012",
    ok_postal_code: "48012",
    second_name: "Zemmora",
    nom: "Zemmoura",
    wilaya_id: 48,
    commune_name: "زمورة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1516,
    code_postal: "48013",
    ok_postal_code: "48013",
    second_name: "Beni Dergoun",
    nom: "Beni Dergoun",
    wilaya_id: 48,
    commune_name: "بني درقن",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1517,
    code_postal: "48014",
    ok_postal_code: "48014",
    second_name: "Djidioua",
    nom: "Djidiouia",
    wilaya_id: 48,
    commune_name: "جديوية",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1518,
    code_postal: "48015",
    ok_postal_code: "48015",
    second_name: "El Guettar",
    nom: "El Guettar",
    wilaya_id: 48,
    commune_name: "القطار",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1519,
    code_postal: "48016",
    ok_postal_code: "48016",
    second_name: "Hamri",
    nom: "Hamri",
    wilaya_id: 48,
    commune_name: "حمري",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1520,
    code_postal: "48017",
    ok_postal_code: "48017",
    second_name: "El Matmar",
    nom: "El Matmar",
    wilaya_id: 48,
    commune_name: "المطمر",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1521,
    code_postal: "48018",
    ok_postal_code: "48018",
    second_name: "Sidi M'Hamed Benaouda",
    nom: "Sidi Mhamed Ben Aouda",
    wilaya_id: 48,
    commune_name: "سيدي امحمد بن عودة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1522,
    code_postal: "48019",
    ok_postal_code: "48019",
    second_name: "A\u00efn Tarek",
    nom: "Ain Tarek",
    wilaya_id: 48,
    commune_name: "عين طارق",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1523,
    code_postal: "48020",
    ok_postal_code: "48020",
    second_name: "Oued Essalem",
    nom: "Oued Essalem",
    wilaya_id: 48,
    commune_name: "وادي السلام",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:47:48",
  },
  {
    id: 1524,
    code_postal: "48021",
    ok_postal_code: "48021",
    second_name: "Ouarizane",
    nom: "Ouarizane",
    wilaya_id: 48,
    commune_name: "واريزان",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1525,
    code_postal: "48022",
    ok_postal_code: "48022",
    second_name: "Mazouna",
    nom: "Mazouna",
    wilaya_id: 48,
    commune_name: "مازونة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1526,
    code_postal: "48023",
    ok_postal_code: "48023",
    second_name: "Kalaa",
    nom: "Kalaa",
    wilaya_id: 48,
    commune_name: "القلعة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1527,
    code_postal: "48024",
    ok_postal_code: "48024",
    second_name: "A\u00efn Rahma",
    nom: "Ain Rahma",
    wilaya_id: 48,
    commune_name: "عين الرحمة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:47:04",
  },
  {
    id: 1528,
    code_postal: "48025",
    ok_postal_code: "48025",
    second_name: "Yellel",
    nom: "Yellel",
    wilaya_id: 48,
    commune_name: "يلل",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1529,
    code_postal: "48026",
    ok_postal_code: "48026",
    second_name: "Oued El Djemaa",
    nom: "Oued El Djemaa",
    wilaya_id: 48,
    commune_name: "وادي الجمعة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1530,
    code_postal: "48027",
    ok_postal_code: "48027",
    second_name: "Ramka",
    nom: "Ramka",
    wilaya_id: 48,
    commune_name: "الرمكة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:03",
  },
  {
    id: 1531,
    code_postal: "48028",
    ok_postal_code: "48028",
    second_name: "Mendes",
    nom: "Mendes",
    wilaya_id: 48,
    commune_name: "منداس",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:09",
  },
  {
    id: 1532,
    code_postal: "48029",
    ok_postal_code: "48029",
    second_name: "Lahlef",
    nom: "Lahlef",
    wilaya_id: 48,
    commune_name: "لحلاف",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1533,
    code_postal: "48030",
    ok_postal_code: "48030",
    second_name: "Beni Zentis",
    nom: "Beni Zentis",
    wilaya_id: 48,
    commune_name: "بني زنطيس",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:47:56",
  },
  {
    id: 1534,
    code_postal: "48031",
    ok_postal_code: "48031",
    second_name: null,
    nom: "Souk El Haad",
    wilaya_id: 48,
    commune_name: "سوق الحد",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:15",
  },
  {
    id: 1535,
    code_postal: "48032",
    ok_postal_code: "48032",
    second_name: "Dar Ben Abdellah",
    nom: "Dar Ben Abdellah",
    wilaya_id: 48,
    commune_name: "دار بن عبد الله",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:20",
  },
  {
    id: 1536,
    code_postal: "48033",
    ok_postal_code: "48033",
    second_name: "El Hassi",
    nom: "El Hassi",
    wilaya_id: 48,
    commune_name: "الحاسي",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:34",
  },
  {
    id: 1537,
    code_postal: "48034",
    ok_postal_code: "48034",
    second_name: "Had Echkalla",
    nom: "Had Echkalla",
    wilaya_id: 48,
    commune_name: "حد الشكالة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:39",
  },
  {
    id: 1538,
    code_postal: "48035",
    ok_postal_code: "48035",
    second_name: "Bendaoud",
    nom: "Bendaoud",
    wilaya_id: 48,
    commune_name: "بن داود",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1539,
    code_postal: "48036",
    ok_postal_code: "48036",
    second_name: "El Ouldja",
    nom: "El Ouldja",
    wilaya_id: 48,
    commune_name: "الولجة",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:46",
  },
  {
    id: 1540,
    code_postal: "48037",
    ok_postal_code: "48037",
    second_name: "Merdja Sidi Abed",
    nom: "Merdja Sidi Abed",
    wilaya_id: 48,
    commune_name: "مرجة سيدي عابد",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2022-04-21 03:05:38",
  },
  {
    id: 1541,
    code_postal: "48038",
    ok_postal_code: "48038",
    second_name: "Ouled Sidi Mihoub",
    nom: "Ouled Sidi Mihoub",
    wilaya_id: 48,
    commune_name: "أولاد سيدي الميهوب",
    wilaya_name: "غليزان",
    hub_id: 51,
    is_active: 1,
    created_at: null,
    updated_at: "2023-05-09 12:48:26",
  },
  {
    id: 1542,
    code_postal: "49004",
    ok_postal_code: "1003",
    second_name: "Charouine",
    nom: "Charouine",
    wilaya_id: 49,
    commune_name: "شروين",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1545,
    code_postal: "49003",
    ok_postal_code: "1010",
    second_name: "Ouled Sa\u00efd",
    nom: "Ouled Said",
    wilaya_id: 49,
    commune_name: "أولاد السعيد",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1546,
    code_postal: "49000",
    ok_postal_code: "1009",
    second_name: "Timimoun",
    nom: "Timimoun",
    wilaya_id: 49,
    commune_name: "تيميمون",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1547,
    code_postal: "49005",
    ok_postal_code: "1007",
    second_name: "Ksar Kaddour",
    nom: "Ksar Kaddour",
    wilaya_id: 49,
    commune_name: "قصر قدور",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1548,
    code_postal: "49006",
    ok_postal_code: "1016",
    second_name: "Tinerkouk",
    nom: "Tinerkouk",
    wilaya_id: 49,
    commune_name: "تنركوك",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1549,
    code_postal: "49007",
    ok_postal_code: "1017",
    second_name: "Deldoul",
    nom: "Deldoul",
    wilaya_id: 49,
    commune_name: "دلدول",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:05",
  },
  {
    id: 1551,
    code_postal: "49009",
    ok_postal_code: "1023",
    second_name: "Aougrout",
    nom: "Aougrout",
    wilaya_id: 49,
    commune_name: "أوقروت",
    wilaya_name: "تيميمون",
    hub_id: 59,
    is_active: 1,
    created_at: null,
    updated_at: "2024-02-11 09:57:44",
  },
  {
    id: 1554,
    code_postal: "51001",
    ok_postal_code: "42016",
    second_name: "Chaiba",
    nom: "Chaiba",
    wilaya_id: 51,
    commune_name: "الشعيبة",
    wilaya_name: "أولاد جلال",
    hub_id: 77,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-15 17:34:07",
  },
  {
    id: 1555,
    code_postal: "51002",
    ok_postal_code: "7009",
    second_name: "Doucen",
    nom: "Doucen",
    wilaya_id: 51,
    commune_name: "الدوسن",
    wilaya_name: "أولاد جلال",
    hub_id: 77,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-15 17:26:26",
  },
  {
    id: 1556,
    code_postal: "51000",
    ok_postal_code: "7005",
    second_name: "Ouled Djellal",
    nom: "Ouled Djellal",
    wilaya_id: 51,
    commune_name: "أولاد جلال",
    wilaya_name: "أولاد جلال",
    hub_id: 77,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-15 17:26:26",
  },
  {
    id: 1557,
    code_postal: "51003",
    ok_postal_code: "7007",
    second_name: "Besbes",
    nom: "Besbes",
    wilaya_id: 51,
    commune_name: "بسباس",
    wilaya_name: "أولاد جلال",
    hub_id: 77,
    is_active: 1,
    created_at: null,
    updated_at: "2024-11-15 17:26:26",
  },
];
